var lazyLoadInstance = new LazyLoad({});

// Глобальные переменные для предотвращения дублирования запросов
if (typeof isAjaxLoading === 'undefined') {
    var isAjaxLoading = false;
}

// Флаг для предотвращения двойной инициализации фильтров товаров
if (typeof productFiltersInitialized === 'undefined') {
    var productFiltersInitialized = false;
}

// Переменные для debounce таймеров
if (typeof productAjaxFilterTimeout === 'undefined') {
    var productAjaxFilterTimeout = null;
}
if (typeof applyProductFilterTimeout === 'undefined') {
    var applyProductFilterTimeout = null;
}

// Глобальные переменные для обработчиков сортировки
if (typeof sortingClickHandler === 'undefined') {
    var sortingClickHandler = null;
    var sortingChangeHandler = null;
    var sortingOutsideClickHandler = null;
    var sortingIsOpening = false;
}

// ВАЖНО: Инициализация фильтров должна выполняться как можно раньше
// Регистрируем обработчики кликов только на фильтры (с data-filter), чтобы не конфликтовать с другими селектами
(function() {
    'use strict';
    
    // Регистрируем обработчик кликов только на триггеры фильтров
    if (typeof document !== 'undefined' && document.addEventListener) {
        document.addEventListener('click', function(e) {
            try {
                const trigger = e.target.closest('.custom-select__trigger');
                if (!trigger) return;
                
                const customSelect = trigger.closest('.custom-select');
                if (!customSelect) return;
                
                // ВАЖНО: Обрабатываем только фильтры с атрибутом data-filter
                // Это исключает селекты в формах (.shopping .custom-select, .shopping-form .custom-select)
                const hasDataFilter = customSelect.hasAttribute('data-filter');
                if (!hasDataFilter) {
                    // Не фильтр - пропускаем, пусть обрабатывают другие обработчики
                    return;
                }
                
                // Проверяем, не был ли клик по кнопке "Выбрать" или "Сбросить"
                if (e.target.closest('.custom-select__btn--apply') || e.target.closest('.custom-select__btn--reset')) {
                    return;
                }
                
                // Блокируем событие, чтобы другие обработчики не мешали
                e.stopPropagation();
                e.stopImmediatePropagation(); // Полностью блокируем другие обработчики на этом элементе
                
                const dropdown = customSelect.querySelector('.custom-select__dropdown');
                const arrow = customSelect.querySelector('.custom-select__arrow');
                
                if (!dropdown || !arrow) return;

                // Закрываем все другие фильтры (только с data-filter)
                document.querySelectorAll('.custom-select[data-filter] .custom-select__dropdown.active').forEach(dd => {
                    if (dd !== dropdown) {
                        dd.classList.remove('active');
                        const otherCustomSelect = dd.closest('.custom-select[data-filter]');
                        if (otherCustomSelect) {
                            otherCustomSelect.classList.remove('active');
                            const otherTrigger = otherCustomSelect.querySelector('.custom-select__trigger');
                            const otherArrow = otherCustomSelect.querySelector('.custom-select__arrow');
                            if (otherTrigger) otherTrigger.classList.remove('active');
                            if (otherArrow) otherArrow.style.transform = 'rotate(0deg)';
                        }
                    }
                });

                // Переключаем текущий селект
                // Проверяем состояние по классу active на dropdown
                const isActive = dropdown.classList.contains('active');
                
                // Переключаем состояние
                if (isActive) {
                    // Закрываем селект - удаляем все классы активности и сбрасываем стрелочку
                    dropdown.classList.remove('active');
                    customSelect.classList.remove('active');
                    trigger.classList.remove('active');
                    arrow.style.transform = 'rotate(0deg)';
                } else {
                    // Открываем селект - добавляем все классы активности и переворачиваем стрелочку
                    dropdown.classList.add('active');
                    customSelect.classList.add('active');
                    trigger.classList.add('active');
                    arrow.style.transform = 'rotate(180deg)';
                }
                
            } catch (error) {
                console.error('❌ Ошибка при открытии фильтра:', error);
            }
        }, true); // Используем capture phase, чтобы обрабатывать клики раньше других обработчиков
    }
})();

/**
 * @function getCoords
 * @description Координаты элемента
 *
 * @param {HTMLElement} elem - проверяемый элемент
 */
function getCoords(elem) {

    let box = elem.getBoundingClientRect();
    return {
        top:box.top + window.scrollY,
        right:box.right + window.scrollX,
        bottom:box.bottom + window.scrollY,
        left:box.left + window.scrollX,
        height:box.height,
    };
}

/**
 * @function isOnScreen
 * @description Эта функция проверяет, находится ли заданный элемент в данный момент в видимой области окна веб-страницы.
 *
 * @param {HTMLElement} elem - проверяемый элемент
 * @param {number|null} coefficientDesktop - Число, которое регулирует точку срабатывания функции на настольных устройствах. Чем выше значение, тем дальше от области просмотра будет считаться, что элемент "на экране".
 * @param {number|null} coefficientMobile - Число, которое регулирует точку срабатывания функции на мобильных устройствах. Чем выше значение, тем дальше от области просмотра будет считаться, что элемент "на экране".
 *
 */
function isOnScreen(elem, coefficientDesktop = null, coefficientMobile = null) {
    // Если коэффициенты не предоставлены, используем значения по умолчанию
    if (coefficientDesktop === null && coefficientMobile === null) {
        let coefficient;
        // Используем более высокий коэффициент (0.75) для мобильных устройств
        window.innerWidth <= 768 ? coefficient = 0.75 : coefficient = 0.3;
        return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficient);
    } else {
        // Используем предоставленные коэффициенты
        if (window.innerWidth <= 768) {
            return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficientMobile);
        } else {
            return window.scrollY > (getCoords(elem).top - window.innerHeight / coefficientDesktop);
        }
    }
}

/**
 * @function isMobile
 * @description Проверка ширины устройства (мобильный или десктоп)
 */
function isMobile() {

    return window.outerWidth <= 768;
}

/**
 * @function isExist
 * @description Проверка наличия элемента на странице
 *
 * @param {string} selector - проверяемый элемент
 */
function isExist(selector) {

    return document.querySelector( selector );
}

/**
 * @function isHome
 * @description Проверка, является ли текущая страница главной
 */
function isHome() {

    return isExist( '.home' );
}

/**
 * @function setCookie
 * @description Устанавливает cookie с указанным именем, значением и сроком действия
 *
 * @param {string} name - имя cookie
 * @param {string} value - значение cookie
 * @param {number} days - количество дней до истечения срока действия (опционально)
 */
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
/**
 * @function getCookie
 * @description Получает значение cookie по его имени
 *
 * @param {string} name - имя cookie
 * @returns {string|null} значение cookie или null, если cookie не найден
 */
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
/**
 * @function eraseCookie
 * @description Удаляет cookie с указанным именем
 *
 * @param {string} name - имя cookie для удаления
 */
function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function openMenu(selector) {
    selector.classList.add('active');
    document.body.classList.add('menu-open');
    document.body.style.overflow = 'clip';
}

function closeMenu(selector) {
    selector.classList.remove('active');
    document.body.classList.remove('menu-open');
    document.body.style.overflow = '';
}

function openSearch(selector) {
    selector.classList.add('search-active');
    document.body.classList.add('search-open');
    document.body.style.overflow = 'clip';
}

function closeSearch(selector) {
    selector.classList.remove('search-active');
    document.body.classList.remove('search-open');
    document.body.style.overflow = '';
}

function openMobileFilters(selector) {
    selector.classList.add('active');
    document.body.classList.add('mobileFilters-active');
    document.body.style.overflow = 'clip';
}

function closeMobileFilters(selector) {
    selector.classList.remove('active');
    document.body.classList.remove('mobileFilters-active');
    document.body.style.overflow = '';
}

function forceChangeLocation(location){
    window.location.href = location;
}

/**
 * @function addToFavorites
 * @description Добавляет пост в избранное, сохраняя его ID и тип в cookies
 *
 * @param {string|number} post_id - ID поста
 * @param {string} post_type - тип поста (например, 'look', 'post', 'product')
 * @returns {boolean} true если пост успешно добавлен, false если уже в избранном
 */
function addToFavorites(post_id, post_type) {
    const favorites = getFavorites();
    const favoriteKey = `${post_type}_${post_id}`;

    // Проверяем, не добавлен ли уже этот пост
    if (favorites.includes(favoriteKey)) {
        return false;
    }

    // Добавляем пост в избранное
    favorites.push(favoriteKey);
    setCookie('favorites', JSON.stringify(favorites), 365); // Храним год

    // Обновляем счетчик в шапке
    if (typeof updateFavoritesCounter === 'function') {
        updateFavoritesCounter();
    }

    return true;
}

/**
 * @function removeFromFavorites
 * @description Удаляет пост из избранного
 *
 * @param {string|number} post_id - ID поста
 * @param {string} post_type - тип поста
 * @returns {boolean} true если пост успешно удален, false если не был в избранном
 */
function removeFromFavorites(post_id, post_type) {
    const favorites = getFavorites();
    const favoriteKey = `${post_type}_${post_id}`;
    const index = favorites.indexOf(favoriteKey);

    if (index === -1) {
        return false;
    }

    favorites.splice(index, 1);
    setCookie('favorites', JSON.stringify(favorites), 365);

    // Обновляем счетчик в шапке
    if (typeof updateFavoritesCounter === 'function') {
        updateFavoritesCounter();
    }

    return true;
}

/**
 * @function isInFavorites
 * @description Проверяет, находится ли пост в избранном
 *
 * @param {string|number} post_id - ID поста
 * @param {string} post_type - тип поста
 * @returns {boolean} true если пост в избранном, false если нет
 */
function isInFavorites(post_id, post_type) {
    const favorites = getFavorites();
    const favoriteKey = `${post_type}_${post_id}`;

    return favorites.includes(favoriteKey);
}

/**
 * @function getFavorites
 * @description Получает список всех избранных постов
 *
 * @returns {Array} массив строк с ключами избранных постов
 */
function getFavorites() {
    const favoritesCookie = getCookie('favorites');

    if (!favoritesCookie) {
        return [];
    }

    try {
        return JSON.parse(favoritesCookie);
    } catch (e) {
        console.error('Ошибка при парсинге избранных постов:', e);
        return [];
    }
}

/**
 * @function toggleFavorite
 * @description Переключает состояние поста в избранном (добавляет/удаляет)
 *
 * @param {string|number} post_id - ID поста
 * @param {string} post_type - тип поста
 * @returns {boolean} true если пост добавлен в избранное, false если удален
 */
function toggleFavorite(post_id, post_type) {
    if (isInFavorites(post_id, post_type)) {
        removeFromFavorites(post_id, post_type);
        return false;
    } else {
        addToFavorites(post_id, post_type);
        return true;
    }
}

/**
 * @function clearAllFavorites
 * @description Очищает все избранные посты
 */
function clearAllFavorites() {
    eraseCookie('favorites');

    // Обновляем счетчик в шапке
    if (typeof updateFavoritesCounter === 'function') {
        updateFavoritesCounter();
    }
}

/**
 * @function getFavoritesByType
 * @description Получает избранные посты определенного типа
 *
 * @param {string} post_type - тип поста для фильтрации
 * @returns {Array} массив ID постов указанного типа
 */
function getFavoritesByType(post_type) {
    const favorites = getFavorites();
    const typePrefix = `${post_type}_`;

    return favorites
        .filter(favorite => favorite.startsWith(typePrefix))
        .map(favorite => favorite.replace(typePrefix, ''));
}

/**
 * @function updateFavoritesCounter
 * @description Обновляет счетчик избранных постов в шапке сайта
 */
function updateFavoritesCounter() {
    const counterElement = document.querySelector('.tool__favorite .counter');
    if (counterElement) {
        const favorites = getFavorites();
        const count = favorites.length;
        const oldCount = parseInt(counterElement.textContent) || 0;

        // Обновляем текст счетчика
        counterElement.textContent = count;

        // Добавляем/убираем класс для анимации
        if (count > 0) {
            counterElement.parentElement.classList.add('has-favorites');
            counterElement.classList.add('show');
        } else {
            counterElement.parentElement.classList.remove('has-favorites');
            counterElement.classList.remove('show');
        }

        // Анимация изменения числа
        if (count !== oldCount) {
            counterElement.style.transform = 'scale(1.2)';
            setTimeout(() => {
                counterElement.style.transform = 'scale(1)';
            }, 150);
        }
    }
}

/**
 * @function initFavoritesCounter
 * @description Инициализирует счетчик избранных при загрузке страницы
 */
function initFavoritesCounter() {
    updateFavoritesCounter();
}

/**
 * @function watchFavoritesCookie
 * @description Отслеживает изменения куки избранных постов и обновляет счетчик
 */
function watchFavoritesCookie() {
    let lastFavoritesValue = getCookie('favorites');

    // Проверяем изменения куки каждые 200мс (более эффективно)
    setInterval(() => {
        const currentFavoritesValue = getCookie('favorites');

        if (currentFavoritesValue !== lastFavoritesValue) {
            lastFavoritesValue = currentFavoritesValue;
            updateFavoritesCounter();

            // Диспетчим кастомное событие для других частей приложения
            window.dispatchEvent(new CustomEvent('favoritesChanged', {
                detail: {
                    favorites: getFavorites(),
                    count: getFavorites().length
                }
            }));
        }
    }, 200);
}

/**
 * @function getFavoritesCount
 * @description Получает количество избранных постов
 * @returns {number} количество избранных постов
 */
function getFavoritesCount() {
    return getFavorites().length;
}

/**
 * @function setupFavoritesSystem
 * @description Настраивает всю систему избранных постов
 */
function setupFavoritesSystem() {
    // Инициализируем счетчик при загрузке
    initFavoritesCounter();

    // Запускаем отслеживание изменений куки
    watchFavoritesCookie();

    // Также обновляем счетчик при клике на кнопки избранного
    document.addEventListener('click', (e) => {
        if (e.target.closest('.tool-favorite')) {
            // Небольшая задержка, чтобы куки успели обновиться
            setTimeout(() => {
                updateFavoritesCounter();
            }, 50);
        }
    });

    // Слушаем кастомные события изменения избранного
    window.addEventListener('favoritesChanged', (e) => {
    });
}

/**
 * @function initCategoryFiltering
 * @description Инициализирует систему фильтрации по категориям
 */
function initCategoryFiltering() {
    
    // Проверяем, есть ли уже выбранная категория в URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentCategory = urlParams.get('category');

    // НЕ устанавливаем категорию по умолчанию автоматически - это может вызывать конфликты
    // if (!currentCategory) {
    //     setDefaultCategory();
    // }

    // Устанавливаем data-termslug для категорий на главной странице, если они пустые
    function setCategoryDataTerms() {
        const categories = document.querySelectorAll('.catalog__category');
        categories.forEach(category => {
            if (!category.getAttribute('data-termslug')) {
                const text = category.textContent.trim().toLowerCase();
                if (text.includes('женщин') || text.includes('women')) {
                    category.setAttribute('data-termslug', 'zhenshhiny');
                } else if (text.includes('мужчин') || text.includes('men')) {
                    category.setAttribute('data-termslug', 'muzhchiny');
                } else if (text.includes('дет') || text.includes('child')) {
                    category.setAttribute('data-termslug', 'deti');
                }
            }
        });
    }

    // Выполняем сразу и при загрузке DOM
    setCategoryDataTerms();
    document.addEventListener('DOMContentLoaded', setCategoryDataTerms);

    // Обработчик кликов по фильтрам категорий
    document.addEventListener('click', (e) => {
        if (e.target.closest('.catalog__category')) {
            e.preventDefault();
            
            // Защита от множественных кликов
            if (window.categoryClickInProgress) {
                
                return;
            }
            
            // Защита от выполнения запросов при сбросе фильтров
            if (window.isClearingFilters) {
                return;
            }
            
            const filterElement = e.target.closest('.catalog__category');
            const categorySlug = filterElement.dataset.termslug;

            if (categorySlug) {
                
                // Проверяем, является ли это родительской категорией (Женщины, Мужчины, Дети)
                const parentCategories = ['zhenshhiny', 'muzhchiny', 'deti'];
                if (parentCategories.includes(categorySlug)) {
                    // Проверяем, действительно ли меняется родительская категория
                    // Обновляем urlParams для получения актуального состояния URL
                    const currentUrlParams = new URLSearchParams(window.location.search);
                    const currentCategory = currentUrlParams.get('category');
                    
                    
                    if (currentCategory !== categorySlug) {
                        
                        // Устанавливаем флаг обработки клика
                        window.categoryClickInProgress = true;
                        // Обновляем фильтры для новой родительской категории
                        updateFiltersForParentCategory(categorySlug);
                        // НЕ вызываем filterByCategory здесь, так как updateFiltersForParentCategory уже обновит товары
                    } else {
                        
                        // Если это та же родительская категория, просто обновляем активный фильтр
                        updateActiveFilter(categorySlug);
                    }
                } else {
                    
                    // Для подкатегорий просто фильтруем
                    filterByCategory(categorySlug);
                }
            }
        }
    });

    // Обработчик кнопки "Сбросить фильтры"
    document.addEventListener('click', (e) => {
        
        if (e.target.closest('.clear-params') || (e.target.classList.contains('text-btn') && e.target.closest('.clear-params'))) {
            
            e.preventDefault();
            e.stopPropagation();
            
            // Защита от множественных вызовов
            if (window.isClearingFilters) {
                return;
            }
            
            clearAllFilters();
        }
    });

    // Обработчик клика по триггерам кастомных селектов
    // УДАЛЕНО: Дублирующий обработчик - уже есть в начале файла (строки 18-72)
    // Обработчик в начале файла обрабатывает все фильтры с data-filter атрибутом
    // Этот обработчик оставлен для обратной совместимости, но теперь он проверяет,
    // не обработан ли уже клик обработчиком в начале файла

    // Обработчик клика по кнопкам "Выбрать"
    document.addEventListener('click', (e) => {
        if (e.target.closest('.custom-select__btn--apply')) {
            e.preventDefault();
            const button = e.target.closest('.custom-select__btn--apply');
            const customSelect = button.closest('.custom-select');
            const filterName = customSelect.getAttribute('data-filter');
            const optionsContainer = customSelect.querySelector('.custom-select__options');
            
            // Ищем все выбранные элементы (и чекбоксы, и радиокнопки)
            const checkboxes = optionsContainer.querySelectorAll('input[type="checkbox"]:checked');
            const radioButtons = optionsContainer.querySelectorAll('input[type="radio"]:checked');
            const allChecked = [...checkboxes, ...radioButtons];

            if (allChecked.length > 0) {
                // Получаем выбранные значения
                const selectedValues = Array.from(allChecked).map(cb => cb.value);
                const selectedLabels = Array.from(allChecked).map(cb => {
                    const label = cb.nextElementSibling;
                    return label ? label.textContent : '';
                });

                // Обновляем текст триггера
                const valueElement = customSelect.querySelector('.custom-select__value');
                const triggerElement = customSelect.querySelector('.custom-select__trigger');
                if (valueElement && triggerElement) {
                    // Определяем название фильтра
                    const filterLabel = filterName.replace('_filter', '');
                    const labelMap = {
                        'brand': 'Бренд',
                        'style': 'Стиль',
                        'color': 'Цвет',
                        'stylist': 'Стилист'
                    };
                    
                    if (selectedLabels.length === 1) {
                        // Для одного выбранного элемента показываем название фильтра с количеством
                        valueElement.textContent = `${labelMap[filterLabel]} (1)`;
                    } else {
                        // Для нескольких выбранных элементов показываем количество
                        valueElement.textContent = `${labelMap[filterLabel]} (${selectedLabels.length})`;
                    }
                    // Добавляем класс для активного фильтра
                    triggerElement.classList.add('has-selection');
                }

                // Применяем фильтр
                let filterValue;
                if ((filterName === 'stylist_filter' || filterName === 'brand_filter' || filterName === 'color_filter' || filterName === 'style_filter') && selectedValues.length > 1) {
                    // Для стилистов, брендов, цветов и стилей передаем все выбранные значения через запятую
                    filterValue = selectedValues.join(',');
                } else {
                    // Для остальных фильтров берем только первое значение
                    filterValue = selectedValues[0];
                }

                // Определяем, на какой странице мы находимся
                if (isExist('.catalog-list') && isExist('.products-grid')) {
                    // Для страниц товаров используем applyProductFilter
                    applyProductFilter(filterName);
                } else {
                    // Для страниц образов используем applyFilter
                    applyFilter(filterName, filterValue);
                }
            } else {
                // Если ничего не выбрано, сбрасываем фильтр
                if (isExist('.catalog-list') && isExist('.products-grid')) {
                    // Для страниц товаров сбрасываем URL параметр и обновляем товары
                    const urlParamName = 'filter' + filterName.replace('_filter', '').charAt(0).toUpperCase() + filterName.replace('_filter', '').slice(1);
                    updateUrlParameter(urlParamName, '');
                    // НЕ вызываем performProductAjaxFilter() здесь - applyProductFilter() уже это делает
                    // if (typeof performProductAjaxFilter === 'function') {
                    //     performProductAjaxFilter();
                    // }
                } else {
                    // Для страниц образов используем removeFilter
                    removeFilter(filterName);
                }
            }

            // Закрываем селект в любом случае с небольшой задержкой
            
            setTimeout(() => {
                const dropdown = customSelect.querySelector('.custom-select__dropdown');
                const triggerElement = customSelect.querySelector('.custom-select__trigger');
                const arrow = customSelect.querySelector('.custom-select__arrow');

                if (dropdown) {
                    dropdown.classList.remove('active');
                    
                }
                if (customSelect) {
                    customSelect.classList.remove('active');
                    
                }
                if (triggerElement) {
                    triggerElement.classList.remove('active');
                    
                }
                if (arrow) {
                    arrow.style.transform = 'rotate(0deg)';
                    
                }

                
            }, 10); // Небольшая задержка в 10мс
        }
    });

    // Обработчик клика по кнопкам "Сбросить фильтр"
    document.addEventListener('click', (e) => {
        if (e.target.closest('.custom-select__btn--reset')) {
            e.preventDefault();
            const button = e.target.closest('.custom-select__btn--reset');
            const customSelect = button.closest('.custom-select');
            const filterName = customSelect.getAttribute('data-filter');
            const optionsContainer = customSelect.querySelector('.custom-select__options');
            const checkboxes = optionsContainer.querySelectorAll('input[type="checkbox"]');


            // Снимаем все чекбоксы и убираем классы активности
            checkboxes.forEach(cb => {
                cb.checked = false;
                // Убираем классы визуального выделения
                cb.classList.remove('selected', 'checked', 'active', 'is-checked');
                
                // Убираем классы с родительского label
                const parentLabel = cb.closest('label');
                if (parentLabel) {
                    parentLabel.classList.remove('selected', 'checked', 'active', 'is-checked');
                }
            });

            // Сбрасываем текст триггера
            const valueElement = customSelect.querySelector('.custom-select__value');
            const triggerElement = customSelect.querySelector('.custom-select__trigger');
            if (valueElement && triggerElement) {
                const filterLabel = filterName.replace('_filter', '');
                const labelMap = {
                    'brand': 'Бренд',
                    'style': 'Стиль',
                    'color': 'Цвет',
                    'stylist': 'Стилист'
                };
                // Подсчитываем количество доступных опций
                const optionsContainer = customSelect.querySelector('.custom-select__options');
                const totalOptions = optionsContainer ? optionsContainer.querySelectorAll('.custom-select__option').length : 0;

                valueElement.textContent = `${labelMap[filterLabel]} (${totalOptions})`;
                // Убираем класс для активного фильтра
                triggerElement.classList.remove('has-selection');
            }

            // Удаляем фильтр
            removeFilter(filterName);

            // Закрываем селект
            const dropdown = customSelect.querySelector('.custom-select__dropdown');
            const arrow = customSelect.querySelector('.custom-select__arrow');
            dropdown.classList.remove('active');
            customSelect.classList.remove('active');
            triggerElement.classList.remove('active');
            arrow.style.transform = 'rotate(0deg)';
        }
    });

    // Закрытие селектов при клике вне их
    // ИСКЛЮЧАЕМ селект сортировки (data-sort="price") - у него свой обработчик
    document.addEventListener('click', (e) => {
        // Пропускаем клики по селекту сортировки
        if (e.target.closest('.custom-select[data-sort="price"]')) {
            return;
        }
        
        // Пропускаем клики по триггеру фильтров - их обрабатывает другой обработчик
        if (e.target.closest('.custom-select__trigger')) {
            const customSelect = e.target.closest('.custom-select');
            if (customSelect && customSelect.hasAttribute('data-filter')) {
                return; // Пропускаем, пусть обрабатывает основной обработчик
            }
        }
        
        // Закрываем селекты только если клик был вне всех селектов
        if (!e.target.closest('.custom-select')) {
            document.querySelectorAll('.custom-select__dropdown.active').forEach(dropdown => {
                // Пропускаем селект сортировки
                const customSelect = dropdown.closest('.custom-select');
                if (customSelect && customSelect.hasAttribute('data-sort')) {
                    return;
                }
                
                dropdown.classList.remove('active');
                if (customSelect) {
                    customSelect.classList.remove('active');
                    const trigger = customSelect.querySelector('.custom-select__trigger');
                    const arrow = customSelect.querySelector('.custom-select__arrow');
                    if (trigger) trigger.classList.remove('active');
                    if (arrow) arrow.style.transform = 'rotate(0deg)';
                }
            });
        }
    });

    // Загружаем данные фильтров при инициализации только если есть соответствующие элементы
    if (isExist('.catalog-list') || isExist('.products-grid')) {
        if (isExist('.catalog-list') && isExist('.products-grid')) {
            // Для страниц товаров НЕ загружаем данные здесь - это будет сделано в initProductFilters()
            // Это предотвращает двойную инициализацию
            // loadFilterData().then(() => {
            //     if (typeof initProductUrlParameters === 'function') {
            //         initProductUrlParameters();
            //     }
            // }).catch(error => {
            //     console.error('Error loading filter data:', error);
            // });
        } else if (isExist('.catalog-list')) {
            
            loadLookFilterData().then(() => {
                // Небольшая задержка, чтобы селекты успели заполниться
                setTimeout(() => {
                    if (typeof initUrlParameters === 'function') {
                        initUrlParameters();
                    }
                }, 100);
            }).catch(error => {
                console.error('❌ Error loading look filter data:', error);
            });
        }
    }
}

// Вызываем инициализацию фильтрации сразу при загрузке скрипта (независимо от других скриптов)
(function() {
    'use strict';
    
    function initFilters() {
        try {
            if (typeof initCategoryFiltering === 'function') {
                initCategoryFiltering();
            } else {
                // Пытаемся вызвать позже, если функция ещё не определена
                setTimeout(function() {
                    if (typeof initCategoryFiltering === 'function') {
                        initCategoryFiltering();
                    }
                }, 100);
            }
        } catch (error) {
            console.error('❌ Ошибка при инициализации фильтров:', error);
        }
    }
    
    // Пытаемся вызвать сразу, если DOM доступен
    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            // DOM ещё загружается
            if (document.addEventListener) {
                document.addEventListener('DOMContentLoaded', initFilters, false);
            }
        } else {
            // DOM уже загружен
            setTimeout(initFilters, 0);
        }
    } else {
        // document ещё не доступен, пытаемся позже
        setTimeout(initFilters, 100);
    }
})();

/**
 * @function filterByCategory
 * @description Фильтрует записи по категории через AJAX
 * @param {string} categorySlug - slug категории для фильтрации
 */
function filterByCategory(categorySlug) {
    // Обновляем активный фильтр
    updateActiveFilter(categorySlug);

    // Определяем тип страницы и используем соответствующий AJAX
    if (isExist('.catalog-list') && isExist('.products-grid')) {
        // Для страниц товаров (есть и catalog-list и products-grid)
        // Сбрасываем состояние кнопки "Загрузить еще" при смене категории
        resetLoadMoreButtonState();
        updateProductUrlParameter('category', categorySlug);
        performProductAjaxFilter();
    } else {
        // Для страниц образов (есть catalog-list но нет products-grid)
        // Сохраняем параметр сортировки перед обновлением категории
        const urlParamsBefore = new URLSearchParams(window.location.search);
        const orderbyValue = urlParamsBefore.get('orderby');
        
        // Обновляем категорию в URL
        updateUrlParameter('category', categorySlug);
        
        // Восстанавливаем параметр сортировки в URL, если он был
        if (orderbyValue && orderbyValue !== 'default') {
            updateUrlParameter('orderby', orderbyValue);
        }

        // Собираем все активные фильтры и добавляем новую категорию
        const filterData = getAllActiveFilters();
        // Убеждаемся, что категория передается правильно
        filterData.look_category_slug = categorySlug;
        
        // Убеждаемся, что параметр сортировки передается из URL
        const urlParamsAfter = new URLSearchParams(window.location.search);
        const orderbyValueAfter = urlParamsAfter.get('orderby');
        if (orderbyValueAfter && orderbyValueAfter !== 'default') {
            filterData['orderby'] = orderbyValueAfter;
        }

        // Логируем для отладки
        console.log('🔍 filterByCategory - orderbyValue:', orderbyValue, 'orderbyValueAfter:', orderbyValueAfter, 'filterData:', filterData);

        // Выполняем AJAX запрос для образов
        performAjaxFilter(filterData);
    }
}

/**
 * @function clearAllFilters
 * @description Сбрасывает все фильтры
 */
function clearAllFilters() {

    // Устанавливаем флаг, что мы сбрасываем фильтры
    window.isClearingFilters = true;

    // Определяем тип страницы для правильного сброса фильтров
    const isProductPage = isExist('.catalog-list') && isExist('.products-grid');

    if (isProductPage) {
        // Для страниц товаров сбрасываем товарные фильтры
        const productFilterNames = ['clothing_filter', 'shoes_filter', 'accessories_filter', 'product_brand_filter'];
        productFilterNames.forEach(filterName => {
            const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
            if (customSelect) {
                // Снимаем все чекбоксы и радиокнопки
                const inputs = customSelect.querySelectorAll('input[type="checkbox"], input[type="radio"]');
                inputs.forEach(input => input.checked = false);

                // Сбрасываем текст триггера
                const valueElement = customSelect.querySelector('.custom-select__value');
                const triggerElement = customSelect.querySelector('.custom-select__trigger');
                if (valueElement && triggerElement) {
                    const filterLabel = filterName.replace('_filter', '');
                    const labelMap = {
                        'clothing': 'Одежда',
                        'shoes': 'Обувь',
                        'accessories': 'Аксессуары',
                        'product_brand': 'Бренд'
                    };

                    // Для подкатегорий товаров (радиокнопки) не показываем счетчики
                    const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');

                    if (isCategoryFilter) {
                        // Для подкатегорий товаров показываем только название без счетчика
                        valueElement.textContent = labelMap[filterLabel];
                    } else {
                        // Для остальных фильтров показываем счетчик
                        const optionsContainer = customSelect.querySelector('.custom-select__options');
                        const totalOptions = optionsContainer ? optionsContainer.querySelectorAll('.custom-select__option').length : 0;
                        valueElement.textContent = `${labelMap[filterLabel]} (${totalOptions})`;
                    }

                    // Убираем классы для активного фильтра
                    triggerElement.classList.remove('has-selection');
                    customSelect.classList.remove('filtered');

                    // Сбрасываем заголовок селекта на дефолтное состояние
                    resetSelectHeader(customSelect, filterName);
                }
            }
        });
    } else {
        // Для страниц образов сбрасываем фильтры образов
        const lookFilterNames = ['brand_filter', 'style_filter', 'color_filter', 'stylist_filter'];
        lookFilterNames.forEach(filterName => {
            const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
            if (customSelect) {
                // Снимаем все чекбоксы и радиокнопки
                const inputs = customSelect.querySelectorAll('input[type="checkbox"], input[type="radio"]');
                inputs.forEach(input => input.checked = false);

                // Для фильтров образов убираем классы и сбрасываем к дефолтному состоянию
                const valueElement = customSelect.querySelector('.custom-select__value');
                const triggerElement = customSelect.querySelector('.custom-select__trigger');
                if (valueElement && triggerElement) {
                    // Сбрасываем текст к дефолтному состоянию из HTML
                    const filterLabel = filterName.replace('_filter', '');
                    const labelMap = {
                        'brand': 'Бренд',
                        'style': 'Стиль',
                        'color': 'Цвет',
                        'stylist': 'Стилист'
                    };

                    // Сбрасываем к дефолтному тексту с (0) - временно
                    valueElement.textContent = `${labelMap[filterLabel]} (0)`;

                    // Убираем только has-selection для фильтров образов (без filtered)
                    triggerElement.classList.remove('has-selection');
                }
            }
        });
    }

    // Сбрасываем мобильные фильтры
    clearMobileFilters();

    // Определяем тип страницы и используем соответствующий сброс
    if (isExist('.catalog-list') && isExist('.products-grid')) {
        // Для страниц товаров (есть и catalog-list и products-grid)
        
        // Устанавливаем флаг сброса фильтров
        window.isClearingFilters = true;
        
        clearProductUrlParameters();

        // Сбрасываем селект сортировки к значению по умолчанию
        initSortingSelect();

        performProductAjaxFilter();
        
        // Для страниц товаров сбрасываем флаг сразу после вызова performProductAjaxFilter
        // (так как для товаров используется другая логика)
        window.isClearingFilters = false;
    } else {
        // Для страниц образов (есть catalog-list но нет products-grid)
        clearUrlParameters();

        // Устанавливаем активную категорию "Женщины" по умолчанию
        // Используем setActiveCategory вместо updateActiveFilter, чтобы не триггерить обработчики
        setActiveCategory('zhenshhiny');

        // Загружаем образы с категорией по умолчанию
        loadFilteredLooks();
        // Флаг будет сброшен в .finally() функции loadFilteredLooks()
    }
}

/**
 * @function clearMobileFilters
 * @description Сбрасывает все мобильные фильтры
 */
function clearMobileFilters() {

    // Сбрасываем все радиокнопки в мобильных фильтрах
    const mobileFilterNames = ['clothing_filter', 'shoes_filter', 'accessories_filter'];
    mobileFilterNames.forEach(filterName => {
        const mobileContainerId = `mobile_${filterName.replace('_filter', '')}_filter_options`;
        const mobileContainer = document.getElementById(mobileContainerId);

        if (mobileContainer) {
            const radios = mobileContainer.querySelectorAll('input[type="radio"]');
            radios.forEach(radio => {
                radio.checked = false;
            });
        }
    });

    // Закрываем все аккордеоны
    const accordionItems = document.querySelectorAll('.mobile-filters__accordion-item');
    accordionItems.forEach(item => {
        item.classList.remove('active');
    });

        // Сбрасываем классы has-selection и filtered для всех селектов
        const allFilterNames = ['clothing_filter', 'shoes_filter', 'accessories_filter', 'product_brand_filter'];
        allFilterNames.forEach(filterName => {
            const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
            if (customSelect) {
                const triggerElement = customSelect.querySelector('.custom-select__trigger');
                if (triggerElement) {
                    triggerElement.classList.remove('has-selection');
                    customSelect.classList.remove('filtered');
                }
            }
        });

    // Закрываем мобильное окно фильтров
    const mobileFiltersContainer = document.querySelector('.catalog__mobile-filters');
    if (mobileFiltersContainer) {
        closeMobileFilters(mobileFiltersContainer);
    }

    // Обновляем счетчики фильтров образов после сброса
    const isProductPage = isExist('.catalog-list') && isExist('.products-grid');
    if (!isProductPage) {
        // Получаем данные фильтров из глобальной переменной
        if (window.lookFilterData) {
            updateLookFilterCounters(window.lookFilterData);
        }
    }
}

/**
 * @function updateActiveFilter
 * @description Обновляет активный фильтр в интерфейсе
 * @param {string} categorySlug - slug активной категории
 */
function updateActiveFilter(categorySlug) {
    

    // Убираем активные классы со всех фильтров
    document.querySelectorAll('.catalog__category').forEach(filter => {
        filter.classList.remove('active');
    });

    // Добавляем активный класс к выбранному фильтру
    const activeFilter = document.querySelector(`[data-termslug="${categorySlug}"]`);
    if (activeFilter) {
        activeFilter.classList.add('active');
        
    } else {
        
    }
}

/**
 * @function updateUrlParameter
 * @description Обновляет параметр в URL
 * @param {string} param - имя параметра
 * @param {string} value - значение параметра
 */
function updateUrlParameter(param, value) {
    const url = new URL(window.location);

    if (value && value !== '') {
        url.searchParams.set(param, value);
    } else {
        url.searchParams.delete(param);
    }

    // Обновляем URL без перезагрузки страницы
    window.history.replaceState({}, '', url);
}

/**
 * @function clearUrlParameters
 * @description Очищает все параметры фильтрации из URL
 */
function clearUrlParameters() {
    const url = new URL(window.location);
    url.searchParams.delete('category');
    url.searchParams.delete('filterBrand');
    url.searchParams.delete('filterStyle');
    url.searchParams.delete('filterColor');
    url.searchParams.delete('filterStylist');
    url.searchParams.delete('filterClothing');
    url.searchParams.delete('filterShoes');
    url.searchParams.delete('filterAccessories');
    url.searchParams.delete('filterProduct_brand');
    url.searchParams.delete('orderby');
    window.history.replaceState({}, '', url);
}

/**
 * @function clearProductUrlParameters
 * @description Очищает все параметры фильтрации товаров из URL
 */
function clearProductUrlParameters() {
    const url = new URL(window.location);
    // НЕ удаляем параметр 'category' - он нужен для корректной работы performProductAjaxFilter
    // url.searchParams.delete('category');
    url.searchParams.delete('brand');
    url.searchParams.delete('clothing');
    url.searchParams.delete('shoes');
    url.searchParams.delete('accessories');
    url.searchParams.delete('filterClothing');
    url.searchParams.delete('filterShoes');
    url.searchParams.delete('filterAccessories');
    url.searchParams.delete('filterProduct_brand');
    url.searchParams.delete('orderby');
    window.history.replaceState({}, '', url);
}

/**
 * @function performAjaxFilter
 * @description Выполняет AJAX запрос для фильтрации
 * @param {object} filterData - данные для фильтрации
 */
function performAjaxFilter(filterData) {
    
    
    // Сбрасываем флаг загрузки при переключении категории/фильтров
    isAjaxLoading = false;
    
    const looksGrid = document.querySelector('.looks-grid');

    // Показываем прелоадер
    if (looksGrid) {
        showLoadingOverlay(looksGrid);
    }

    // Убеждаемся, что параметр сортировки передается из URL, если он не передан в filterData
    if (!filterData.hasOwnProperty('orderby')) {
        const urlParams = new URLSearchParams(window.location.search);
        const orderbyValue = urlParams.get('orderby');
        if (orderbyValue && orderbyValue !== 'default') {
            filterData['orderby'] = orderbyValue;
        }
    }

    // Подготавливаем данные для запроса
    const requestData = {
        action: 'load_looks',
        nonce: looksAjax.nonce,
        ...filterData
    };
    
    // Логируем для отладки
    console.log('🔍 performAjaxFilter - filterData:', filterData);
    console.log('🔍 performAjaxFilter - requestData:', requestData);
    console.log('🔍 performAjaxFilter - orderby в requestData:', requestData.orderby);

    // Выполняем AJAX запрос
    fetch(looksAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(requestData)
    })
    .then(response => {
        return response.json();
    })
    .then(data => {
        if (data.success) {
            updateLooksContent(data.data);
        } else {
            console.log(`❌ AJAX ошибка:`, data);
            showErrorMessage('Ошибка при загрузке данных');
            // Скрываем прелоадер при ошибке
            if (looksGrid) {
                hideLoadingOverlay(looksGrid);
            }
        }
    })
    .catch(error => {
        console.error('❌ Ошибка AJAX запроса:', error);
        showErrorMessage('Произошла ошибка при загрузке данных');
        // Скрываем прелоадер при ошибке
        if (looksGrid) {
            hideLoadingOverlay(looksGrid);
        }
    })
    .finally(() => {
        // Сбрасываем флаг загрузки после завершения AJAX запроса
        isAjaxLoading = false;
        
        // Прелоадер уже скрыт в updateLooksContent или в обработчиках ошибок

        // Дополнительная проверка восстановления кнопки после AJAX запроса
        setTimeout(() => {
            const loadMoreBtn = document.querySelector('.load-more-btn');
            const currentItems = document.querySelectorAll('.look-item[data-id]').length;
            const loadMoreContainer = document.querySelector('.load-more-container');
            const looksList = document.querySelector('.looks-list');

            // Получаем данные из атрибутов DOM
            const totalAvailable = looksList ? parseInt(looksList.getAttribute('data-total')) || 0 : 0;
            const totalPages = looksList ? parseInt(looksList.getAttribute('data-pages')) || 1 : 1;


            if (!loadMoreBtn && loadMoreContainer && currentItems > 0) {

                const newButton = document.createElement('button');
                newButton.type = 'button';
                newButton.className = 'load-more-btn btn';
                newButton.textContent = 'Загрузить еще';
                newButton.setAttribute('data-page', '2');
                newButton.setAttribute('data-total-pages', totalPages);
                newButton.style.display = 'none'; // НОВАЯ СИСТЕМА: Кнопка скрыта по умолчанию

                loadMoreContainer.innerHTML = '';
                loadMoreContainer.appendChild(newButton);

                // Инициализируем обработчик для новой кнопки
                initLoadMoreButtonForNewButton(newButton);

            } else if (loadMoreBtn && currentItems > 0 && totalAvailable > 0 && currentItems < totalAvailable) {

                // Сбрасываем состояние существующей кнопки только если есть еще элементы для загрузки
                loadMoreBtn.style.display = 'none'; // НОВАЯ СИСТЕМА: Кнопка скрыта по умолчанию
                loadMoreBtn.setAttribute('data-page', '2');
                loadMoreBtn.setAttribute('data-total-pages', totalPages);
                loadMoreBtn.removeAttribute('style');
                loadMoreBtn.style.display = 'none'; // НОВАЯ СИСТЕМА: Кнопка скрыта по умолчанию

                // Принудительно показываем кнопку и контейнер
                const loadMoreContainer = loadMoreBtn.closest('.load-more-container');
                if (loadMoreContainer) {
                    loadMoreContainer.style.display = 'flex';
                    loadMoreContainer.style.visibility = 'visible';
                }

            } else if (loadMoreBtn && totalAvailable > 0 && currentItems >= totalAvailable) {

                // Скрываем кнопку если все элементы загружены
                loadMoreBtn.style.display = 'none';

            }
        }, 200);
        lazyLoadInstance.update();
    });
}

/**
 * @function updateLooksContent
 * @description Обновляет содержимое списка образов
 * @param {object} data - данные ответа от сервера
 */
function updateLooksContent(data) {
    const looksGrid = document.querySelector('.looks-grid');
    const looksList = document.querySelector('.looks-list');

    if (looksGrid && data.html) {
        // Полностью заменяем содержимое при фильтрации
        looksGrid.innerHTML = data.html;

        // Скрываем прелоадер после обновления контента
        hideLoadingOverlay(looksGrid);

        // Обновляем атрибуты контейнера
        if (looksList && data.total !== undefined && data.pages !== undefined) {
            looksList.setAttribute('data-total', data.total);
            looksList.setAttribute('data-pages', data.pages);
        }

        // Инициализируем ленивую загрузку видео для новых элементов
        if (typeof initLazyVideoLoading === 'function') {
            initLazyVideoLoading();
        }

        // Инициализируем автовоспроизведение видео для новых элементов
        if (typeof initVideoAutoplay === 'function') {
            initVideoAutoplay();
        }
        
        // Восстанавливаем состояние сортировки из URL после обновления контента
        // Делаем это с небольшой задержкой, чтобы DOM успел обновиться
        setTimeout(() => {
            const sortingSelect = document.querySelector('.custom-select[data-sort="price"]');
            if (sortingSelect && typeof restoreSortingState === 'function') {
                const urlParams = new URLSearchParams(window.location.search);
                const orderbyValue = urlParams.get('orderby');
                // Восстанавливаем состояние сортировки из URL
                restoreSortingState(orderbyValue || 'default');
            }
        }, 50);

        // Скрываем кнопку "Загрузить еще" на главной странице
        const isHomePage = document.querySelector('.looks-grid') !== null;
        if (isHomePage) {
            const loadMoreBtn = document.querySelector('.load-more-btn');
            if (loadMoreBtn) {
                loadMoreBtn.style.display = 'none';
            }
            const loadMoreContainer = document.querySelector('.load-more-container');
            if (loadMoreContainer) {
                loadMoreContainer.style.display = 'none';
            }
        }

        // Инициализируем состояние кнопок избранного для нового контента
        initFavoritesButtons();

        // Инициализируем большие карточки для нового контента
        if (typeof initBigItemCards === 'function') {
            initBigItemCards();
        }

        // Восстанавливаем состояние фильтров после обновления контента
        setTimeout(() => {
            restoreFilterStates();
        }, 1000);

        // Восстанавливаем кнопку "Загрузить еще" если её нет
        setTimeout(() => {
            const loadMoreBtn = document.querySelector('.load-more-btn');
            const currentItems = document.querySelectorAll('.look-item[data-id]').length;
            const loadMoreContainer = document.querySelector('.load-more-container');



            // Если все элементы загружены, скрываем кнопку
            if (currentItems >= data.total && data.total > 0) {
                if (loadMoreBtn) {
                    loadMoreBtn.style.display = 'none';
                }
            } else if (data.total && currentItems < data.total && currentItems > 0) {
                // Показываем кнопку, если она есть, или создаем новую
                if (loadMoreBtn) {

                    // Сбрасываем состояние кнопки только если есть еще элементы для загрузки
                    if (data.total && currentItems < data.total) {
                        loadMoreBtn.style.display = 'none'; // НОВАЯ СИСТЕМА: Кнопка скрыта по умолчанию
                        loadMoreBtn.setAttribute('data-page', '2');
                        loadMoreBtn.setAttribute('data-total-pages', data.pages || 2);
                        loadMoreBtn.removeAttribute('style');
                        loadMoreBtn.style.display = 'none'; // НОВАЯ СИСТЕМА: Кнопка скрыта по умолчанию

                        // Принудительно показываем контейнер
                        if (loadMoreContainer) {
                            loadMoreContainer.style.display = 'flex';
                            loadMoreContainer.style.visibility = 'visible';
                        }
                    } else {
                        // Скрываем кнопку если все элементы загружены
                        loadMoreBtn.style.display = 'none';
                    }

                } else {

                    if (loadMoreContainer) {
                        // Проверяем, находимся ли мы на главной странице
                        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
                        const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                                             document.body.classList.contains('tax-product_category') ||
                                             document.body.classList.contains('post-type-archive-look') ||
                                             document.body.classList.contains('tax-look_category') ||
                                             window.location.pathname.includes('/catalog') ||
                                             window.location.pathname.includes('/looks');
                        
                        if (isHomePage && !isArchivePage) {
                            // На главной странице НЕ инициализируем автоподгрузку - там должна работать только кнопка
                            // Кнопка будет показана/скрыта в initLoadMoreButton
                        } else {
                            // На других страницах создаем кнопку
                            const newButton = document.createElement('button');
                            newButton.type = 'button';
                            newButton.className = 'load-more-btn btn';
                            newButton.textContent = 'Загрузить еще';
                            newButton.setAttribute('data-page', '2');
                            newButton.setAttribute('data-total-pages', data.pages || 2);
                            newButton.style.display = 'block';

                            loadMoreContainer.innerHTML = '';
                            loadMoreContainer.appendChild(newButton);

                            // Принудительно показываем контейнер
                            loadMoreContainer.style.display = 'flex';
                            loadMoreContainer.style.visibility = 'visible';

                            // Инициализируем обработчик для новой кнопки
                            initLoadMoreButtonForNewButton(newButton);
                        }

                    } else {
                    }
                }
            } else if (currentItems === 0) {
            }
        }, 100);

        // Автоматический скролл отключен для улучшения пользовательского опыта
    }

    // Обновляем счетчики фильтров если есть данные
    if (data.filters) {
        updateLookFilterCounters(data.filters);
    } else if (window.lookFilterData) {
        // Если данных фильтров нет в ответе, используем сохраненные данные
        updateLookFilterCounters(window.lookFilterData);
    }
    
    // Инициализируем кнопку "Загрузить еще" после обновления контента
    setTimeout(() => {
        initLoadMoreButton();
    }, 300);
}

/**
 * @function showLoadingIndicator
 * @description Показывает индикатор загрузки
 */
function showLoadingIndicator() {
    const looksGrid = document.querySelector('.looks-grid');
    if (looksGrid) {
        // Сохраняем существующий контент
        const existingContent = looksGrid.innerHTML;

        const loadingHtml = `
            <div class="looks-loading" style="text-align: center; padding: 40px;">
                <div class="loading-spinner" style="border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto 20px;"></div>
                <p>Загрузка...</p>
            </div>
        `;

        // Добавляем индикатор загрузки, не заменяя существующий контент
        looksGrid.insertAdjacentHTML('beforeend', loadingHtml);

        // Сохраняем ссылку на индикатор для последующего удаления
        looksGrid._loadingIndicator = looksGrid.querySelector('.looks-loading');
    }
}

/**
 * @function hideLoadingIndicator
 * @description Скрывает индикатор загрузки
 */
function hideLoadingIndicator() {
    const loadingElement = document.querySelector('.looks-loading');
    if (loadingElement) {
        loadingElement.remove();
    }
}

/**
 * @function showErrorMessage
 * @description Показывает сообщение об ошибке
 * @param {string} message - текст сообщения
 */
function showErrorMessage(message) {
    const looksGrid = document.querySelector('.looks-grid');
    if (looksGrid) {
        const errorHtml = `
            <div class="looks-error" style="text-align: center; padding: 40px; color: #e74c3c;">
                <p>${message}</p>
            </div>
        `;
        looksGrid.innerHTML = errorHtml;
    }
}

/**
 * @function initUrlParameters
 * @description Инициализирует фильтры на основе URL параметров
 */
function initUrlParameters() {
    
    // Если данные фильтров уже загружены, сразу восстанавливаем состояние
    if (window.lookFilterDataLoaded) {
        initUrlParametersAfterFiltersLoaded();
    } else {
        // Сначала загружаем данные фильтров
        if (typeof loadLookFilterData === 'function') {
            loadLookFilterData().then(() => {
                initUrlParametersAfterFiltersLoaded();
            }).catch(error => {
                console.error('❌ Ошибка загрузки данных фильтров:', error);
                // Продолжаем инициализацию даже при ошибке
                initUrlParametersAfterFiltersLoaded();
            });
        } else {
            initUrlParametersAfterFiltersLoaded();
        }
    }
}

function initUrlParametersAfterFiltersLoaded() {
    
    const urlParams = new URLSearchParams(window.location.search);
    const filterData = {};

    // Проверяем параметр категории
    const categoryParam = urlParams.get('category');
    if (categoryParam) {
        updateActiveFilter(categoryParam);
        filterData.look_category_slug = categoryParam;
    }

    // Добавляем небольшую задержку, чтобы чекбоксы успели создать в DOM
    setTimeout(() => {
        // Проверяем остальные параметры фильтрации
        const brandParam = urlParams.get('filterBrand');
        if (brandParam) {
            filterData.brand = brandParam;
            setCustomSelectValue('brand_filter', brandParam);
        }

        const styleParam = urlParams.get('filterStyle');
        if (styleParam) {
            filterData.style = styleParam;
            setCustomSelectValue('style_filter', styleParam);
        }

        const colorParam = urlParams.get('filterColor');
        if (colorParam) {
            filterData.color = colorParam;
            setCustomSelectValue('color_filter', colorParam);
        }

        const stylistParam = urlParams.get('filterStylist');
        if (stylistParam) {
            filterData.stylist = stylistParam;
            setCustomSelectValue('stylist_filter', stylistParam);
        }

        // Проверяем, есть ли параметры фильтрации в URL (кроме категории, которая может быть установлена по умолчанию)
        const orderbyValue = urlParams.get('orderby');
        const hasOrderby = orderbyValue && orderbyValue !== 'default' && orderbyValue !== '';
        const hasFilters = urlParams.has('filterBrand') || 
                          urlParams.has('filterStyle') || 
                          urlParams.has('filterColor') || 
                          urlParams.has('filterStylist') ||
                          hasOrderby;
        
        // Если есть параметры фильтрации, загружаем отфильтрованные данные
        // Но НЕ вызываем applyFilter для каждого фильтра отдельно, чтобы избежать множественных запросов
        if (hasFilters) {
            // Используем getAllActiveFilters для получения всех фильтров из URL
            const allFilters = getAllActiveFilters();
            performAjaxFilter(allFilters);
        } else {
            // Если нет параметров фильтрации, НЕ вызываем AJAX-запрос
            // Контент уже загружен сервером с правильным порядком
            // Только восстанавливаем состояние фильтров без перезагрузки контента
            
            // Если есть только категория в URL, но нет других фильтров, тоже не вызываем AJAX
            // Контент уже загружен сервером с правильным порядком
            if (categoryParam) {
                // Просто обновляем активную категорию, но не перезагружаем контент
                updateActiveFilter(categoryParam);
            }
        }
    }, 150); // Задержка для создания чекбоксов в DOM

    // Инициализируем кнопку "Загрузить еще" для образов после загрузки контента
    // initLoadMoreButton(); // Убираем отсюда, будет вызвано в updateLooksContent
}

/**
 * @function initProductUrlParameters
 * @description Инициализирует фильтры товаров на основе URL параметров
 */
function initProductUrlParameters() {
    const urlParams = new URLSearchParams(window.location.search);

    // Проверяем параметр категории товара
    const categoryParam = urlParams.get('category');
    if (categoryParam) {
        updateActiveFilter(categoryParam);
    } else {
        // Если нет параметра категории, устанавливаем "Женщины" по умолчанию (без добавления в URL)
        updateActiveFilter('zhenshhiny');
    }

    // Восстанавливаем состояние селектов на основе URL параметров
    // Добавляем небольшую задержку, чтобы селекты успели загрузиться
    setTimeout(() => {
        restoreSelectStatesFromUrl();
    }, 100);

    // НЕ вызываем performProductAjaxFilter() здесь - это будет сделано в initProductFilters()
    // Это предотвращает двойную фильтрацию при инициализации
    // const hasProductFilters = urlParams.has('category') ||
    //                          urlParams.has('filterClothing') ||
    //                          urlParams.has('filterShoes') ||
    //                          urlParams.has('filterAccessories') ||
    //                          urlParams.has('filterProduct_brand') ||
    //                          urlParams.has('orderby');

    // if (hasProductFilters) {
    //     performProductAjaxFilter();
    // }
    // Убираем автоматическое обновление каталога при отсутствии фильтров
    // Товары уже загружены на сервере и отображаются
}

/**
 * @function restoreSelectStatesFromUrl
 * @description Восстанавливает состояние селектов на основе URL параметров
 */
function restoreSelectStatesFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);

    // Если URL пустой (после сброса фильтров), не восстанавливаем состояние
    if (urlParams.toString() === '') {
        return;
    }

    // Восстанавливаем состояние фильтров категорий (радиокнопки)
    const categoryFilters = ['filterClothing', 'filterShoes', 'filterAccessories'];
    categoryFilters.forEach(filterParam => {
        const value = urlParams.get(filterParam);
        if (value) {
            const filterName = filterParam.replace('filter', '').toLowerCase() + '_filter';
            setCustomSelectValue(filterName, value);
        }
    });

    // Восстанавливаем состояние фильтра бренда
    const brandValue = urlParams.get('filterProduct_brand');
    if (brandValue) {
        setCustomSelectValue('product_brand_filter', brandValue);
    }
}

/**
 * @function setSelectValue
 * @description Устанавливает значение селекта
 * @param {string} selectId - ID селекта
 * @param {string} value - значение
 */
function setSelectValue(selectId, value) {
    const select = document.getElementById(selectId);
    if (select) {
        select.value = value;
    }
}

/**
 * @function setCustomSelectValue
 * @description Устанавливает значение кастомного селекта
 * @param {string} filterName - имя фильтра
 * @param {string} value - значение (может быть через запятую для множественного выбора)
 */
function setCustomSelectValue(filterName, value) {
    
    const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
    if (!customSelect) {
        console.log(`❌ Селект ${filterName} не найден`);
        return;
    }

    const optionsContainer = customSelect.querySelector('.custom-select__options');
    if (!optionsContainer) {
        console.log(`❌ Контейнер опций для ${filterName} не найден`);
        return;
    }

    // Обрабатываем множественные значения
    const valueArray = value.split(',');
    const checkedBoxes = [];
    const selectedLabels = [];

    // Отмечаем соответствующие чекбоксы
    valueArray.forEach(val => {
        const trimmedValue = val.trim();
        const checkbox = optionsContainer.querySelector(`input[value="${trimmedValue}"]`);

        if (checkbox) {
            checkbox.checked = true;
            checkedBoxes.push(checkbox);
            const label = checkbox.nextElementSibling;
            if (label) {
                selectedLabels.push(label.textContent);
            }
        } else {
            console.log(`❌ Чекбокс для значения ${trimmedValue} не найден`);
        }
    });

    // Обновляем текст триггера
    if (checkedBoxes.length > 0) {
        const valueElement = customSelect.querySelector('.custom-select__value');
        const triggerElement = customSelect.querySelector('.custom-select__trigger');

        if (valueElement && triggerElement) {
            // Определяем название фильтра
            const filterLabel = filterName.replace('_filter', '');
            const labelMap = {
                'brand': 'Бренд',
                'style': 'Стиль',
                'color': 'Цвет',
                'stylist': 'Стилист',
                'product_brand': 'Бренд'
            };
            
            if (selectedLabels.length === 1) {
                // Для одного выбранного элемента показываем название фильтра с количеством
                const labelName = labelMap[filterLabel] || filterLabel;
                valueElement.textContent = `${labelName} (1)`;
            } else {
                // Для нескольких выбранных элементов показываем количество
                const labelName = labelMap[filterLabel] || filterLabel;
                valueElement.textContent = `${labelName} (${selectedLabels.length})`;
            }
            triggerElement.classList.add('has-selection');
        }
    }
}

/**
 * @function initLazyVideoLoading
 * @description Инициализирует ленивую загрузку видео для новых элементов
 */
function initLazyVideoLoading() {
    const videoContainers = document.querySelectorAll('.look-main-video:not([data-video-initialized])');

    if (videoContainers.length === 0) return;

    const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const videoContainer = entry.target;
                const videoSrc = videoContainer.dataset.videoSrc;
                const videoType = videoContainer.dataset.videoType;

                if (videoSrc && !videoContainer.querySelector('video')) {
                    // Создаем элемент video
                    const video = document.createElement('video');
                    video.width = '100%';
                    video.height = 'auto';
                    video.autoplay = true;
                    video.muted = true;
                    video.loop = true;
                    video.playsInline = true;
                    video.preload = 'metadata';

                    // Создаем source элемент
                    const source = document.createElement('source');
                    source.src = videoSrc;
                    source.type = videoType;

                    video.appendChild(source);
                    video.appendChild(document.createTextNode('Ваш браузер не поддерживает тег Video.'));

                    // Заменяем placeholder на видео
                    videoContainer.innerHTML = '';
                    videoContainer.appendChild(video);

                    // Обработка ошибок загрузки
                    video.addEventListener('error', () => {
                        videoContainer.innerHTML = '<div class="video-error"><p>Ошибка загрузки видео</p></div>';
                    });

                    // Обработка успешной загрузки
                    video.addEventListener('loadeddata', () => {
                        videoContainer.classList.add('video-loaded');
                    });
                }

                // Отключаем наблюдение для этого элемента
                videoObserver.unobserve(videoContainer);
            }
        });
    }, {
        rootMargin: '50px 0px',
        threshold: 0.1
    });

    // Наблюдаем за новыми видео контейнерами
    videoContainers.forEach(videoContainer => {
        videoContainer.setAttribute('data-video-initialized', 'true');
        videoObserver.observe(videoContainer);
    });
}

/**
 * @function loadFilterData
 * @description Загружает данные для фильтров через AJAX
 */
function loadFilterData() {
    return fetch(looksAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'get_filter_data',
            nonce: looksAjax.filterNonce
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            populateFilterSelects(data.data);
            // Инициализируем состояние кнопок избранного для нового контента
            initFavoritesButtons();

            // Инициализируем большие карточки для нового контента
            if (typeof initBigItemCards === 'function') {
                initBigItemCards();
            }
        } else {
            console.error('Ошибка загрузки данных фильтров');
        }
        return data;
    })
    .catch(error => {
        console.error('Ошибка AJAX запроса для фильтров:', error);
        throw error;
    });
}

/**
 * @function initFavoritesButtons
 * @description Инициализирует состояние кнопок избранного для динамически загруженного контента
 */
function initFavoritesButtons() {
    // Находим все кнопки избранного и устанавливаем их состояние
    document.querySelectorAll('.tool-favorite').forEach(button => {
        const postId = button.dataset.id;
        const postType = button.dataset.type;

        if (postId && postType) {
            if (isInFavorites(postId, postType)) {
                button.classList.add('isInFavorites');
            } else {
                button.classList.remove('isInFavorites');
            }
        }
    });
}

/**
 * @function initBigItemCards
 * @description Добавляет классы для больших карточек в каталогах
 * @param {boolean} onlyNew - если true, обрабатывает только элементы без классов big-item-card
 */
function initBigItemCards(onlyNew = false) {
    // Функция для определения, является ли позиция большой карточкой
    function isBigItemPosition(position) {
        // Позиции: 3, 14, 29, 40, 51, 62, 73, 84, 95, 106...
        // Формула: 3, 14, 29, затем каждые 11 позиций
        if (position === 3 || position === 14 || position === 29) {
            return true;
        }
        if (position > 29) {
            return (position - 29) % 11 === 0;
        }
        return false;
    }

    // Функция для определения, является ли позиция четной большой карточкой
    function isEvenBigItemPosition(position) {
        // Четные позиции: 14, 40, 62, 84, 106, 128, 150...
        // Формула: 14, затем 40 (14 + 26), затем каждые 22 позиции (62 = 40 + 22, 84 = 62 + 22, 106 = 84 + 22, 128 = 106 + 22)
        if (position === 14) {
            return true;
        }
        if (position === 40) {
            return true;
        }
        if (position > 40 && (position - 40) % 22 === 0) {
            return true;
        }
        return false;
    }

    // Обрабатываем товары
    const productItems = document.querySelectorAll('.product-item');
    productItems.forEach((item, index) => {
        // Если onlyNew = true, пропускаем элементы, у которых уже есть классы
        if (onlyNew && item.classList.contains('big-item-card')) {
            return;
        }

        const position = index + 1;

        // Удаляем старые классы перед добавлением новых
        item.classList.remove('big-item-card', 'big-item-card--even');

        if (isBigItemPosition(position)) {
            // Проверяем количество оставшихся элементов
            const remainingElements = productItems.length - position;
            const isEvenPosition = isEvenBigItemPosition(position);
            const minRequired = isEvenPosition ? 4 : 2;

            if (remainingElements >= minRequired) {
                item.classList.add('big-item-card');

                if (isEvenPosition) {
                    item.classList.add('big-item-card--even');
                }
            }
        }
    });

    // Обрабатываем образы
    const lookItems = document.querySelectorAll('.look-item');
    lookItems.forEach((item, index) => {
        // Если onlyNew = true, пропускаем элементы, у которых уже есть классы
        if (onlyNew && item.classList.contains('big-item-card')) {
            return;
        }

        const position = index + 1;

        // Удаляем старые классы перед добавлением новых
        item.classList.remove('big-item-card', 'big-item-card--even');

        if (isBigItemPosition(position)) {
            // Проверяем количество оставшихся элементов
            const remainingElements = lookItems.length - position;
            const isEvenPosition = isEvenBigItemPosition(position);
            const minRequired = isEvenPosition ? 4 : 2;

            if (remainingElements >= minRequired) {
                item.classList.add('big-item-card');

                if (isEvenPosition) {
                    item.classList.add('big-item-card--even');
                }
            }
        }
    });
}

/**
 * @function populateFilterSelects
 * @description Заполняет селекты данными фильтров
 * @param {object} filterData - данные фильтров
 */
function populateFilterSelects(filterData) {
    // Сохраняем данные фильтров в глобальную переменную для использования при сбросе
    window.lookFilterData = filterData;

    // Заполняем селект брендов
    if (filterData.brands) {
        populateSelect('brand_filter_options', filterData.brands, 'Бренд');
    }

    // Заполняем селект стилей
    if (filterData.styles) {
        populateSelect('style_filter_options', filterData.styles, 'Стиль');
    }

    // Заполняем селект цветов
    if (filterData.colors) {
        populateSelect('color_filter_options', filterData.colors, 'Цвет');
    }

    // Заполняем селект стилистов
    if (filterData.stylists) {
        populateSelect('stylist_filter_options', filterData.stylists, 'Стилист');
    }

    // Заполняем мобильные фильтры для образов
    populateMobileFiltersForLooks(filterData);

    // Обновляем счетчики для фильтров образов
    updateLookFilterCounters(filterData);
}

/**
 * @function updateLookFilterCounters
 * @description Обновляет счетчики для фильтров образов
 * @param {object} filterData - данные фильтров
 */
function updateLookFilterCounters(filterData) {
    // Проверяем, есть ли данные
    if (!filterData) {
        return;
    }

    // Обновляем счетчик брендов
    if (filterData.brands && filterData.brands.length > 0) {
        updateLookFilterCounter('brand_filter', filterData.brands.length);
    }

    // Обновляем счетчик стилей
    if (filterData.styles && filterData.styles.length > 0) {
        updateLookFilterCounter('style_filter', filterData.styles.length);
    }

    // Обновляем счетчик цветов
    if (filterData.colors && filterData.colors.length > 0) {
        updateLookFilterCounter('color_filter', filterData.colors.length);
    }

    // Обновляем счетчик стилистов
    if (filterData.stylists && filterData.stylists.length > 0) {
        updateLookFilterCounter('stylist_filter', filterData.stylists.length);
    }
}

/**
 * @function updateLookFilterCounter
 * @description Обновляет счетчик для конкретного фильтра образов
 * @param {string} filterName - имя фильтра
 * @param {number} count - количество элементов
 */
function updateLookFilterCounter(filterName, count) {
    const customSelect = document.querySelector(`[data-filter="${filterName}"]`);

    if (customSelect) {
        const valueElement = customSelect.querySelector('.custom-select__value');
        const triggerElement = customSelect.querySelector('.custom-select__trigger');

        if (valueElement && triggerElement) {
            // Проверяем, есть ли выбранные значения
            const optionsContainer = customSelect.querySelector('.custom-select__options');
            const checkedBoxes = optionsContainer ? optionsContainer.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked') : [];

            // Если есть выбранные значения, не перезаписываем текст
            if (checkedBoxes.length > 0) {
                return;
            }

            // Если ничего не выбрано, обновляем счетчик
            const labelMap = {
                'brand_filter': 'Бренд',
                'style_filter': 'Стиль',
                'color_filter': 'Цвет',
                'stylist_filter': 'Стилист'
            };

            const label = labelMap[filterName] || filterName;
            const newText = `${label} (${count})`;
            valueElement.textContent = newText;
            triggerElement.classList.remove('has-selection');
        }
    }
}

/**
 * @function populateSelect
 * @description Заполняет конкретный селект данными
 * @param {string} selectId - ID селекта
 * @param {Array} items - массив терминов или постов
 * @param {string} label - название фильтра
 */
function populateSelect(selectId, items, label) {
    
    const optionsContainer = document.getElementById(selectId);
    if (!optionsContainer) {
        console.warn(`❌ Options container with ID ${selectId} not found`);
        return;
    }

    // Проверяем, не заполнен ли уже селект
    if (optionsContainer.children.length > 0) {
        return;
    }

    // Проверяем, что items является массивом, если нет - пытаемся преобразовать
    if (!Array.isArray(items)) {
        // Если это объект с числовыми ключами, преобразуем в массив
        if (items && typeof items === 'object') {
            const convertedItems = Object.values(items);
            if (convertedItems.length > 0) {
                items = convertedItems;
            } else {
                console.error(`Не удалось преобразовать объект в массив для ${selectId}`);
                return;
            }
        } else {
            console.error(`Ошибка: items для ${selectId} не является массивом и не может быть преобразован:`, items);
            return;
        }
    }

    // Сохраняем текущее состояние выбранных значений
    // Сначала пытаемся восстановить из URL (источник истины), потом из чекбоксов
    const selectedValues = [];
    const filterName = selectId.replace('_options', '');
    const urlParams = new URLSearchParams(window.location.search);
    
    // Определяем название URL параметра для этого фильтра
    let urlParamName = '';
    if (filterName === 'brand_filter') {
        urlParamName = 'filterBrand';
    } else if (filterName === 'style_filter') {
        urlParamName = 'filterStyle';
    } else if (filterName === 'color_filter') {
        urlParamName = 'filterColor';
    } else if (filterName === 'stylist_filter') {
        urlParamName = 'filterStylist';
    }
    
    // Приоритет - URL параметр (источник истины)
    if (urlParamName && urlParams.has(urlParamName)) {
        const urlValue = urlParams.get(urlParamName);
        if (urlValue) {
            // Разбиваем значение через запятую для множественного выбора
            selectedValues.push(...urlValue.split(',').map(v => v.trim()));
        }
    } else {
        // Если в URL нет значения, используем текущее состояние чекбоксов
        const existingCheckboxes = optionsContainer.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
        existingCheckboxes.forEach(checkbox => {
            selectedValues.push(checkbox.value);
        });
    }

    // Очищаем контейнер
    optionsContainer.innerHTML = '';

    // Добавляем новые опции с чекбоксами
    items.forEach(item => {
        const optionDiv = document.createElement('div');
        optionDiv.className = 'custom-select__option';

        const checkbox = document.createElement('input');
        // Для фильтров категорий (одежда, обувь, аксессуары) используем радиокнопки
        if (selectId.includes('clothing') || selectId.includes('shoes') || selectId.includes('accessories')) {
            checkbox.type = 'radio';
            checkbox.name = 'category_filter'; // Общее имя для всех радиокнопок категорий
        } else {
            checkbox.type = 'checkbox';
        }
        checkbox.id = `${selectId}_${item.term_id || item.ID}`;
        checkbox.value = item.term_id || item.ID;

        // Добавляем data-атрибут с ID на сам элемент custom-select__option
        optionDiv.setAttribute('data-option-id', checkbox.id);

        const labelElement = document.createElement('label');
        labelElement.htmlFor = checkbox.id;

        // Проверяем, является ли элемент термином таксономии или постом
        if (item.term_id) {
            // Это термин таксономии
            labelElement.textContent = item.name;
        } else if (item.ID) {
            // Это пост (например, стилист)
            labelElement.textContent = item.post_title;
        } else {
            console.warn('Unknown item type:', item);
            return;
        }

        optionDiv.appendChild(checkbox);
        optionDiv.appendChild(labelElement);
        optionsContainer.appendChild(optionDiv);
    });

    // Восстанавливаем выбранные значения
    selectedValues.forEach(value => {
        const checkbox = optionsContainer.querySelector(`input[value="${value}"]`);
        if (checkbox) {
            checkbox.checked = true;
        } else {
            console.log(`❌ Не найден чекбокс для значения ${value} в ${selectId}`);
        }
    });

    // Обновляем текст триггера с учетом выбранных значений
    // filterName уже объявлен выше в функции
    const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
    if (customSelect) {
        const valueElement = customSelect.querySelector('.custom-select__value');
        const triggerElement = customSelect.querySelector('.custom-select__trigger');

        if (valueElement && triggerElement) {
            const checkedBoxes = optionsContainer.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');

            if (checkedBoxes.length === 0) {
                // Если ничего не выбрано, показываем счетчик
                const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');
                if (!isCategoryFilter) {
                    valueElement.textContent = `${label} (${items.length})`;
                } else {
                    valueElement.textContent = label;
                }
                triggerElement.classList.remove('has-selection');
            } else if (checkedBoxes.length === 1) {
                // Если выбрано одно значение, показываем его название
                const labelElement = checkedBoxes[0].nextElementSibling;
                if (labelElement) {
                    valueElement.textContent = labelElement.textContent;
                }
                triggerElement.classList.add('has-selection');
            } else {
                // Если выбрано несколько значений, показываем "Выбрано: X"
                valueElement.textContent = `Выбрано: ${checkedBoxes.length}`;
                triggerElement.classList.add('has-selection');
            }
        }
    }
}

/**
 * @function getAllActiveFilters
 * @description Собирает все активные фильтры
 * @returns {object} объект с активными фильтрами
 */
function getAllActiveFilters() {
    const filterData = {};
    const urlParams = new URLSearchParams(window.location.search);

    // Получаем активную категорию из URL или определяем по умолчанию
    const categoryParam = urlParams.get('category');
    if (categoryParam) {
        filterData.look_category_slug = categoryParam;
    } else {
        // Если URL пустой, проверяем, есть ли активная категория на странице
        const activeCategoryElement = document.querySelector('.catalog__filter.param_category .param__value.active');
        if (activeCategoryElement) {
            const categorySlug = activeCategoryElement.getAttribute('data-category');
            if (categorySlug) {
                filterData.look_category_slug = categorySlug;
            }
        } else {
            // Альтернативный способ: проверяем, есть ли активная категория в других элементах
            const categoryButton = document.querySelector('.catalog__filter.param_category .param__value.active, .catalog__filter.param_category .param__value[data-category]');
            if (categoryButton) {
                const categorySlug = categoryButton.getAttribute('data-category');
                if (categorySlug) {
                    filterData.look_category_slug = categorySlug;
                } else {
                    filterData.look_category_slug = 'zhenshhiny'; // Женщины по умолчанию
                }
            } else {
                // Если ничего не найдено, используем категорию по умолчанию
                filterData.look_category_slug = 'zhenshhiny'; // Женщины по умолчанию
            }
        }
    }

    // Получаем активные параметры фильтров из URL
    const paramNames = ['filterBrand', 'filterStyle', 'filterColor', 'filterStylist'];
    paramNames.forEach(paramName => {
        const paramValue = urlParams.get(paramName);
        if (paramValue) {
            // Убираем префикс 'filter' для внутреннего использования
            const internalParamName = paramName.replace('filter', '').toLowerCase();
            
            // Для брендов, стилистов и стилей сохраняем массив значений, для остальных - строку
            if (internalParamName === 'brand' || internalParamName === 'stylist' || internalParamName === 'style') {
                filterData[internalParamName] = paramValue.split(',');
            } else {
                filterData[internalParamName] = paramValue;
            }
        }
    });

    // Обрабатываем параметр сортировки
    const orderbyValue = urlParams.get('orderby');
    if (orderbyValue && orderbyValue !== 'default') {
        filterData['orderby'] = orderbyValue;
    }
    // Если нет параметра или "default", не добавляем orderby - будет сортировка по умолчанию
    
    // Логируем для отладки
    console.log('🔍 getAllActiveFilters - orderbyValue:', orderbyValue, 'filterData:', filterData);

    return filterData;
}

/**
 * @function applyFilter
 * @description Применяет фильтр
 * @param {string} filterName - имя фильтра
 * @param {string} filterValue - значение фильтра
 */
function applyFilter(filterName, filterValue) {    
    
    // Защита от выполнения запросов при сбросе фильтров
    if (window.isClearingFilters) {
        return;
    }
    
    // Преобразуем название фильтра в URL параметр с префиксом filter
    const urlParamName = 'filter' + filterName.replace('_filter', '').charAt(0).toUpperCase() + filterName.replace('_filter', '').slice(1);

    // Обновляем URL
    updateUrlParameter(urlParamName, filterValue);

    // Собираем все активные фильтры
    const filterData = getAllActiveFilters();

    // Для брендов, стилистов и стилей сохраняем массив значений, для остальных - строку
    if (filterName === 'brand_filter' || filterName === 'stylist_filter' || filterName === 'style_filter') {
        filterData[filterName.replace('_filter', '')] = filterValue.toString().split(',');
    } else {
        filterData[filterName.replace('_filter', '')] = filterValue;
    }

    performAjaxFilter(filterData);

    // Обновляем состояние активности всех селектов
    updateAllFiltersActiveState();
}

/**
 * @function removeFilter
 * @description Удаляет фильтр
 * @param {string} filterName - имя фильтра
 */
function removeFilter(filterName) {
    // Защита от выполнения запросов при сбросе фильтров
    if (window.isClearingFilters) {
        return;
    }
    
    // Преобразуем название фильтра в URL параметр с префиксом filter
    const urlParamName = 'filter' + filterName.replace('_filter', '').charAt(0).toUpperCase() + filterName.replace('_filter', '').slice(1);

    // Удаляем из URL
    updateUrlParameter(urlParamName, '');

    // Собираем все активные фильтры (кроме удаляемого)
    const filterData = getAllActiveFilters();
    delete filterData[filterName.replace('_filter', '')];

    // Выполняем AJAX запрос с оставшимися фильтрами
    performAjaxFilter(filterData);

    // Обновляем состояние активности всех селектов
    updateAllFiltersActiveState();
}

/**
 * @function initSliderMain
 * @description Инициализирует основной слайдер стилистов
 */
function initSliderMain() {
    const sliderContainer = document.querySelector('.stylists__slider .stylists-slider__main');
    const sliderThumbsContainer = document.querySelector('.stylists__slider .stylists-slider__thumbs');

    if (!sliderContainer) {
        console.warn('Контейнер слайдера slider__main не найден');
        return;
    }

    // Проверяем, что Swiper доступен
    if (typeof Swiper === 'undefined') {
        console.error('Swiper не загружен. Убедитесь, что библиотека Swiper подключена.');
        return;
    }

    // Проверяем количество слайдов для определения возможности использования loop
    const thumbsSlides = sliderThumbsContainer.querySelectorAll('.swiper-slide');
    const mainSlides = sliderContainer.querySelectorAll('.swiper-slide');
    const minSlidesForLoop = 3; // Минимальное количество слайдов для loop режима

    // Включаем loop если достаточно слайдов (8 слайдов достаточно)
    const canUseLoopThumbs = thumbsSlides.length >= 4; // Для slidesPerView: 'auto' нужно минимум 4
    const canUseLoopMain = mainSlides.length >= minSlidesForLoop;


    // Инициализируем слайдер
    const sliderThumbs = new Swiper(sliderThumbsContainer, {
        // Основные настройки
        slidesPerView: 'auto', // Возвращаем auto для правильного отображения
        slidesPerGroup: 1,
        spaceBetween: 6,
        centeredSlides: false,
        loop: canUseLoopThumbs, // Включаем loop если достаточно слайдов
        rewind: false,
        // Навигация - отключаем для слайдера миниатюр
        navigation: false,
        // Анимация
        speed: 400,
        effect: 'slide',
        allowTouchMove: true,
        resistanceRatio: 0.85,
        touchRatio: 1,
        threshold: 5,
        // Дополнительные настройки для стабильной работы
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        // Отладка навигации - отключена для слайдера миниатюр
        on: {},
    });

    // Определяем, нужно ли реверсировать слайды для мобильных устройств
    const isMobile = window.innerWidth < 991;
    const totalSlides = mainSlides.length;

    // Инициализируем слайдер
    const slider = new Swiper(sliderContainer, {
        // Основные настройки
        slidesPerView: 1,
        spaceBetween: 6,
        centeredSlides: true,
        /* centeredSlidesBounds: true, */
        loop: canUseLoopMain, // Включаем бесконечную прокрутку только если достаточно слайдов
        loopAdditionalSlides: 0, // Отключаем дополнительные слайды для точной навигации
        loopPreventsSlide: false, // Позволяем переходить к дублированным слайдам
        /* autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        }, */


        // Навигация
        navigation: {
            nextEl: isMobile ? '.stylists__slider__btn--next' : '.stylists__slider__btn--prev', // Меняем местами кнопки для мобильных
            prevEl: isMobile ? '.stylists__slider__btn--prev' : '.stylists__slider__btn--next',
        },
        // Анимация
        speed: 400, // Увеличиваем скорость анимации для плавности
        effect: 'slide', // Явно указываем эффект slide
        allowTouchMove: true, // Разрешаем сенсорное управление
        resistanceRatio: 0.85, // Сопротивление при достижении границ
        touchRatio: 1, // Чувствительность сенсорного управления
        threshold: 5, // Минимальное расстояние для срабатывания свайпа
        // Отладка навигации
        on: {
            navigationNext: function() {
                userInteracting = true;
                // Увеличиваем время ожидания для завершения всех анимаций
                setTimeout(() => {
                    userInteracting = false;
                    // Синхронизируем после завершения взаимодействия
                    if (lastMainIndex !== slider.realIndex) {
                        syncSliders(slider, sliderThumbs, canUseLoopThumbs, 'ОСНОВНОЙ', 'МИНИАТЮРЫ');
                    }
                }, 500);
            },
            navigationPrev: function() {
                userInteracting = true;
                // Увеличиваем время ожидания для завершения всех анимаций
                setTimeout(() => {
                    userInteracting = false;
                    // Синхронизируем после завершения взаимодействия
                    if (lastMainIndex !== slider.realIndex) {
                        syncSliders(slider, sliderThumbs, canUseLoopThumbs, 'ОСНОВНОЙ', 'МИНИАТЮРЫ');
                    }
                }, 500);
            }
        },
    });


    // Синхронизация слайдеров без использования thumbs
    let isSliding = false; // Флаг для предотвращения рекурсивных вызовов
    let syncTimeout = null; // Таймер для отложенной синхронизации
    let userInteracting = false; // Флаг для отслеживания пользовательского взаимодействия
    let lastMainIndex = 0; // Последний известный индекс основного слайдера
    let lastThumbsIndex = 0; // Последний известный индекс слайдера миниатюр
    let finalSyncTimeout = null; // Таймер для финальной синхронизации

    // Функция для синхронизации слайдеров
    function syncSliders(sourceSlider, targetSlider, canUseLoop, sourceName, targetName) {

        if (isSliding) {
            return;
        }

        isSliding = true;
        const realIndex = sourceSlider.realIndex;


        // Очищаем предыдущий таймер
        if (syncTimeout) {
            clearTimeout(syncTimeout);
        }

        // Для слайдера миниатюр используем slideToLoop если loop включен
        if (targetName === 'МИНИАТЮРЫ') {
            if (canUseLoop) {
                targetSlider.slideToLoop(realIndex);
            } else {
                // Проверяем границы для слайдера миниатюр без loop
                const maxIndex = targetSlider.slides.length - 1;
                const safeIndex = Math.min(realIndex, maxIndex);

                targetSlider.slideTo(safeIndex);
            }
        } else {
            // Для основного слайдера используем slideToLoop если loop включен
            if (canUseLoop) {
                targetSlider.slideToLoop(realIndex);
            } else {
                targetSlider.slideTo(realIndex);
            }
        }

        // Для слайдера миниатюр с loop не нужно принудительное обновление
        if (targetName === 'МИНИАТЮРЫ' && canUseLoop) {
            // Разблокируем флаг с задержкой для loop режима
            syncTimeout = setTimeout(() => {
                isSliding = false;
            }, 100); // Увеличиваем задержку для loop режима
        } else {
            // Принудительно обновляем слайдер после синхронизации только для основного слайдера
            setTimeout(() => {
                targetSlider.update();
                targetSlider.updateSlides();
            }, 50);

            // Увеличиваем время блокировки для стабильности
            syncTimeout = setTimeout(() => {
                isSliding = false;
            }, 100);
        }
    }

    // Синхронизация основного слайдера с миниатюрами
    slider.on('slideChange', function () {
        lastMainIndex = this.realIndex;

        // Всегда синхронизируем миниатюры с основным слайдером
        setTimeout(() => {
            syncSliders(this, sliderThumbs, canUseLoopThumbs, 'ОСНОВНОЙ', 'МИНИАТЮРЫ');
        }, 10);

        // Плавно обновляем позицию при переходе к дублированным слайдам
        this.allowSlideNext = true;
        this.allowSlidePrev = true;
    });

    // Слайдер миниатюр НЕ синхронизирует основной - только клики по миниатюрам

    // Обработчик клика по миниатюрам через делегирование событий
    sliderThumbsContainer.addEventListener('click', function(e) {
        const clickedSlide = e.target.closest('.swiper-slide');
        if (clickedSlide) {
            const slideIndex = clickedSlide.getAttribute('data-slide-index');
            if (slideIndex !== null) {
                const index = parseInt(slideIndex);
                if (!isSliding) {
                    isSliding = true;

                    // Сначала прокручиваем превью слайдер к выбранному слайду
                    if (canUseLoopThumbs) {
                        sliderThumbs.slideToLoop(index);
                    } else {
                        sliderThumbs.slideTo(index);
                    }

                    // Затем переключаем основной слайдер
                    if (canUseLoopMain) {
                        slider.slideToLoop(index);
                    } else {
                        slider.slideTo(index);
                    }

                    // Принудительно обновляем слайдеры после клика
                    setTimeout(() => {
                        sliderThumbs.update();
                        slider.update();
                        sliderThumbs.updateSlides();
                        slider.updateSlides();
                    }, 50);

                    // Увеличиваем время блокировки для стабильности
                    setTimeout(() => {
                        isSliding = false;
                    }, 100);
                } else {
                }
            } else {
            }
        } else {
        }
    });

    // Принудительно обновляем слайдеры после инициализации
    setTimeout(() => {
        sliderThumbs.update();
        slider.update();
        sliderThumbs.updateSlides();
        slider.updateSlides();

        // Принудительно включаем навигацию
        sliderThumbs.allowSlideNext = true;
        sliderThumbs.allowSlidePrev = true;
        slider.allowSlideNext = true;
        slider.allowSlidePrev = true;

        // Принудительная синхронизация при инициализации
        const currentMainIndex = slider.realIndex;
        const currentThumbsIndex = sliderThumbs.realIndex;


        // Синхронизируем слайдеры если они не совпадают
        if (currentMainIndex !== currentThumbsIndex) {
            if (canUseLoopThumbs) {
                sliderThumbs.slideToLoop(currentMainIndex);
            } else {
                sliderThumbs.slideTo(currentMainIndex);
            }
        }

        // Проверяем, нужно ли отключить loop после инициализации
        const currentThumbsSlides = sliderThumbsContainer.querySelectorAll('.swiper-slide');
        const currentMainSlides = sliderContainer.querySelectorAll('.swiper-slide');

        if (currentThumbsSlides.length < 4 && sliderThumbs.params.loop) {
            sliderThumbs.destroy(true, true);
            // Переинициализируем без loop
            window.sliderThumbs = new Swiper(sliderThumbsContainer, {
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                spaceBetween: 6,
                centeredSlides: false,
                loop: false,
                rewind: true, // Включаем rewind при отключенном loop
                navigation: {
                    nextEl: '.stylists__slider__btn--prev',
                    prevEl: '.stylists__slider__btn--next',
                },
                speed: 300,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
            });
        }

        if (currentMainSlides.length < 3 && slider.params.loop) {
            slider.destroy(true, true);
            // Переинициализируем без loop
            window.sliderMain = new Swiper(sliderContainer, {
                slidesPerView: 1,
                spaceBetween: 6,
                centeredSlides: true,
                loop: false,
                navigation: {
                    nextEl: '.stylists__slider__btn--prev',
                    prevEl: '.stylists__slider__btn--next',
                },
                speed: 250,
            });
        }
    }, 100);

    // Обработчик изменения размера окна для динамического обновления направления
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const newIsMobile = window.innerWidth < 991;
            if (isMobile !== newIsMobile) {
                // Переинициализируем слайдер с новыми параметрами
                const newInitialSlide = newIsMobile && totalSlides > 0 ? totalSlides - 1 : 0;
                slider.slideTo(newInitialSlide);

                // Обновляем навигацию
                slider.params.navigation.nextEl = newIsMobile ? '.stylists__slider__btn--next' : '.stylists__slider__btn--prev';
                slider.params.navigation.prevEl = newIsMobile ? '.stylists__slider__btn--prev' : '.stylists__slider__btn--next';
                slider.update();
            }
        }, 100);
    });

    // Сохраняем ссылку на слайдер в глобальной области для доступа из других функций
    window.sliderMain = slider;
    window.sliderThumbs = sliderThumbs; // Также сохраняем ссылку на слайдер миниатюр

    return slider;
}

/**
 * @function initQuickSearchCategories
 * @description Инициализирует обработку кликов по категориям в быстром поиске
 */
function initQuickSearchCategories() {
    // Обработка кликов по быстрым поисковым словам
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('quick-search-item')) {
            e.preventDefault();

            const searchTerm = e.target.getAttribute('data-search-term');
            const searchInput = document.getElementById('header_search');

            if (searchTerm && searchInput) {
                // Подставляем термин в строку поиска
                searchInput.value = searchTerm;

                // Фокусируемся на поле ввода
                searchInput.focus();

                // Запускаем поиск только если есть контейнер для результатов
                const searchResults = document.querySelector('.search-results');
                if (searchResults) {
                    const event = new Event('input', { bubbles: true });
                    searchInput.dispatchEvent(event);
                }
            }
        }
    });
}

// Инициализируем обработку категорий при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
    initQuickSearchCategories();
    initSearchClear();
    initAjaxSearch();
    initMobileFiltersAccordion();
    initMobileFilters();
    
    // Инициализация для страницы looks
    if (document.querySelector('.looks-page-content') || document.querySelector('.looks-grid')) {
        initLooksPage();
        
        // Проверяем, находимся ли мы на главной странице
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
        
        // Инициализируем кнопку "Загрузить еще" при первой загрузке страницы
        if (isHomePage) {
            setTimeout(() => {
                initLoadMoreButton();
            }, 100);
        }
        
        // Инициализируем автоподгрузку ТОЛЬКО если НЕ на главной странице
        if (!isHomePage) {
            setTimeout(() => {
                // Сбрасываем флаг инициализации для повторной инициализации
                window.looksAutoLoadInitialized = false;
                // Принудительно инициализируем автоподгрузку для образов
                if (typeof initAutoLoadForLooks === 'function') {
                    initAutoLoadForLooks();
                } else {
                    // Если функция не найдена, инициализируем простую автоподгрузку
                    initSimpleAutoLoadForLooks();
                }
            }, 1000);
        }
    }
    
    // Инициализация автовоспроизведения видео на всех страницах
    initVideoAutoplay();
});

/**
 * @function initLooksPage
 * @description Инициализирует страницу looks
 */
function initLooksPage() {
    // Проверяем, есть ли активная категория на странице
    const activeCategory = document.querySelector('.catalog__category.active');
    const urlParams = new URLSearchParams(window.location.search);
    const categoryParam = urlParams.get('category');
    
    // Если нет активной категории и нет параметра в URL, устанавливаем "женщины" по умолчанию
    if (!activeCategory && !categoryParam) {
        setActiveCategory('zhenshhiny');
    }
    
    // Инициализируем ленивую загрузку видео для существующих элементов
    if (typeof initLazyVideoLoading === 'function') {
        initLazyVideoLoading();
    }
    
    // Инициализируем мобильные фильтры для образов
    if (typeof initLookMobileFilters === 'function') {
        initLookMobileFilters();
    }
}

// Функция для автоматического запуска видео на страницах образов
function initVideoAutoplay() {
    const videos = document.querySelectorAll('video');
    
    
    videos.forEach((video, index) => {
        // Проверяем, не воспроизводится ли видео уже
        if (video.paused && video.readyState >= 3) {
            
            video.play().then(() => {
                
            }).catch(error => {
                
                // Если автовоспроизведение заблокировано, попробуем снова через некоторое время
                setTimeout(() => {
                    video.play().catch(e => {});
                }, 1000);
            });
        }
    });
}

/**
 * @function initMobileFiltersAccordion
 * @description Инициализирует аккордеон для мобильных фильтров
 */
function initMobileFiltersAccordion() {
    const accordionItems = document.querySelectorAll('.mobile-filters__accordion-item');


    accordionItems.forEach(item => {
        const header = item.querySelector('.mobile-filters__accordion-header');
        const content = item.querySelector('.mobile-filters__accordion-content');
        const arrow = item.querySelector('.mobile-filters__accordion-arrow');

        if (header && content && arrow) {
            // Проверяем, не добавлен ли уже обработчик
            if (header.dataset.accordionInitialized) {
                return;
            }

            header.dataset.accordionInitialized = 'true';

            header.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();


                // Закрываем все другие аккордеоны
                accordionItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                        const otherContent = otherItem.querySelector('.mobile-filters__accordion-content');
                        const otherArrow = otherItem.querySelector('.mobile-filters__accordion-arrow');
                        if (otherContent && otherArrow) {
                            otherContent.classList.remove('active');
                            otherArrow.style.transform = 'rotate(0deg)';
                        }
                    }
                });

                // Переключаем текущий аккордеон
                const isActive = item.classList.contains('active');

                if (isActive) {
                    item.classList.remove('active');
                    content.classList.remove('active');
                    arrow.style.transform = 'rotate(0deg)';
                } else {
                    item.classList.add('active');
                    content.classList.add('active');
                    arrow.style.transform = 'rotate(180deg)';
                    // Проверяем содержимое аккордеона
                    const options = content.querySelectorAll('.mobile-filters__options-item');
                }
            });
        }
    });
}

/**
 * @function initMobileFilters
 * @description Инициализирует мобильные фильтры (только дополнительные обработчики)
 */
function initMobileFilters() {
    const mobileFiltersBody = document.querySelector('.mobile-filters__body');
    const mobileFiltersReset = document.querySelector('.mobile-filters__filter-reset');
    const mobileFiltersCloseBtn = document.querySelector('.mobile-filters__close-btn');


    if (mobileFiltersBody) {
        // Обработчик закрытия мобильных фильтров по кнопке "Отмена"
        if (mobileFiltersReset) {
            mobileFiltersReset.addEventListener('click', function(e) {
                e.preventDefault();
                closeMobileFilters(document.querySelector('.catalog__mobile-filters'));
            });
        }

        // Обработчик закрытия мобильных фильтров по кнопке "Закрыть"
        if (mobileFiltersCloseBtn) {
            mobileFiltersCloseBtn.addEventListener('click', function(e) {
                e.preventDefault();
                closeMobileFilters(document.querySelector('.catalog__mobile-filters'));
            });
        }

        // Закрытие при клике вне мобильных фильтров
        mobileFiltersBody.addEventListener('click', function(e) {
            if (e.target === mobileFiltersBody) {
                closeMobileFilters(document.querySelector('.catalog__mobile-filters'));
            }
        });
    }
}

/**
 * @function initSearchClear
 * @description Инициализирует функциональность крестика для очистки поля поиска
 */
function initSearchClear() {
    const searchInput = document.getElementById('header_search');
    const searchClear = document.querySelector('.search-clear');

    if (!searchInput || !searchClear) return;

    // Показываем/скрываем крестик в зависимости от содержимого поля
    function toggleClearButton() {
        if (searchInput.value.trim() !== '') {
            searchClear.style.display = 'flex';
        } else {
            searchClear.style.display = 'none';
        }
    }

    // Обработчик ввода текста
    searchInput.addEventListener('input', toggleClearButton);

    // Обработчик клика по крестику
    searchClear.addEventListener('click', function(e) {
        e.preventDefault();
        searchInput.value = '';
        searchInput.focus();
        searchClear.style.display = 'none';
    });

    // Инициализация при загрузке
    toggleClearButton();
}

/**
 * @function initAjaxSearch
 * @description Инициализирует AJAX поиск
 */
function initAjaxSearch() {
    const searchInput = document.getElementById('header_search');
    const searchResults = document.querySelector('.search-results__list');
    const searchPagination = document.querySelector('.search-results__pagination');
    const searchLoading = document.querySelector('.search-results__loading');
    const searchMainCont = document.querySelector('.search-results');

    if (!searchInput || !searchResults || !searchPagination || !searchLoading) return;

    let searchTimeout;
    let currentPage = 1;
    let currentQuery = '';

    // Обработчик ввода с задержкой
    searchInput.addEventListener('input', function() {
        const query = this.value.trim();

        // Очищаем предыдущий таймер
        clearTimeout(searchTimeout);

        if (query.length < 2) {
            clearSearchResults();
            return;
        }

        // Устанавливаем новый таймер
        searchTimeout = setTimeout(() => {
            performSearch(query, 1);
        }, 500); // Задержка 500мс
    });

    // Функция выполнения поиска
    function performSearch(query, page) {
        // Обновляем текущий запрос и страницу
        currentQuery = query;
        currentPage = page;

        showLoading();

        const formData = new FormData();
        formData.append('action', 'search_content');
        formData.append('query', query);
        formData.append('page', page);
        formData.append('nonce', window.searchAjax.nonce);

        fetch(window.searchAjax.ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            hideLoading();

            // Отладочная информация в консоли
            if (data.success && data.data.debug) {
                console.group('🔍 Search Debug Info');
                console.log('Query:', query);
                console.log('All Results:', data.data.debug.all_results);
                if (data.data.debug.all_results && data.data.debug.all_results.first_10_ids) {
                    console.log('First 10 IDs from all results:', data.data.debug.all_results.first_10_ids);
                }
                console.log('Paginated Results:', data.data.debug.paginated_results);
                if (data.data.debug.paginated_results && data.data.debug.paginated_results.all_ids) {
                    console.log('Paginated IDs:', data.data.debug.paginated_results.all_ids);
                }
                console.log('Pagination:', data.data.debug.pagination);
                if (data.data.debug.all_results && !data.data.debug.all_results.is_sorted) {
                    console.warn('⚠️ Array is NOT sorted correctly!', data.data.debug.all_results.sort_errors);
                } else if (data.data.debug.all_results && data.data.debug.all_results.is_sorted) {
                    console.log('✅ Array is correctly sorted by ID');
                }
                console.groupEnd();
            }

            if (data.success) {
                searchMainCont.classList.remove('empty')
                displaySearchResults(data.data.results, data.data.pagination, data.data.query);
                lazyLoadInstance.update();                
            } else {
                showNoResults();
            }
        })
        .catch(error => {
            hideLoading();
            console.error('Search error:', error);
            showError();
        });
    }

    // Функция отображения информации о результатах
    function displaySearchInfo(totalResults, query) {
        const searchInfo = document.querySelector('.search-results__info');
        if (searchInfo) {
            searchInfo.style.display = 'block';
            searchInfo.textContent = `${totalResults} результатов по запросу: "${query}"`;
        }
    }

    // Функция отображения результатов
    function displaySearchResults(results, pagination, query) {
        // Очищаем предыдущие результаты
        searchResults.innerHTML = '';

        if (results.length === 0) {
            // Показываем сообщение только если нет результатов вообще
            if (pagination.total_results === 0) {
                showNoResults();
            } else {
                // Если есть общие результаты, но на этой странице нет - показываем пустую страницу
                searchResults.innerHTML = '<div style="text-align: center; padding: 40px; color: #666;">На этой странице нет результатов</div>';
            }
        } else {
            // Отображаем информацию о результатах только если есть результаты
            displaySearchInfo(pagination.total_results, query);

            // Создаем элементы результатов
            results.forEach((result, index) => {
                const resultElement = createResultElement(result);
                // Добавляем data-атрибут с ID для отладки
                resultElement.setAttribute('data-result-id', result.id);
                resultElement.setAttribute('data-result-index', index);
                searchResults.appendChild(resultElement);
            });
            
            // Отладочная информация: проверяем порядок элементов на странице
            if (window.console && console.group) {
                const displayedElements = Array.from(searchResults.querySelectorAll('.search-result-item'));
                const displayedIds = displayedElements.map(el => parseInt(el.getAttribute('data-result-id')) || 0);
                console.log('📋 Displayed order on page:', displayedIds);
                console.log('📋 Expected order from array:', results.map(r => parseInt(r.id)));
                
                // Проверяем, совпадает ли порядок
                const expectedIds = results.map(r => parseInt(r.id));
                const isOrderCorrect = JSON.stringify(displayedIds) === JSON.stringify(expectedIds);
                if (!isOrderCorrect) {
                    console.warn('⚠️ ORDER MISMATCH! Elements are displayed in different order than in array!');
                    console.log('Expected:', expectedIds);
                    console.log('Displayed:', displayedIds);
                } else {
                    console.log('✅ Display order matches array order');
                }
            }
        }

        // Создаем пагинацию (всегда, если есть общие результаты)
        if (pagination.total_results > 0) {
            createPagination(pagination);
        }
    }

    // Функция создания элемента результата
    function createResultElement(result) {
        const item = document.createElement('div');
        item.className = 'search-result-item';
        item.onclick = () => window.location.href = result.permalink;

        const typeLabel = result.type === 'product' ? 'Товар' : 'Образ';
        const metaInfo = result.type === 'product' ? result.price : '';

        // Создаем HTML структуру в зависимости от типа
        let priceHtml = '';
        if (result.type === 'product' && metaInfo) {
            priceHtml = `<div class="search-result-item__content__price">${metaInfo}</div>`;
        }

        // Определяем, как отображать медиа (изображение или видео)
        let mediaHtml = '';
        const thumbnailUrl = result.thumbnail || '/wp-content/themes/planetalook/assets/images/placeholder.jpg';
        
        if (result.type === 'look' && result.media_type === 'video') {
            // Для образов с видео используем тег video
            mediaHtml = `
                <video 
                    class="lazy" data-src="${thumbnailUrl}" 
                    autoplay 
                    muted 
                    loop 
                    playsinline 
                    preload="metadata"
                    style="width: 100%; height: 100%; object-fit: cover;"
                >
                    Ваш браузер не поддерживает тег Video.
                </video>
            `;
        } else {
            // Для товаров и образов с изображениями используем тег img
            mediaHtml = `<img class="lazy" data-src="${thumbnailUrl}" alt="${result.title}">`;
        }

        item.innerHTML = `
            <div class="search-result-item__image">
                ${mediaHtml}
            </div>
            <div class="search-result-item__content">
                <div class="search-result-item__content__title">${result.title}</div>
                <div class="search-result-item__content__brand">${result.brand}</div>
                <div class="search-result-item__content__excerpt">${result.excerpt}</div>
                ${priceHtml}
            </div>
        `;

        return item;
    }

    // Функция создания пагинации
    function createPagination(pagination) {
        searchPagination.innerHTML = '';

        if (pagination.total_pages <= 1) return;

        // Кнопка "Предыдущая"
        const prevButton = document.createElement('span');
        prevButton.className = `pagination-item ${pagination.current_page === 1 ? 'disabled' : ''}`;
        prevButton.textContent = '←';
        prevButton.onclick = () => {
            if (pagination.current_page > 1) {
                currentPage = pagination.current_page - 1;
                performSearch(currentQuery, currentPage);
            }
        };
        searchPagination.appendChild(prevButton);

        // Номера страниц
        const startPage = Math.max(1, pagination.current_page - 2);
        const endPage = Math.min(pagination.total_pages, pagination.current_page + 2);

        for (let i = startPage; i <= endPage; i++) {
            const pageButton = document.createElement('span');
            pageButton.className = `pagination-item ${i === pagination.current_page ? 'active' : ''}`;
            pageButton.textContent = i;
            pageButton.onclick = () => {
                currentPage = i;
                performSearch(currentQuery, currentPage);
            };
            searchPagination.appendChild(pageButton);
        }

        // Кнопка "Следующая"
        const nextButton = document.createElement('span');
        nextButton.className = `pagination-item ${pagination.current_page === pagination.total_pages ? 'disabled' : ''}`;
        nextButton.textContent = '→';
        nextButton.onclick = () => {
            if (pagination.current_page < pagination.total_pages) {
                currentPage = pagination.current_page + 1;
                performSearch(currentQuery, currentPage);
            }
        };
        searchPagination.appendChild(nextButton);
    }

    // Вспомогательные функции
    function showLoading() {
        searchLoading.style.display = 'flex';
        searchResults.innerHTML = '';
        searchPagination.innerHTML = '';
    }

    function hideLoading() {
        searchLoading.style.display = 'none';
    }

    function showNoResults() {
        // Скрываем информацию о результатах
        const searchInfo = document.querySelector('.search-results__info');
        if (searchInfo) {
            searchInfo.style.display = 'none';
        }

        searchResults.innerHTML = `
            <div class="item-error">
                <div class="image"><img class="lazy" data-src="/wp-content/themes/planetalook/assets/svg/error.svg" alt="Ошибка" ></div>
                <div class="text">Ничего не найдено</div>
            </div>
        `;
        // Не очищаем пагинацию, так как она может быть нужна
    }

    function showError() {
        searchResults.innerHTML = '<div style="text-align: center; padding: 40px; color: #e74c3c;">Произошла ошибка при поиске</div>';
        searchPagination.innerHTML = '';
    }

    function clearSearchResults() {
        searchResults.innerHTML = '';
        searchPagination.innerHTML = '';
    }
}

// Инициализация Swiper слайдера для товара
document.addEventListener('DOMContentLoaded', function() {
    // Проверяем, есть ли слайдеры на странице
    const mainSlider = document.querySelector('.product-main-slider');
    const thumbsSlider = document.querySelector('.product-thumbs-slider');

    if (mainSlider && thumbsSlider) {
        // Сначала инициализируем слайдер миниатюр
        const thumbsSwiper = new Swiper('.product-thumbs-slider', {
            spaceBetween: 6,
            slidesPerView: 3,
            direction: 'vertical',
            loop: false, // Отключаем loop для миниатюр
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            freeMode: true,
            navigation: {
                nextEl: '.thumbs-next',
                prevEl: '.thumbs-prev',
            },
        });

        // Затем инициализируем основной слайдер с привязкой к миниатюрам
        const mainSwiper = new Swiper('.product-main-slider', {
            spaceBetween: 6,
            loop: false, // Отключаем loop для основного слайдера
            thumbs: {
                swiper: thumbsSwiper,
            },
            navigation: {
                nextEl: '.main-next',
                prevEl: '.main-prev',
            },
        });
    }

    // Инициализация слайдера образов
    const looksSlider = document.querySelector('.looks-slider');
    if (looksSlider) {
        const looksSwiper = new Swiper('.looks-slider', {
            slidesPerView: 4,
            spaceBetween: 6,
            loop: false,
            navigation: {
                nextEl: '.looks-next',
                prevEl: '.looks-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 'auto',
                    spaceBetween: 3,
                },
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 3,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 6,
                }
            }
        });
    }

    // Инициализация слайдеров внутри карточек образов
    if (typeof Swiper !== 'undefined') {
        const lookCardSliders = document.querySelectorAll('.look-card-swiper');
        lookCardSliders.forEach(function(slider) {
            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                allowTouchMove: true,
                autoplay: false
            });
        });
    }

    const similarProductsSlider = document.querySelector('.similar-products-slider');
    if (similarProductsSlider) {
        const similarProductsSwiper = new Swiper('.similar-products-slider', {
            slidesPerView: 4,
            spaceBetween: 6,
            loop: false,
            navigation: {
                nextEl: '.similar-next',
                prevEl: '.similar-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 'auto',
                    spaceBetween: 3,
                },
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 3,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 6,
                }
            }
        });
    }

    // Функциональность "В избранное" для всех элементов
    document.addEventListener('click', function(e) {
        if (e.target.closest('.tool-favorite, .add-to-favorites')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const button = e.target.closest('.tool-favorite, .add-to-favorites');

            // Проверяем, не обрабатывался ли уже этот клик
            if (button.dataset.processing === 'true') {
                return;
            }
            button.dataset.processing = 'true';

            const postId = button.getAttribute('data-id') || button.getAttribute('data-look-id');
            const postType = button.getAttribute('data-type') || 'look';

            if (postId) {
                // Проверяем, находится ли элемент в избранном
                if (isInFavorites(postId, postType)) {
                    // Если элемент в избранном, показываем подтверждение удаления
                    if(document.querySelector('.favorites-grid')){
                        if (confirm('Удалить из избранного?')) {
                            removeFromFavorites(postId, postType);
                            button.classList.remove('active', 'isInFavorites');

                            // Если мы на странице избранного, удаляем элемент из DOM
                            if (document.querySelector('.favorites-grid')) {
                                const favoritesItem = button.closest('.favorites-item');
                                if (favoritesItem) {
                                    favoritesItem.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                                    favoritesItem.style.opacity = '0';
                                    favoritesItem.style.transform = 'scale(0.8)';

                                    setTimeout(() => {
                                        favoritesItem.remove();

                                        // Проверяем, есть ли еще элементы в текущем фильтре
                                        const remainingItems = document.querySelectorAll('.favorites-item');
                                        if (remainingItems.length === 0) {
                                            const favoritesGrid = document.querySelector('.favorites-grid');
                                            const currentFilter = document.querySelector('.filter-item.active');
                                            let type = 'product';
                                            if (currentFilter && currentFilter.textContent.includes('Готовые образы')) {
                                                type = 'look';
                                            }

                                            if (type === 'product') {
                                                favoritesGrid.innerHTML = '<div class="favorites-empty"><p>В избранном нет товаров</p></div>';
                                            } else {
                                                favoritesGrid.innerHTML = '<div class="favorites-empty"><p>В избранном нет образов</p></div>';
                                            }
                                        }
                                    }, 300);
                                }
                            }
                        }
                    }else{
                        removeFromFavorites(postId, postType);
                        button.classList.remove('active', 'isInFavorites');
                    }
                } else {
                    // Если элемент не в избранном, добавляем его
                    addToFavorites(postId, postType);
                    button.classList.add('active', 'isInFavorites');
                }
            }

            // Сбрасываем флаг обработки
            setTimeout(() => {
                button.dataset.processing = 'false';
            }, 100);
        }
    });

    // Инициализация фильтров товаров, если мы на странице каталога товаров
    // Проверяем также наличие элементов на странице
    const hasCatalogList = isExist('.catalog-list');
    const hasProductsGrid = isExist('.products-grid');
    const hasPageType = document.body.classList.contains('post-type-archive-product') ||
                       document.body.classList.contains('tax-product_category');
    
    if ((hasPageType || (hasCatalogList && hasProductsGrid)) && hasCatalogList && hasProductsGrid) {
        initProductFilters();
    }
});

// Флаги объявлены в начале файла

/**
 * @function initProductFilters
 * @description Инициализирует фильтры для страницы товаров
 */
function initProductFilters() {
    
    // Для страниц образов НЕ инициализируем фильтры товаров
    const hasCatalogList = isExist('.catalog-list');
    const hasProductsGrid = isExist('.products-grid');
    
    if (!hasCatalogList || !hasProductsGrid) {
        return;
    }
    
    // Проверяем, не была ли уже выполнена инициализация
    if (productFiltersInitialized) {
        // НЕ выходим полностью - нужно инициализировать обработчики событий
    } else {
        productFiltersInitialized = true;
        
        // Инициализируем текст триггеров по умолчанию
        initProductFilterTriggers();

        // Загружаем данные фильтров товаров через AJAX
        loadProductFilterData();
    }

    // Инициализируем обработчики событий для фильтров товаров (всегда)
    initProductFilterEventHandlers();

    // Инициализируем сортировку (всегда)
    initProductSorting();

    // Инициализируем кнопку "Загрузить еще" и автоподгрузку (всегда)
    initLoadMoreButton();

    // НЕ восстанавливаем состояние фильтров здесь - это будет сделано в loadProductFilterData()
    // после создания элементов фильтров
    
    // НЕ выполняем фильтрацию здесь - это будет сделано после загрузки данных и восстановления состояния
    // const urlParams = new URLSearchParams(window.location.search);
    // const hasProductFilters = urlParams.has('category') ||
    //                          urlParams.has('filterClothing') ||
    //                          urlParams.has('filterShoes') ||
    //                          urlParams.has('filterAccessories') ||
    //                          urlParams.has('filterProduct_brand') ||
    //                          urlParams.has('orderby');

    // if (hasProductFilters) {
    //     setTimeout(() => {
    //         performProductAjaxFilter();
    //     }, 150);
    // }
}

/**
 * @function initProductFilterTriggers
 * @description Инициализирует текст триггеров фильтров по умолчанию
 */
function initProductFilterTriggers() {
    const filterNames = ['clothing_filter', 'shoes_filter', 'accessories_filter', 'product_brand_filter'];

    filterNames.forEach(filterName => {
        const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
        if (customSelect) {
            const valueElement = customSelect.querySelector('.custom-select__value');
            if (valueElement) {
                const filterLabel = getFilterLabel(filterName);
                // Показываем счетчик для всех фильтров кроме радиокнопок категорий
                const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');
                if (!isCategoryFilter) {
                    valueElement.textContent = `${filterLabel} (0)`;
                } else {
                    valueElement.textContent = filterLabel;
                }
            }
        }
    });

    // Инициализируем селект сортировки
    initSortingSelect();

    // Инициализируем кнопку "Загрузить еще"
    initLoadMoreButton();
}

/**
 * @function initSortingSelect
 * @description Инициализирует селект сортировки по умолчанию
 */
function initSortingSelect() {
    const sortingSelect = document.querySelector('[data-sort="price"]');
    if (sortingSelect) {
        const valueElement = sortingSelect.querySelector('.custom-select__value');
        if (valueElement) {
            // Устанавливаем текст по умолчанию
            valueElement.textContent = 'Сначала дешевле';
        }
    }
}

/**
 * @function initLoadMoreButtonForNewButton
 * @description Инициализирует обработчик клика для конкретной кнопки "Загрузить еще"
 * @param {HTMLElement} button - кнопка для инициализации
 */
function initLoadMoreButtonForNewButton(button) {
    if (!button) return;
    
    // Удаляем старые обработчики если есть
    const oldHandler = button._loadMoreClickHandler;
    if (oldHandler) {
        button.removeEventListener('click', oldHandler, true);
        button.removeEventListener('click', oldHandler, false);
    }
    button.removeEventListener('click', handleLoadMoreClick);
    
    // Создаем новый обработчик с привязкой
    const clickHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        handleLoadMoreClick.call(button, e);
    };
    
    // Сохраняем ссылку на обработчик для возможности удаления
    button._loadMoreClickHandler = clickHandler;
    
    // Добавляем обработчик с capture фазой для приоритета
    button.addEventListener('click', clickHandler, true);
    
    // Также добавляем обычный обработчик
    button.addEventListener('click', clickHandler, false);
}

/**
 * @function handleLoadMoreClick
 * @description Обработчик клика по кнопке "Загрузить еще"
 */
function handleLoadMoreClick(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    // Проверяем, находимся ли мы на главной странице
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
    const urlParams = new URLSearchParams(window.location.search);
    const hasCategoryParam = urlParams.has('category');
    
    // Определяем тип страницы по наличию элементов
    if (isExist('.products-grid')) {
        // Страница товаров
        loadMoreProducts();
    } else if (isExist('.looks-grid')) {
        // Страница образов
        // На главной странице используем loadMoreLooks (кнопка), на остальных - loadMoreLooksInfinite (автоподгрузка)
        if (isHomePage) {
            loadMoreLooks();
        } else {
            loadMoreLooksInfinite();
        }
    }
}

/**
 * @function initLoadMoreButton
 * @description Инициализирует кнопку "Загрузить еще"
 */
function initLoadMoreButton() {
    const loadMoreBtn = document.querySelector('.load-more-btn');
    if (loadMoreBtn) {
        // Используем новый обработчик
        initLoadMoreButtonForNewButton(loadMoreBtn);

        // Проверяем, нужно ли скрыть кнопку при инициализации (с задержкой для обновления DOM)
        setTimeout(() => {
            const looksGrid = document.querySelector('.looks-grid');
            const productsGrid = document.querySelector('.products-grid');

            // Определяем, находимся ли мы на главной странице
            const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
            const urlParams = new URLSearchParams(window.location.search);
            const hasCategoryParam = urlParams.has('category');
            
            // Определяем, находимся ли мы на архивных страницах
            const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                                 document.body.classList.contains('tax-product_category') ||
                                 document.body.classList.contains('post-type-archive-look') ||
                                 document.body.classList.contains('tax-look_category') ||
                                 window.location.pathname.includes('/catalog') ||
                                 window.location.pathname.includes('/looks');
            
            

            if (looksGrid) {
                const totalItems = document.querySelectorAll('.look-item').length;
                
                // На главной странице используем данные из looks-list, на других - из looks-grid
                let totalAvailable = 0;
                if (isHomePage) {
                    const looksList = document.querySelector('.looks-list');
                    totalAvailable = looksList ? parseInt(looksList.getAttribute('data-total')) || 0 : 0;
                } else {
                    totalAvailable = parseInt(looksGrid.getAttribute('data-total')) || 0;
                }
                
                const currentPage = parseInt(loadMoreBtn.dataset.page) || 2;
                const totalPages = parseInt(loadMoreBtn.dataset.totalPages) || 1;

                

                // Кнопка "Загрузить еще" показывается ТОЛЬКО на главной странице (с категорией или без)
                if (isHomePage && !isArchivePage) {
                    // На главной странице показываем кнопку только если есть еще образы для загрузки
                    // Используем > вместо >=, чтобы загрузить последнюю страницу
                    if (currentPage > totalPages) {
                        loadMoreBtn.style.display = 'none';
                        // Также скрываем контейнер
                        const loadMoreContainer = document.querySelector('.load-more-container');
                        if (loadMoreContainer) {
                            loadMoreContainer.style.display = 'none';
                        }
                    } else if (totalAvailable > 0 && totalItems >= totalAvailable) {
                        loadMoreBtn.style.display = 'none';
                        // Также скрываем контейнер
                        const loadMoreContainer = document.querySelector('.load-more-container');
                        if (loadMoreContainer) {
                            loadMoreContainer.style.display = 'none';
                        }
                    } else {
                        // Показываем кнопку на главной странице
                        loadMoreBtn.style.display = 'block';
                        // Показываем контейнер
                        const loadMoreContainer = document.querySelector('.load-more-container');
                        if (loadMoreContainer) {
                            loadMoreContainer.style.display = 'flex';
                        }
                    }
                } else {
                    // На архивных страницах и других страницах (не главная) скрываем кнопку и включаем автоподгрузку
                    
                    loadMoreBtn.style.display = 'none';
                    
                    // Скрываем контейнер на архивных страницах
                    const loadMoreContainer = document.querySelector('.load-more-container');
                    if (loadMoreContainer) {
                        loadMoreContainer.style.display = 'none';
                    }
                    
                    // Инициализируем автоподгрузку для архивных страниц и страниц категорий
                    
                    initAutoLoadForCategory();
                }
            } else if (productsGrid) {
                const totalItems = document.querySelectorAll('.product-item').length;
                const totalAvailable = parseInt(productsGrid.dataset.total) || 0;

                // На архивных страницах товаров всегда скрываем кнопку и включаем автоподгрузку
                if (isArchivePage) {
                    
                    loadMoreBtn.style.display = 'none';
                    
                    // Скрываем контейнер на архивных страницах
                    const loadMoreContainer = document.querySelector('.load-more-container');
                    if (loadMoreContainer) {
                        loadMoreContainer.style.display = 'none';
                    }
                    
                    // Инициализируем автоподгрузку для архивных страниц товаров
                    initAutoLoadForCategory();
                } else if (totalItems >= totalAvailable && totalAvailable > 0) {
                    loadMoreBtn.style.display = 'none';
                } else {
                    // Показываем кнопку на не-архивных страницах товаров
                    loadMoreBtn.style.display = 'block';
                }
            }
        }, 200); // Задержка для инициализации DOM
    }

    // Инициализируем автопрогрузку при прокрутке только на страницах, которые НЕ являются главной
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
    const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                         document.body.classList.contains('tax-product_category') ||
                         document.body.classList.contains('post-type-archive-look') ||
                         document.body.classList.contains('tax-look_category') ||
                         window.location.pathname.includes('/catalog') ||
                         window.location.pathname.includes('/looks');
    
    if (!isHomePage || isArchivePage) {
        initInfiniteScroll();
    }
}

/**
 * @function loadMoreProducts
 * @description Загружает дополнительные товары
 */
function loadMoreProducts() {
    // Проверяем, не выполняется ли уже запрос
    if (isAjaxLoading) {
        return;
    }

    const loadMoreBtn = document.querySelector('.load-more-btn');
    if (!loadMoreBtn) return;

    const currentPage = parseInt(loadMoreBtn.dataset.page) || 2;
    const totalPages = parseInt(loadMoreBtn.dataset.totalPages) || 1;

    if (currentPage > totalPages) return;

    // Устанавливаем флаг загрузки
    isAjaxLoading = true;

    // Показываем индикатор загрузки
    showProductLoadingIndicator();

    // Собираем все активные фильтры из URL
    const urlParams = new URLSearchParams(window.location.search);
    const filterData = {};

    // Обрабатываем основной параметр категории товара
    const categoryValue = urlParams.get('category');
    if (categoryValue) {
        filterData['product_category_slug'] = categoryValue;
    } else {
        // НЕ устанавливаем fallback категорию автоматически - это вызывает двойную загрузку
        // filterData['product_category_slug'] = 'zhenshhiny';
    }

    // Получаем параметры фильтров с префиксом "filter"
    const filterParams = ['filterClothing', 'filterShoes', 'filterAccessories'];
    for (const param of filterParams) {
        const value = urlParams.get(param);
        if (value) {
            const baseParam = param.replace('filter', '').toLowerCase();
            const termSlug = getTermSlugById(value);
            if (termSlug) {
                filterData[baseParam + '_slug'] = termSlug;
            }
        }
    }

    // Обрабатываем параметр бренда
    const brandValue = urlParams.get('filterProduct_brand');
    if (brandValue) {
        const brandSlug = getTermSlugById(brandValue);
        if (brandSlug) {
            filterData['product_brand_slug'] = brandSlug;
        }
    }

    // Обрабатываем параметр сортировки
    const orderbyValue = urlParams.get('orderby');
    if (orderbyValue && orderbyValue !== 'default') {
        filterData['orderby'] = orderbyValue;
    }
    // Если нет параметра или "default", не добавляем orderby - будет сортировка по умолчанию

    // Добавляем номер страницы
    filterData['page'] = currentPage;

    // Подготавливаем данные для запроса
    const requestData = {
        action: 'load_filtered_products',
        nonce: productAjax.loadNonce,
        ...filterData
    };

    // Выполняем AJAX запрос
    fetch(productAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(requestData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            appendProductsContent(data.data);
            updateLoadMoreButton(currentPage + 1, data.data.pages);

            // Проверяем, нужно ли скрыть кнопку для товаров (с задержкой для обновления DOM)
            setTimeout(() => {
                const totalItems = document.querySelectorAll('.product-item').length;
                const totalAvailable = data.data.total;

                if (totalItems >= totalAvailable) {
                    const loadMoreBtn = document.querySelector('.load-more-btn');
                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = 'none';
                    } else {
                    }
                } else {
                }
            }, 100); // Небольшая задержка для обновления DOM
        } else {
            showProductErrorMessage('Ошибка при загрузке товаров');
        }
    })
    .catch(error => {
        console.error('Ошибка AJAX запроса для товаров:', error);
        showProductErrorMessage('Произошла ошибка при загрузке товаров');
    })
    .finally(() => {
        hideProductLoadingIndicator();
        // Сбрасываем флаг загрузки
        isAjaxLoading = false;
    });
}

/**
 * @function appendProductsContent
 * @description Добавляет новый контент к существующему
 */
function appendProductsContent(data) {
    const productsGrid = document.querySelector('.products-grid');
    if (productsGrid && data.html) {
        productsGrid.insertAdjacentHTML('beforeend', data.html);

        // Инициализируем кнопки избранного для нового контента
        if (typeof initFavoritesButtons === 'function') {
            initFavoritesButtons();
        }

        // Инициализируем большие карточки для нового контента
        if (typeof initBigItemCards === 'function') {
            initBigItemCards(); // Пересчитываем все позиции после добавления новых элементов
        }
    }
}

/**
 * @function updateLoadMoreButton
 * @description Обновляет состояние кнопки "Загрузить еще"
 */
function updateLoadMoreButton(nextPage, totalPages) {
    const loadMoreBtn = document.querySelector('.load-more-btn');
    
    // Определяем, находимся ли мы на главной странице
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
    const urlParams = new URLSearchParams(window.location.search);
    const hasCategoryParam = urlParams.has('category');
    
    // Определяем, находимся ли мы на архивных страницах
    const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                         document.body.classList.contains('tax-product_category') ||
                         document.body.classList.contains('post-type-archive-look') ||
                         document.body.classList.contains('tax-look_category') ||
                         window.location.pathname.includes('/catalog') ||
                         window.location.pathname.includes('/looks');

    // Обновляем данные кнопки, если она существует
    if (loadMoreBtn) {
        loadMoreBtn.dataset.page = nextPage;
    }
    
    // На архивных страницах обновляем данные в looks-list
    if (isArchivePage) {
        const looksList = document.querySelector('.looks-list');
        if (looksList) {
            looksList.dataset.currentPage = nextPage;
            
        }
    }
    
    // Если нет кнопки и не архивная страница, выходим
    if (!loadMoreBtn && !isArchivePage) {
        return;
    }

    if (nextPage > totalPages) {
        // Скрываем кнопку, если больше нет страниц
        // Используем > вместо >=, чтобы загрузить последнюю страницу
        const loadMoreContainer = document.querySelector('.load-more-container');
        if (loadMoreContainer) {
            loadMoreContainer.style.display = 'none';
        }
        if (loadMoreBtn) {
            loadMoreBtn.style.display = 'none';
        }
    } else if (isHomePage && !hasCategoryParam) {
        // На главной странице показываем кнопку, если есть еще страницы
        const loadMoreContainer = document.querySelector('.load-more-container');
        if (loadMoreContainer) {
            loadMoreContainer.style.display = 'flex';
        }
        loadMoreBtn.style.display = 'block';
    } else {
        // На других страницах показываем контейнер, если есть еще страницы
        const loadMoreContainer = document.querySelector('.load-more-container');
        if (loadMoreContainer && nextPage < totalPages) {
            loadMoreContainer.style.display = 'flex';
        }
    }
}

/**
 * @function resetLoadMoreButtonState
 * @description Сбрасывает состояние кнопки "Загрузить еще" при смене категории
 */
function resetLoadMoreButtonState() {
    const loadMoreBtn = document.querySelector('.load-more-btn');
    const loadMoreContainer = document.querySelector('.load-more-container');

    // Определяем тип страницы
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
    const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                         document.body.classList.contains('tax-product_category') ||
                         document.body.classList.contains('post-type-archive-look') ||
                         document.body.classList.contains('tax-look_category') ||
                         window.location.pathname.includes('/catalog') ||
                         window.location.pathname.includes('/looks');

    if (loadMoreBtn) {
        // Сбрасываем данные кнопки на начальные значения
        loadMoreBtn.dataset.page = '2';
        loadMoreBtn.dataset.totalPages = '1';

        // На архивных страницах скрываем кнопку, на главной - показываем
        if (isArchivePage) {
            loadMoreBtn.style.display = 'none';
        } else if (isHomePage) {
            loadMoreBtn.style.display = 'block';
        }
    }

    if (loadMoreContainer) {
        // На архивных страницах скрываем контейнер, на главной - показываем
        if (isArchivePage) {
            loadMoreContainer.style.display = 'none';
        } else if (isHomePage) {
            loadMoreContainer.style.display = 'flex';
            loadMoreContainer.style.visibility = 'visible';
        }
    }

    // Сбрасываем данные в products-list если есть
    const productsList = document.querySelector('.products-list');
    if (productsList) {
        productsList.setAttribute('data-current-page', '1');
    }

    // Сбрасываем флаг загрузки
    isAjaxLoading = false;

    // Сбрасываем флаг инициализации автоподгрузки для переинициализации
    window.categoryAutoLoadInitialized = false;
}


/**
 * @function loadMoreLooks
 * @description Загружает дополнительные образы
 */
function loadMoreLooks() {
    

    // Проверяем, не выполняется ли уже запрос
    if (isAjaxLoading) {
        console.log('⚠️ loadMoreLooks: запрос уже выполняется, пропускаем');
        return;
    }

    // Устанавливаем флаг загрузки
    isAjaxLoading = true;
    console.log('🔄 loadMoreLooks: начинаем загрузку, флаг установлен');

    const loadMoreBtn = document.querySelector('.load-more-btn');
    
    // Определяем, находимся ли мы на архивных страницах
    const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                         document.body.classList.contains('tax-product_category') ||
                         document.body.classList.contains('post-type-archive-look') ||
                         document.body.classList.contains('tax-look_category') ||
                         window.location.pathname.includes('/catalog') ||
                         window.location.pathname.includes('/looks');

    if (!loadMoreBtn && !isArchivePage) {
        console.error('Load more button not found!');
        return;
    }
    
    // На архивных страницах используем данные из looks-list
    let currentPage, totalPages, totalAvailable;
    
    if (isArchivePage && !loadMoreBtn) {
        const looksList = document.querySelector('.looks-list');
        
        
        if (looksList) {
            currentPage = parseInt(looksList.dataset.currentPage) || 1;
            totalPages = parseInt(looksList.dataset.pages) || 1;
            totalAvailable = parseInt(looksList.dataset.total) || 0;
            
        } else {
            console.error('loadMoreLooks: No looks-list found on archive page');
            return;
        }
    } else if (loadMoreBtn) {
        currentPage = parseInt(loadMoreBtn.dataset.page) || 2;
        totalPages = parseInt(loadMoreBtn.dataset.totalPages) || 1;
        totalAvailable = parseInt(loadMoreBtn.dataset.totalAvailable) || 0;
        
    } else {
        console.error('loadMoreLooks: No data source found');
        return;
    }

    // Устанавливаем флаг загрузки
    isAjaxLoading = true;

    // Проверяем, есть ли еще страницы для загрузки
    // Используем >= вместо >, чтобы загрузить последнюю страницу
    if (currentPage > totalPages) {
        isAjaxLoading = false;
        return;
    }

    // Показываем прелоадер
    const looksGrid = document.querySelector('.looks-grid');
    if (looksGrid) {
        showLoadingOverlay(looksGrid);
    }

    // Собираем все активные фильтры из URL
    const filterData = getAllActiveFilters();
    console.log('🔍 loadMoreLooks - активные фильтры:', filterData);
    console.log('🔍 loadMoreLooks - категория:', filterData.look_category_slug);

    // Используем пагинацию для всех страниц
    filterData.page = currentPage;
    // На мобильной версии загружаем 19 образов, на десктопе - 18
    filterData.posts_per_page = isMobile() ? 19 : 18;

    // Убираем логику с loaded_ids - используем только пагинацию
    // const loadedIds = new Set();
    // if (looksGrid) {
    //     const lookItems = looksGrid.querySelectorAll('.look-item[data-id]');
    //     lookItems.forEach(item => {
    //         const id = item.getAttribute('data-id');
    //         if (id) {
    //             loadedIds.add(id);
    //         }
    //     });
    // }
    // if (loadedIds.size === 0) {
    //     const globalItems = document.querySelectorAll('.look-item[data-id]');
    //     globalItems.forEach(item => {
    //         const id = item.getAttribute('data-id');
    //         if (id) {
    //             loadedIds.add(id);
    //         }
    //     });
    // }
    // const loadedIdsArray = Array.from(loadedIds);
    // if (loadedIdsArray.length > 0) {
    //     filterData.loaded_ids = loadedIdsArray.join(',');
    // }


    // Подготавливаем данные для запроса
    const requestData = {
        action: 'load_more_looks',
        nonce: looksAjax.nonce,
        page: currentPage,
        ...filterData
    };
    
    console.log('📤 loadMoreLooks - отправляем запрос:', requestData);

    
    

    // Выполняем AJAX запрос
    fetch(looksAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(requestData)
    })
    .then(response => {
        console.log('📥 loadMoreLooks - получен ответ:', response);
        return response.json();
    })
    .then(data => {
        console.log('📊 loadMoreLooks - данные ответа:', data);
        if (data.success) {
            
            
            
            try {
                console.log('🔄 loadMoreLooks - вызываем appendLooksContent с данными:', data.data);
                appendLooksContent(data.data);
                console.log('✅ loadMoreLooks - appendLooksContent завершена');
            } catch (error) {
                console.error('❌ loadMoreLooks: Error in appendLooksContent:', error);
            }
            updateLoadMoreButton(currentPage + 1, data.data.pages);

            // Проверяем, нужно ли скрыть кнопку для образов (с задержкой для обновления DOM)
            setTimeout(() => {
                const totalItems = document.querySelectorAll('.look-item').length;
                const totalAvailable = data.data.total;

                if (totalItems >= totalAvailable) {
                    const loadMoreBtn = document.querySelector('.load-more-btn');
                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = 'none';
                    } else {
                    }
                } else {
                }
            }, 100); // Небольшая задержка для обновления DOM
        } else {
            console.error('AJAX Error:', data);
            showErrorMessage('Ошибка при загрузке образов');
        }
    })
    .catch(error => {
        console.error('loadMoreLooks: AJAX Error:', error);
        showErrorMessage('Произошла ошибка при загрузке образов');
    })
    .finally(() => {
        
        // Скрываем прелоадер на всякий случай
        const looksGrid = document.querySelector('.looks-grid');
        if (looksGrid) {
            hideLoadingOverlay(looksGrid);
        }
        // Сбрасываем флаг загрузки
        isAjaxLoading = false;
        console.log('✅ loadMoreLooks: загрузка завершена, флаг сброшен');
        lazyLoadInstance.update();
    });
}

/**
 * @function appendLooksContent
 * @description Добавляет новый контент образов к существующему
 */
function appendLooksContent(data) {
    
    
    const looksGrid = document.querySelector('.looks-grid');
    
    

    if (looksGrid && data.html && data.html.trim() !== '') {
        

        // Получаем ID уже загруженных образов
        const existingIds = Array.from(document.querySelectorAll('.look-item')).map(item => 
            item.dataset.id
        ).filter(id => id);
        
        // Создаем временный контейнер для нового контента
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data.html;
        
        // Получаем ID новых элементов
        const newElementsAll = Array.from(tempDiv.querySelectorAll('.look-item'));
        const newIds = newElementsAll.map(item => item.dataset.id).filter(id => id);
        
        
        
        
        // Упрощенная фильтрация дубликатов
        const newElements = newElementsAll.filter(item => {
            const itemId = item.dataset.id;
            if (!itemId) {
                return false;
            }
            
            // Проверяем только по ID - этого достаточно
            if (existingIds.includes(itemId)) {
                return false;
            }
            
            return true;
        });
        
        
        // Добавляем только новые элементы
        console.log('🔍 appendLooksContent - новые элементы:', newElements.length);
        console.log('🔍 appendLooksContent - существующие ID:', existingIds);
        console.log('🔍 appendLooksContent - новые ID:', newIds);
        
        if (newElements.length > 0) {
            const newContent = newElements.map(el => el.outerHTML).join('');
            console.log('✅ appendLooksContent - добавляем контент:', newContent.length, 'символов');
            looksGrid.insertAdjacentHTML('beforeend', newContent);
        } else {
            console.log('⚠️ appendLooksContent - нет новых элементов для добавления');
        }
        
        
        // Скрываем прелоадер после успешного добавления контента
        hideLoadingOverlay(looksGrid);

        // Инициализируем большие карточки для нового контента
        if (typeof initBigItemCards === 'function') {
            initBigItemCards(); // Пересчитываем все позиции после добавления новых элементов
        }

        // Инициализируем слайдеры для новых карточек образов
        if (typeof Swiper !== 'undefined') {
            const newLookCardSliders = looksGrid.querySelectorAll('.look-card-swiper:not(.swiper-initialized)');
            newLookCardSliders.forEach(function(slider) {
                new Swiper(slider, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: false,
                    allowTouchMove: true,
                    autoplay: false
                });
            });
        }

        // Инициализируем ленивую загрузку видео для новых элементов
        if (typeof initLazyVideoLoading === 'function') {
            initLazyVideoLoading();
        }

        // Инициализируем автовоспроизведение видео для новых элементов
        if (typeof initVideoAutoplay === 'function') {
            initVideoAutoplay();
        }

        // НЕ инициализируем автоподгрузку на главной странице - там должна работать только кнопка
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
        const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                             document.body.classList.contains('tax-product_category') ||
                             document.body.classList.contains('post-type-archive-look') ||
                             document.body.classList.contains('tax-look_category') ||
                             window.location.pathname.includes('/catalog') ||
                             window.location.pathname.includes('/looks');
        
        // На главной странице (не архивной) НЕ инициализируем автоподгрузку
        if (!isHomePage || isArchivePage) {
            // Только на не-главных страницах или архивных страницах инициализируем автоподгрузку
            setTimeout(() => {
                if (typeof initSimpleAutoLoadForLooks === 'function') {
                    initSimpleAutoLoadForLooks();
                }
            }, 100);
        }
    } else if (data.html && data.html.trim() === '') {
        // Скрываем кнопку, если нет больше элементов
        const loadMoreBtn = document.querySelector('.load-more-btn');
        if (loadMoreBtn) {
            // Проверяем, находимся ли мы на главной странице
            const isHomePage = document.querySelector('.looks-grid') !== null;
            
            // На главной странице не скрываем кнопку, если есть еще страницы
            if (!isHomePage) {
                loadMoreBtn.style.display = 'none';
            }
        }
    } else {
    }
    
    // НОВАЯ СИСТЕМА: Простая логика без блокировки
}

/**
 * @function updateFiltersForParentCategory
 * @description Обновляет фильтры при смене родительской категории
 * @param {string} parentCategorySlug - slug родительской категории
 */
function updateFiltersForParentCategory(parentCategorySlug) {
    
    
    
    
    
    // Для страниц образов НЕ обновляем фильтры, так как они одинаковые
    if (!isExist('.catalog-list') || !isExist('.products-grid')) {
        
        // Защита от выполнения запросов при сбросе фильтров
        if (window.isClearingFilters) {
            window.categoryClickInProgress = false;
            return;
        }
        
        // Просто обновляем URL и активную категорию
        updateUrlParameter('category', parentCategorySlug);
        updateActiveFilter(parentCategorySlug);
        
        // Загружаем образы для новой категории
        const filterData = getAllActiveFilters();
        filterData.look_category_slug = parentCategorySlug;
        performAjaxFilter(filterData);
        lazyLoadInstance.update();
        
        // Сбрасываем флаг обработки клика для страниц образов
        window.categoryClickInProgress = false;
        return;
    }

    // Проверяем, не выполняется ли уже обновление для этой категории
    if (window.updatingFiltersFor === parentCategorySlug) {
        
        return;
    }
    
    // Устанавливаем флаг обновления
    window.updatingFiltersFor = parentCategorySlug;

    // Проверяем, есть ли объект для AJAX запросов товаров
    if (typeof productAjax === 'undefined') {
        console.warn('productAjax object not found. Cannot update filters.');
        window.updatingFiltersFor = null; // Сбрасываем флаг
        return;
    }

    // Сначала сбрасываем все фильтры и обновляем URL с новой категорией
    clearSubcategoryFilters(parentCategorySlug);

    // Показываем индикатор загрузки
    const filterContainers = document.querySelectorAll('.catalog__filters-options, .mobile-filters__options');
    filterContainers.forEach(container => {
        container.innerHTML = '<div style="text-align: center; padding: 20px;">Загрузка...</div>';
    });

    // Загружаем новые данные фильтров
    fetch(productAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'get_product_filter_data',
            nonce: productAjax.filterNonce,
            parent_category: parentCategorySlug
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            
            
            // Обновляем фильтры только для страниц товаров, для образов оставляем текущие
            if (isExist('.catalog-list') && isExist('.products-grid')) {
                // Для страниц товаров
                populateProductFilterSelects(data.data);
                updateProductUrlParameter('category', parentCategorySlug);
            } else {
                // Для страниц образов - НЕ обновляем фильтры, оставляем текущие
                updateUrlParameter('category', parentCategorySlug);
            }

            // Обновляем активный фильтр визуально
            updateActiveFilter(parentCategorySlug);

            // Увеличиваем задержку, чтобы URL успел обновиться
            setTimeout(() => {
                

                // Проверяем тип страницы и используем правильную функцию
                if (isExist('.catalog-list') && isExist('.products-grid')) {
                    // Для страниц товаров
                    performProductAjaxFilter();
                } else {
                    // Для страниц образов
                    const filterData = getAllActiveFilters();
                    filterData.look_category_slug = parentCategorySlug;
                    performAjaxFilter(filterData);
                }

                
            }, 200);
        } else {
            console.error('Ошибка обновления фильтров:', data);
        }
        
        // Сбрасываем флаги обновления
        window.updatingFiltersFor = null;
        window.categoryClickInProgress = false;
    })
    .catch(error => {
        console.error('Ошибка AJAX запроса для обновления фильтров:', error);
        // Сбрасываем флаги обновления при ошибке
        window.updatingFiltersFor = null;
        window.categoryClickInProgress = false;
    });
}

/**
 * @function clearSubcategoryFilters
 * @description Сбрасывает выбранные подкатегории и обновляет товары
 * @param {string} newCategory - новая категория для установки в URL
 */
function clearSubcategoryFilters(newCategory = null) {
    

    // Подсчитываем количество элементов для сброса
    const subcategoryCheckboxes = document.querySelectorAll('.catalog__filters-options input[type="checkbox"]');
    const subcategoryRadios = document.querySelectorAll('.catalog__filters-options input[type="radio"]');
    const mobileCheckboxes = document.querySelectorAll('.mobile-filters__options input[type="checkbox"]');
    const mobileRadios = document.querySelectorAll('.mobile-filters__options input[type="radio"]');


    // Сбрасываем все чекбоксы подкатегорий
    subcategoryCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
    });

    // Сбрасываем все радиокнопки подкатегорий
    subcategoryRadios.forEach(radio => {
        radio.checked = false;
    });

    // Сбрасываем все мобильные фильтры
    mobileCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
    });

    // Сбрасываем все мобильные радиокнопки
    mobileRadios.forEach(radio => {
        radio.checked = false;
    });

    // Сбрасываем текст триггеров фильтров
    const filterTriggers = document.querySelectorAll('.custom-select[data-filter] .custom-select__trigger');
    filterTriggers.forEach(trigger => {
        trigger.classList.remove('has-selection');
        const customSelect = trigger.closest('.custom-select');
        if (customSelect) {
            customSelect.classList.remove('filtered');

            // Сбрасываем текст в value элементе
            const valueElement = customSelect.querySelector('.custom-select__value');
            if (valueElement) {
                const filterName = customSelect.getAttribute('data-filter');
                const filterLabel = getFilterLabel(filterName);
                valueElement.textContent = filterLabel;
            }
        }
    });

    // Сбрасываем URL параметры подкатегорий и обновляем категорию
    const urlParams = new URLSearchParams(window.location.search);
    
    

    // Очищаем все параметры фильтров (включая старый и новый формат)
    urlParams.delete('clothing');
    urlParams.delete('shoes');
    urlParams.delete('accessories');
    urlParams.delete('brand');
    urlParams.delete('orderby');

    // Очищаем параметры в новом формате (filterAccessories, filterClothing и т.д.)
    urlParams.delete('filterClothing');
    urlParams.delete('filterShoes');
    urlParams.delete('filterAccessories');
    urlParams.delete('filterBrand');
    urlParams.delete('filterProduct_brand');
    urlParams.delete('filterOrderby');

    // Устанавливаем новую категорию если она передана
    if (newCategory) {
        urlParams.set('category', newCategory);
        
    }

    // Обновляем URL
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    
    window.history.replaceState({}, '', newUrl);

    // НЕ вызываем performProductAjaxFilter здесь, так как это будет сделано в updateFiltersForParentCategory

    
}

/**
 * @function loadProductFilterData
 * @description Загружает данные для фильтров товаров через AJAX
 */
function loadProductFilterData() {
    
    // Проверяем, есть ли объект для AJAX запросов товаров
    if (typeof productAjax === 'undefined') {
        return;
    }
    
    // Для страниц образов НЕ загружаем данные фильтров, так как они одинаковые
    const hasCatalogList = isExist('.catalog-list');
    const hasProductsGrid = isExist('.products-grid');
    
    if (!hasCatalogList || !hasProductsGrid) {
        return;
    }

    // Определяем активную родительскую категорию
    let parentCategorySlug = 'zhenshhiny'; // По умолчанию "Женщины"

    // Сначала проверяем категорию из URL
    const urlParams = new URLSearchParams(window.location.search);
    const categoryFromUrl = urlParams.get('category');
    if (categoryFromUrl) {
        parentCategorySlug = categoryFromUrl;
        
    } else {
        // Если нет категории в URL, ищем активную категорию в навигации
        const activeCategory = document.querySelector('.catalog__category.active');
        if (activeCategory && activeCategory.dataset.termslug) {
            parentCategorySlug = activeCategory.dataset.termslug;
            
        } else {
            
        }
    }

    fetch(productAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'get_product_filter_data',
            nonce: productAjax.filterNonce,
            parent_category: parentCategorySlug
        })
    })
    .then(response => {
        return response.json();
    })
    .then(data => {
        if (data.success) {
            populateProductFilterSelects(data.data);
            
            // Восстанавливаем состояние фильтров ПОСЛЕ создания элементов
            setTimeout(() => {
                restoreFiltersFromUrl();
                updateAllFiltersActiveState();
                
                // Проверяем, есть ли параметры фильтрации в URL и выполняем фильтрацию если нужно
                const urlParams = new URLSearchParams(window.location.search);
                const hasProductFilters = urlParams.has('category') ||
                                         urlParams.has('filterClothing') ||
                                         urlParams.has('filterShoes') ||
                                         urlParams.has('filterAccessories') ||
                                         urlParams.has('filterProduct_brand') ||
                                         urlParams.has('orderby');

                if (hasProductFilters) {
                    // Добавляем небольшую задержку, чтобы фильтры успели восстановиться
                    setTimeout(() => {
                        performProductAjaxFilter();
                    }, 150);
                }
            }, 100);
        } else {
            console.error('❌ Ошибка загрузки данных фильтров товаров:', data);
        }
        lazyLoadInstance.update();
    })
    .catch(error => {
        console.error('❌ Ошибка AJAX запроса для фильтров товаров:', error);
    });
}

/**
 * @function groupCategoriesByType
 * @description Группирует категории по типам на основе их названий
 * @param {Array} categories - массив категорий
 * @returns {object} объект с сгруппированными категориями
 */
function groupCategoriesByType(categories) {
    const grouped = {
        clothing: [],
        shoes: [],
        accessories: []
    };

    

    // Преобразуем объект в массив, если необходимо
    let categoriesArray = [];
    if (Array.isArray(categories)) {
        categoriesArray = categories;
    } else if (categories && typeof categories === 'object') {
        categoriesArray = Object.values(categories);
        
    } else {
        
        return grouped;
    }

    categoriesArray.forEach(category => {
        const categoryType = determineCategoryType(category.name);
        
        if (grouped[categoryType]) {
            grouped[categoryType].push(category);
        }
    });

    
    return grouped;
}

/**
 * @function determineCategoryType
 * @description Определяет тип категории по названию
 * @param {string} categoryName - название категории
 * @returns {string} тип категории (clothing, shoes, accessories)
 */
function determineCategoryType(categoryName) {
    const nameLower = categoryName.toLowerCase();

    // Ключевые слова для определения типа
    const clothingKeywords = ['платье', 'блуз', 'рубашк', 'джемпер', 'кардиган', 'свитер', 'водолазк', 'футболк', 'майк', 'топ', 'брюк', 'джинс', 'шорт', 'юбк', 'пиджак', 'жилет', 'костюм', 'нижнее белье', 'купальник', 'спортивн'];
    const shoesKeywords = ['обувь', 'ботинк', 'туфл', 'кроссовк', 'кед', 'сандал', 'сабо', 'босоножк', 'сапог', 'балетк', 'лофер', 'мокасин'];
    const accessoriesKeywords = ['аксессуар', 'сумк', 'рюкзак', 'очк', 'шарф', 'платок', 'перчатк', 'варежк', 'ремн', 'украшен', 'головной убор', 'шляп'];

    for (const keyword of clothingKeywords) {
        if (nameLower.includes(keyword)) {
            return 'clothing';
        }
    }

    for (const keyword of shoesKeywords) {
        if (nameLower.includes(keyword)) {
            return 'shoes';
        }
    }

    for (const keyword of accessoriesKeywords) {
        if (nameLower.includes(keyword)) {
            return 'accessories';
        }
    }

    // По умолчанию относим к одежде
    return 'clothing';
}

/**
 * @function populateProductFilterSelects
 * @description Заполняет селекты данными фильтров товаров
 * @param {object} filterData - данные фильтров товаров
 */
function populateProductFilterSelects(filterData) {

    // Сохраняем данные фильтров в глобальную переменную
    window.productFilterData = filterData;

    // Группируем категории по типам на фронтенде
    // Используем all_categories если доступно, иначе объединяем отдельные массивы
    let allCategories = [];
    if (filterData.all_categories && Array.isArray(filterData.all_categories)) {
        allCategories = filterData.all_categories;
    } else {
        // Fallback: объединяем отдельные массивы
        if (filterData.clothing && Array.isArray(filterData.clothing)) {
            allCategories = allCategories.concat(filterData.clothing);
        }
        if (filterData.shoes && Array.isArray(filterData.shoes)) {
            allCategories = allCategories.concat(filterData.shoes);
        }
        if (filterData.accessories && Array.isArray(filterData.accessories)) {
            allCategories = allCategories.concat(filterData.accessories);
        }
    }

    const groupedCategories = groupCategoriesByType(allCategories);    

    // Создаем объект для мобильных фильтров с правильной структурой
    const mobileFilterData = {
        clothing: groupedCategories.clothing || [],
        shoes: groupedCategories.shoes || [],
        accessories: groupedCategories.accessories || [],
        product_brands: filterData.product_brands || []
    };

    // Заполняем мобильные фильтры отдельно
    populateMobileFilters(mobileFilterData);

    // Заполняем компьютерные фильтры (оригинальные)
    if (groupedCategories.clothing && groupedCategories.clothing.length > 0) {
        populateProductSelect('clothing_filter_options', groupedCategories.clothing, 'Одежда');
    } else {
        console.warn('⚠️ Нет категорий одежды');
    }
    
    if (groupedCategories.shoes && groupedCategories.shoes.length > 0) {
        populateProductSelect('shoes_filter_options', groupedCategories.shoes, 'Обувь');
    } else {
        console.warn('⚠️ Нет категорий обуви');
    }
    
    if (groupedCategories.accessories && groupedCategories.accessories.length > 0) {
        populateProductSelect('accessories_filter_options', groupedCategories.accessories, 'Аксессуары');
    } else {
        console.warn('⚠️ Нет категорий аксессуаров');
    }
    
    if (filterData.product_brands) {
        // Преобразуем объект брендов в массив, если необходимо
        let brandsArray = [];
        if (Array.isArray(filterData.product_brands)) {
            brandsArray = filterData.product_brands;
        } else if (typeof filterData.product_brands === 'object') {
            brandsArray = Object.values(filterData.product_brands);
        }

        if (brandsArray.length > 0) {
            populateProductSelect('product_brand_filter_options', brandsArray, 'Бренд');
        } else {
            console.warn('⚠️ Нет брендов');
        }
    } else {
        console.warn('⚠️ Данные брендов отсутствуют');
    }

    // Обновляем счетчики в триггерах после заполнения данными
    updateProductFilterCounters();

}

/**
 * @function updateProductFilterCounters
 * @description Обновляет счетчики в триггерах фильтров товаров
 */
function updateProductFilterCounters() {

    const filterNames = ['clothing_filter', 'shoes_filter', 'accessories_filter', 'product_brand_filter'];

    filterNames.forEach(filterName => {
        const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
        if (!customSelect) return;

        const optionsContainer = customSelect.querySelector('.custom-select__options');
        const valueElement = customSelect.querySelector('.custom-select__value');
        const triggerElement = customSelect.querySelector('.custom-select__trigger');

        if (optionsContainer && valueElement && triggerElement) {
            const totalOptions = optionsContainer.querySelectorAll('.custom-select__option').length;
            const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');

            const labelMap = {
                'clothing': 'Одежда',
                'shoes': 'Обувь',
                'accessories': 'Аксессуары',
                'product_brand': 'Бренд'
            };

            const filterLabel = labelMap[filterName.replace('_filter', '')];

            if (isCategoryFilter) {
                // Для категорий показываем только название без счетчика
                valueElement.textContent = filterLabel;
            } else {
                // Для остальных фильтров показываем счетчик
                valueElement.textContent = `${filterLabel} (${totalOptions})`;
            }

        }
    });
}

/**
 * @function populateMobileFilters
 * @description Заполняет мобильные фильтры данными
 * @param {object} filterData - данные фильтров
 */
function populateMobileFilters(filterData) {

    // Заполняем мобильные фильтры подкатегорий одежды
    if (filterData.clothing) {
        populateMobileFilter('mobile_clothing_filter_options', filterData.clothing, 'Одежда');
    }

    // Заполняем мобильные фильтры подкатегорий обуви
    if (filterData.shoes) {
        populateMobileFilter('mobile_shoes_filter_options', filterData.shoes, 'Обувь');
    }

    // Заполняем мобильные фильтры подкатегорий аксессуаров
    if (filterData.accessories) {
        populateMobileFilter('mobile_accessories_filter_options', filterData.accessories, 'Аксессуары');
    }

    // Заполняем мобильные фильтры брендов товаров
    if (filterData.product_brands) {
        populateMobileFilter('mobile_product_brand_filter_options', filterData.product_brands, 'Бренд');
    }
}

/**
 * @function populateMobileFilter
 * @description Заполняет конкретный мобильный фильтр данными
 * @param {string} selectId - ID контейнера
 * @param {Array} items - массив терминов
 * @param {string} label - название фильтра
 */
function populateMobileFilter(selectId, items, label) {

    const optionsContainer = document.getElementById(selectId);

    if (!optionsContainer) {
        console.warn(`Mobile options container with ID ${selectId} not found`);
        return;
    }

    // Очищаем контейнер
    optionsContainer.innerHTML = '';

    // Проверяем, что items является массивом
    if (!items || !Array.isArray(items) || items.length === 0) {
        optionsContainer.innerHTML = '<div class="mobile-filter__option no-options">Нет доступных опций</div>';
        return;
    }

    // Преобразуем объект в массив, если необходимо
    let itemsArray;
    if (Array.isArray(items)) {
        itemsArray = items;
    } else if (typeof items === 'object' && items !== null) {
        itemsArray = Object.values(items);
    } else {
        console.error('Items is not an array or object:', items);
        return;
    }

    // Добавляем новые опции для мобильных фильтров
    itemsArray.forEach(item => {
        const optionDiv = document.createElement('div');
        optionDiv.className = 'mobile-filters__options-item';

        const input = document.createElement('input');

        // Для категорий (одежда, обувь, аксессуары) используем радиокнопки
        const isCategoryFilter = selectId.includes('clothing_filter') || selectId.includes('shoes_filter') || selectId.includes('accessories_filter');
        if (isCategoryFilter) {
            input.type = 'radio';
            input.name = selectId.replace('_options', '').replace('mobile_', '');
        } else {
            input.type = 'checkbox';
        }

        input.value = item.term_id || item.slug;
        input.id = `${selectId}_${item.slug || item.term_id}`;
        
        // Формируем ID десктопной опции (как в populateProductSelect)
        // selectId: mobile_clothing_filter_options -> desktopSelectId: clothing_filter_options
        const desktopSelectId = selectId.replace('mobile_', '');
        const desktopOptionId = `${desktopSelectId}_${item.slug || item.term_id}`;
        
        // Добавляем data-атрибут с ID десктопной опции
        optionDiv.setAttribute('data-option-id', desktopOptionId);

        const labelElement = document.createElement('label');
        labelElement.htmlFor = input.id;
        labelElement.textContent = item.name;

        optionDiv.appendChild(input);
        optionDiv.appendChild(labelElement);
        optionsContainer.appendChild(optionDiv);


        // Добавляем обработчик изменения
        input.addEventListener('change', function() {

            // Определяем, какая категория была изменена по имени радиокнопки
            const changedCategory = this.name;

            applyMobileFilters(changedCategory);
        });
    });

}

/**
 * @function applyMobileFilters
 * @description Применяет мобильные фильтры и обновляет товары
 * @param {string} changedCategory - категория, которая была изменена
 */
function applyMobileFilters(changedCategory = null) {

    // Собираем выбранные значения из мобильных фильтров
    const selectedFilters = {};

    // Отладочная информация о текущем состоянии мобильных радиокнопок

    // Собираем выбранные категории (только мобильные радиокнопки)
    const clothingRadio = document.querySelector('#mobile_clothing_filter_options input[name="clothing_filter"]:checked');
    const shoesRadio = document.querySelector('#mobile_shoes_filter_options input[name="shoes_filter"]:checked');
    const accessoriesRadio = document.querySelector('#mobile_accessories_filter_options input[name="accessories_filter"]:checked');



    // Используем переданную категорию или определяем по текущему состоянию
    if (!changedCategory) {
        // Определяем, какая категория была изменена (приоритет по порядку проверки)
        if (accessoriesRadio) {
            changedCategory = 'accessories_filter';
        } else if (shoesRadio) {
            changedCategory = 'shoes_filter';
        } else if (clothingRadio) {
            changedCategory = 'clothing_filter';
        }
    }


    // Сбрасываем другие категории только если что-то изменилось
    if (changedCategory) {
        resetOtherMobileCategoryFilters(changedCategory);

        // Теперь определяем активную категорию после сброса
        const activeClothingRadio = document.querySelector('#mobile_clothing_filter_options input[name="clothing_filter"]:checked');
        const activeShoesRadio = document.querySelector('#mobile_shoes_filter_options input[name="shoes_filter"]:checked');
        const activeAccessoriesRadio = document.querySelector('#mobile_accessories_filter_options input[name="accessories_filter"]:checked');


        // Определяем активную категорию после сброса
        if (activeAccessoriesRadio) {
            selectedFilters.accessories = activeAccessoriesRadio.value;
        } else if (activeShoesRadio) {
            selectedFilters.shoes = activeShoesRadio.value;
        } else if (activeClothingRadio) {
            selectedFilters.clothing = activeClothingRadio.value;
        }
    }

    // Собираем выбранные бренды (чекбоксы)
    const brandCheckboxes = document.querySelectorAll('input[name="product_brand_filter"]:checked');
    if (brandCheckboxes.length > 0) {
        selectedFilters.product_brands = Array.from(brandCheckboxes).map(cb => cb.value);
    }

    // Если выбрана категория, закрываем мобильные фильтры
    if (changedCategory) {
        const mobileFiltersContainer = document.querySelector('.catalog__mobile-filters');
        if (mobileFiltersContainer) {
            closeMobileFilters(mobileFiltersContainer);
        }
    }


    // Применяем мобильные фильтры
    applyMobileFiltersToUrl(selectedFilters);
}

/**
 * @function applyMobileFiltersToUrl
 * @description Применяет мобильные фильтры к URL и выполняет AJAX запрос
 * @param {Object} selectedFilters - выбранные фильтры
 */
function applyMobileFiltersToUrl(selectedFilters) {

    // Обновляем URL с параметрами фильтра
    if (selectedFilters.clothing) {
        updateProductUrlParameter('filterClothing', selectedFilters.clothing);
    } else {
        removeProductUrlParameter('filterClothing');
    }

    if (selectedFilters.shoes) {
        updateProductUrlParameter('filterShoes', selectedFilters.shoes);
    } else {
        removeProductUrlParameter('filterShoes');
    }

    if (selectedFilters.accessories) {
        updateProductUrlParameter('filterAccessories', selectedFilters.accessories);
    } else {
        removeProductUrlParameter('filterAccessories');
    }

    if (selectedFilters.product_brands && selectedFilters.product_brands.length > 0) {
        updateProductUrlParameter('filterProduct_brand', selectedFilters.product_brands.join(','));
    } else {
        removeProductUrlParameter('filterProduct_brand');
    }

    // Выполняем AJAX запрос для фильтрации товаров
    performProductAjaxFilter();

}

/**
 * @function resetOtherMobileCategoryFilters
 * @description Сбрасывает другие мобильные фильтры категорий при выборе одной
 * @param {string} selectedCategory - выбранная категория
 */
function resetOtherMobileCategoryFilters(selectedCategory) {

    // Сбрасываем другие категории
    const otherCategories = ['clothing_filter', 'shoes_filter', 'accessories_filter'];
    otherCategories.forEach(categoryName => {
        if (categoryName !== selectedCategory) {

            // Сбрасываем только мобильные радиокнопки
            const mobileContainerId = `mobile_${categoryName.replace('_filter', '')}_filter_options`;
            const otherRadios = document.querySelectorAll(`#${mobileContainerId} input[name="${categoryName}"]`);
            otherRadios.forEach(radio => {
                radio.checked = false;
            });

            // Сбрасываем фильтр в URL
            let filterParam = categoryName.replace('_filter', '');
            if (filterParam === 'product_brand') {
                filterParam = 'filterProduct_brand';
            } else {
                filterParam = 'filter' + filterParam.charAt(0).toUpperCase() + filterParam.slice(1);
            }
            removeProductUrlParameter(filterParam);
        }
    });
}

/**
 * @function populateProductSelect
 * @description Заполняет конкретный селект товаров данными
 * @param {string} selectId - ID селекта
 * @param {Array} items - массив терминов
 * @param {string} label - название фильтра
 */
function populateProductSelect(selectId, items, label) {

    const optionsContainer = document.getElementById(selectId);

    if (!optionsContainer) {
        return;
    }

    // Очищаем контейнер
    optionsContainer.innerHTML = '';

    // Преобразуем объект в массив, если необходимо
    let itemsArray;
    if (Array.isArray(items)) {
        itemsArray = items;
    } else if (typeof items === 'object' && items !== null) {
        itemsArray = Object.values(items);
    } else {
        console.error('Items is not an array or object:', items);
        return;
    }

    // Добавляем новые опции для компьютерных фильтров
    itemsArray.forEach(item => {
        const optionDiv = document.createElement('div');
        optionDiv.className = 'custom-select__option';

        const input = document.createElement('input');

        // Для категорий (одежда, обувь, аксессуары) используем радиокнопки
        const isCategoryFilter = selectId.includes('clothing_filter') || selectId.includes('shoes_filter') || selectId.includes('accessories_filter');
        if (isCategoryFilter) {
            input.type = 'radio';
            input.name = selectId.replace('_options', '');
        } else {
            input.type = 'checkbox';
        }

        input.value = item.term_id || item.slug;
        input.id = `${selectId}_${item.slug || item.term_id}`;
        
        // Добавляем data-атрибут с ID на сам элемент custom-select__option
        optionDiv.setAttribute('data-option-id', input.id);

        const labelElement = document.createElement('label');
        labelElement.htmlFor = input.id;
        labelElement.textContent = item.name;

        optionDiv.appendChild(input);
        optionDiv.appendChild(labelElement);
        optionsContainer.appendChild(optionDiv);


        // Добавляем обработчик изменения для компьютерных фильтров
        input.addEventListener('change', function() {

            // Для радиокнопок категорий сбрасываем другие категории
            if (input.type === 'radio' && (selectId.includes('clothing_filter') || selectId.includes('shoes_filter') || selectId.includes('accessories_filter'))) {
                resetOtherCategoryFilters(input);
            }

            // НЕ применяем фильтр сразу - только при нажатии на кнопку "Выбрать"
            // const filterName = selectId.replace('_options', '');
            // applyProductFilter(filterName);
        });
    });

}

/**
 * @function resetOtherCategoryFilters
 * @description Сбрасывает другие фильтры категорий при выборе одной
 * @param {HTMLElement} selectedInput - выбранный элемент
 */
function resetOtherCategoryFilters(selectedInput) {

    // Получаем имя выбранной категории
    const selectedCategory = selectedInput.name;

    // Сбрасываем другие категории
    const otherCategories = ['clothing_filter', 'shoes_filter', 'accessories_filter'];
    otherCategories.forEach(categoryName => {
        if (categoryName !== selectedCategory) {
            const otherRadios = document.querySelectorAll(`input[name="${categoryName}"]`);
            otherRadios.forEach(radio => {
                radio.checked = false;
            });

            // Сбрасываем фильтр в URL
            let filterParam = categoryName.replace('_filter', '');
            if (filterParam === 'product_brand') {
                filterParam = 'filterProduct_brand';
            } else {
                filterParam = 'filter' + filterParam.charAt(0).toUpperCase() + filterParam.slice(1);
            }
            removeProductUrlParameter(filterParam);

            // Сбрасываем визуальное состояние фильтра
            const otherFilter = document.querySelector(`[data-filter="${categoryName}"]`);
            if (otherFilter) {
                const valueElement = otherFilter.querySelector('.custom-select__value');
                const triggerElement = otherFilter.querySelector('.custom-select__trigger');

                if (valueElement) {
                    const filterLabel = getFilterLabel(categoryName);
                    valueElement.textContent = filterLabel;
                }

                // Убираем класс has-selection
                if (triggerElement) {
                    triggerElement.classList.remove('has-selection');
                }
            }
        }
    });
}

/**
 * @function initProductFilterEventHandlers
 * @description Инициализирует обработчики событий для фильтров товаров
 */
function initProductFilterEventHandlers() {
    // Обработчики для кнопок применения фильтров
    // УБРАНО: дублирующий обработчик для кнопок "Выбрать" - уже есть в основном коде
    // document.addEventListener('click', function(e) {
    //     if (e.target.classList.contains('custom-select__btn--apply')) {
    //         const customSelect = e.target.closest('.custom-select');
    //         const filterName = customSelect.getAttribute('data-filter');

    //         if (filterName) {
    //             applyProductFilter(filterName);
    //         }
    //     }
    // });

    // Обработчики для кнопок сброса фильтров
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('custom-select__btn--reset')) {
            const customSelect = e.target.closest('.custom-select');
            const filterName = customSelect.getAttribute('data-filter');

            if (filterName) {
                resetProductFilter(filterName);
            }
        }
    });

    // Обработчики для радиокнопок категорий (одежда, обувь, аксессуары)
    document.addEventListener('change', function(e) {
        if (e.target.type === 'radio' && e.target.name === 'category_filter') {
            // Сбрасываем все другие фильтры категорий
            resetOtherCategoryFilters(e.target);
        }
    });

    // Обработчики для радиокнопок в фильтрах товаров (clothing_filter, shoes_filter, accessories_filter)
    document.addEventListener('change', function(e) {
        if (e.target.type === 'radio' && 
            (e.target.name === 'clothing_filter' || 
             e.target.name === 'shoes_filter' || 
             e.target.name === 'accessories_filter')) {
            
            
            
            // Сбрасываем все другие радиокнопки в той же группе
            const allRadiosInGroup = document.querySelectorAll(`input[type="radio"][name="${e.target.name}"]`);
            allRadiosInGroup.forEach(radio => {
                if (radio !== e.target) {
                    radio.checked = false;
                    // Убираем классы визуального выделения
                    radio.classList.remove('selected', 'checked', 'active', 'is-checked');
                    
                    // Убираем классы с родительского label
                    const parentLabel = radio.closest('label');
                    if (parentLabel) {
                        parentLabel.classList.remove('selected', 'checked', 'active', 'is-checked');
                    }
                }
            });
            
            // Добавляем классы к выбранной радиокнопке
            e.target.classList.add('selected', 'checked', 'active', 'is-checked');
            
            // Добавляем классы к родительскому label
            const parentLabel = e.target.closest('label');
            if (parentLabel) {
                parentLabel.classList.add('selected', 'checked', 'active', 'is-checked');
            }
            
            
        }
    });
}


/**
 * @function applyProductFilter
 * @description Применяет фильтр товаров
 * @param {string} filterName - имя фильтра
 */
function applyProductFilter(filterName) {
    // Если мы сбрасываем фильтры, не выполняем обновление заголовков
    if (window.isClearingFilters) {
        return;
    }
    
    // Отменяем предыдущий вызов, если он еще не выполнился (debounce)
    if (applyProductFilterTimeout) {
        clearTimeout(applyProductFilterTimeout);
        applyProductFilterTimeout = null;
    }
    
    // Откладываем выполнение на 150мс для предотвращения множественных вызовов
    applyProductFilterTimeout = setTimeout(() => {
        applyProductFilterImmediate(filterName);
    }, 150);
}

function applyProductFilterImmediate(filterName) {
    const customSelect = document.querySelector(`[data-filter="${filterName}"]`);

    if (!customSelect) {
        console.error('Custom select not found for filter:', filterName);
        return;
    }

    const optionsContainer = customSelect.querySelector('.custom-select__options');

    // Для фильтров категорий используем радиокнопки, для остальных - чекбоксы
    const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');

    // Сначала находим выбранные радиокнопки/чекбоксы ДО сброса
    const checkedBoxes = isCategoryFilter
        ? optionsContainer.querySelectorAll('input[type="radio"]:checked')
        : optionsContainer.querySelectorAll('input[type="checkbox"]:checked');
    
    

    // Сбрасываем все радиокнопки/чекбоксы в этой группе
    const groupInputs = isCategoryFilter
        ? optionsContainer.querySelectorAll('input[type="radio"]')
        : optionsContainer.querySelectorAll('input[type="checkbox"]');
    
    groupInputs.forEach(input => {
        input.checked = false;
        // Убираем классы визуального выделения
        input.classList.remove('selected', 'checked', 'active', 'is-checked');
        
        // Убираем классы с родительского label
        const parentLabel = input.closest('label');
        if (parentLabel) {
            parentLabel.classList.remove('selected', 'checked', 'active', 'is-checked');
        }
    });
    
    

    // Восстанавливаем выбранные радиокнопки/чекбоксы после сброса
    if (checkedBoxes.length > 0) {
        checkedBoxes.forEach(checkbox => {
            checkbox.checked = true;
            
            // Добавляем классы для визуального выделения
            checkbox.classList.add('selected', 'checked', 'active', 'is-checked');
            
            // Добавляем классы к родительскому label
            const parentLabel = checkbox.closest('label');
            if (parentLabel) {
                parentLabel.classList.add('selected', 'checked', 'active', 'is-checked');
            }
            
            
        });
    }


    let filterParam = filterName.replace('_filter', '');

    // Добавляем префикс "filter" ко всем параметрам
    if (filterParam === 'product_brand') {
        filterParam = 'filterProduct_brand';
    } else {
        filterParam = 'filter' + filterParam.charAt(0).toUpperCase() + filterParam.slice(1);
    }

    if (checkedBoxes.length > 0) {
        const selectedValues = Array.from(checkedBoxes).map(cb => cb.value);
        // Обновляем URL с параметрами фильтра
        updateProductUrlParameter(filterParam, selectedValues.join(','));

        // Обновляем заголовок селекта с выбранными значениями
        updateSelectHeader(customSelect, checkedBoxes, filterName);
    } else {
        // Если ничего не выбрано, удаляем параметр из URL
        removeProductUrlParameter(filterParam);

        // Сбрасываем заголовок селекта на дефолтное состояние
        resetSelectHeader(customSelect, filterName);
    }

    // Сбрасываем состояние кнопки "Загрузить еще" при смене фильтра
    resetLoadMoreButtonState();

    // Выполняем AJAX запрос для фильтрации товаров
    performProductAjaxFilter();

    // Обновляем состояние активности всех селектов
    updateAllFiltersActiveState();
}

/**
 * @function resetProductFilter
 * @description Сбрасывает фильтр товаров
 * @param {string} filterName - имя фильтра
 */
function resetProductFilter(filterName) {
    const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
    const optionsContainer = customSelect.querySelector('.custom-select__options');
    // Для фильтров категорий используем радиокнопки, для остальных - чекбоксы
    const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');
    const checkboxes = isCategoryFilter
        ? optionsContainer.querySelectorAll('input[type="radio"]')
        : optionsContainer.querySelectorAll('input[type="checkbox"]');

    // Снимаем все галочки и убираем классы активности
    checkboxes.forEach(cb => {
        cb.checked = false;
        // Убираем классы визуального выделения
        cb.classList.remove('selected', 'checked', 'active', 'is-checked');
        
        // Убираем классы с родительского label
        const parentLabel = cb.closest('label');
        if (parentLabel) {
            parentLabel.classList.remove('selected', 'checked', 'active', 'is-checked');
        }
    });

    // Обновляем текст триггера на дефолтный
    const valueElement = customSelect.querySelector('.custom-select__value');
    const triggerElement = customSelect.querySelector('.custom-select__trigger');
    if (valueElement) {
        const filterLabel = getFilterLabel(filterName);
        // Показываем счетчик для всех фильтров кроме радиокнопок категорий
        const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');
        if (!isCategoryFilter) {
            valueElement.textContent = `${filterLabel} (0)`;
        } else {
            valueElement.textContent = filterLabel;
        }
    }

    // Убираем класс has-selection
    if (triggerElement) {
        triggerElement.classList.remove('has-selection');
    }

    let filterParam = filterName.replace('_filter', '');

    // Добавляем префикс "filter" ко всем параметрам
    if (filterParam === 'product_brand') {
        filterParam = 'filterProduct_brand';
    } else {
        filterParam = 'filter' + filterParam.charAt(0).toUpperCase() + filterParam.slice(1);
    }

    // Удаляем параметр из URL
    removeProductUrlParameter(filterParam);

    // Сбрасываем состояние кнопки "Загрузить еще" при сбросе фильтра
    resetLoadMoreButtonState();

    // Выполняем AJAX запрос для обновления товаров
    performProductAjaxFilter();

    // Обновляем состояние активности всех селектов
    updateAllFiltersActiveState();
}

/**
 * @function updateProductUrlParameter
 * @description Обновляет URL параметр для фильтров товаров
 * @param {string} param - имя параметра
 * @param {string} value - значение параметра
 */
function updateProductUrlParameter(param, value) {
    const url = new URL(window.location);
    
    
    url.searchParams.set(param, value);
    
    window.history.replaceState({}, '', url);
    
}

/**
 * @function removeProductUrlParameter
 * @description Удаляет URL параметр для фильтров товаров
 * @param {string} param - имя параметра
 */
function removeProductUrlParameter(param) {
    const url = new URL(window.location);
    url.searchParams.delete(param);
    window.history.replaceState({}, '', url);
}

/**
 * @function performProductAjaxFilter
 * @description Выполняет AJAX запрос для фильтрации товаров
 */
function performProductAjaxFilter() {
    // Отменяем предыдущий запрос, если он еще не выполнился
    if (productAjaxFilterTimeout) {
        clearTimeout(productAjaxFilterTimeout);
        productAjaxFilterTimeout = null;
    }
    
    // Защита от множественных одновременных запросов
    if (isAjaxLoading) {
        console.log('⏳ AJAX запрос уже выполняется, откладываем новый запрос...');
        // Откладываем выполнение запроса
        productAjaxFilterTimeout = setTimeout(() => {
            performProductAjaxFilter();
        }, 300);
        return;
    }
    
    // Устанавливаем флаг загрузки
    isAjaxLoading = true;

    // Показываем индикатор загрузки
    showProductLoadingIndicator();

    // Собираем все активные фильтры из URL
    const urlParams = new URLSearchParams(window.location.search);
    const filterData = {};

    // Обрабатываем основной параметр категории товара
    const categoryValue = urlParams.get('category');

    if (categoryValue) {
        filterData['product_category_slug'] = categoryValue;
    } else {
        // Если нет категории в URL, используем активную категорию из DOM
        const activeCategory = document.querySelector('.catalog__category.active');
        if (activeCategory && activeCategory.dataset.termslug) {
            filterData['product_category_slug'] = activeCategory.dataset.termslug;
        } else {
            // Используем дефолтную категорию "Женщины"
            filterData['product_category_slug'] = 'zhenshhiny';
        }
    }

    // Получаем параметры фильтров с префиксом "filter"
    // Логика: собираем ВСЕ активные фильтры категорий для пересечения
    const filterParams = ['filterClothing', 'filterShoes', 'filterAccessories'];

    for (const param of filterParams) {
        const value = urlParams.get(param);
        if (value) {
            // Преобразуем filterClothing -> clothing_slug
            const baseParam = param.replace('filter', '').toLowerCase();
            // Получаем slug по ID термина
            const termSlug = getTermSlugById(value);
            if (termSlug) {
                filterData[baseParam + '_slug'] = termSlug;
            } else {
                // Если не найден по ID, возможно это уже slug
                filterData[baseParam + '_slug'] = value;
            }
        }
    }

    // Обрабатываем параметр бренда отдельно
    const brandValue = urlParams.get('filterProduct_brand');
    if (brandValue) {
        // Если передано несколько брендов через запятую, обрабатываем каждый
        const brandIds = brandValue.split(',');
        const brandSlugs = [];

        for (const brandId of brandIds) {
            const brandSlug = getTermSlugById(brandId.trim());
            if (brandSlug) {
                brandSlugs.push(brandSlug);
            } else {
                // Если не найден по ID, возможно это уже slug
                brandSlugs.push(brandId.trim());
            }
        }

        if (brandSlugs.length > 0) {
            filterData['product_brand_slug'] = brandSlugs.join(',');
        }
    }

    // Обрабатываем параметр сортировки
    const orderbyValue = urlParams.get('orderby');
    if (orderbyValue && orderbyValue !== 'default') {
        filterData['orderby'] = orderbyValue;
    }
    // Если нет параметра или "default", не добавляем orderby - будет сортировка по умолчанию

    // Подготавливаем данные для запроса
    const requestData = {
        action: 'load_filtered_products',
        nonce: productAjax.loadNonce,
        page: 1,
        ...filterData
    };



    // Выполняем AJAX запрос
    fetch(productAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(requestData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            updateProductsContent(data.data);
            
            // Очищаем флаг сброса фильтров
            if (window.isClearingFilters) {
                window.isClearingFilters = false;
            }
        } else {
            showProductErrorMessage('Ошибка при загрузке товаров');
        }
    })
    .catch(error => {
        console.error('Ошибка AJAX запроса для товаров:', error);
        showProductErrorMessage('Произошла ошибка при загрузке товаров');
    })
    .finally(() => {
        hideProductLoadingIndicator();
        // Сбрасываем флаг загрузки
        isAjaxLoading = false;
        // Очищаем таймер debounce
        if (productAjaxFilterTimeout) {
            clearTimeout(productAjaxFilterTimeout);
            productAjaxFilterTimeout = null;
        }
        lazyLoadInstance.update();
    });
}

/**
 * @function updateProductsContent
 * @description Обновляет содержимое списка товаров
 * @param {object} data - данные ответа от сервера
 */
function updateProductsContent(data) {
    const productsGrid = document.querySelector('.products-grid');
    const productsList = document.querySelector('.products-list');

    if (productsGrid) {
        // Всегда обновляем содержимое, даже если html пустой
        productsGrid.innerHTML = data.html || '<div class="no-products-found"><p>Товары не найдены</p></div>';

        // Обновляем атрибуты контейнера
        if (productsList && data.total !== undefined && data.pages !== undefined) {
            productsList.setAttribute('data-total', data.total);
            productsList.setAttribute('data-pages', data.pages);
            productsList.setAttribute('data-current-page', data.current_page || 1);
        }

        // Инициализируем кнопки избранного для нового контента
        if (typeof initFavoritesButtons === 'function') {
            initFavoritesButtons();
        }

        // Инициализируем большие карточки для нового контента
        if (typeof initBigItemCards === 'function') {
            initBigItemCards(); // Пересчитываем все позиции после обновления контента
        }
        
        // Восстанавливаем состояние сортировки из URL после обновления контента
        // Делаем это с небольшой задержкой, чтобы DOM успел обновиться
        setTimeout(() => {
            const sortingSelect = document.querySelector('.custom-select[data-sort="price"]');
            if (sortingSelect && typeof restoreSortingState === 'function') {
                const urlParams = new URLSearchParams(window.location.search);
                const orderbyValue = urlParams.get('orderby');
                // Восстанавливаем состояние сортировки из URL
                restoreSortingState(orderbyValue || 'default');
            }
        }, 50);
        
        // Переинициализируем сортировку, если селект был пересоздан (хотя он находится вне products-grid)
        // Это нужно на случай, если селект все же пересоздается
        if (typeof initProductSorting === 'function') {
            // Сбрасываем флаг инициализации, чтобы можно было переинициализировать
            const sortingSelect = document.querySelector('.custom-select[data-sort="price"]');
            if (sortingSelect) {
                sortingSelect.dataset.sortingInitialized = 'false';
            }
            initProductSorting();
        }

        // Обновляем состояние кнопки "Загрузить еще" после смены категории
        if (data.pages !== undefined && data.total !== undefined) {
            // Обновляем данные кнопки, но не меняем её видимость
            const loadMoreBtn = document.querySelector('.load-more-btn');
            if (loadMoreBtn) {
                loadMoreBtn.dataset.totalPages = data.pages;
                loadMoreBtn.dataset.page = '2';
            }
            
            // Проверяем, нужно ли скрыть кнопку если все товары загружены
            setTimeout(() => {
                const totalItems = document.querySelectorAll('.product-item').length;
                const totalAvailable = data.total;
                
                if (totalItems >= totalAvailable && totalAvailable > 0) {
                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = 'none';
                    }
                }
            }, 100);
            
            // Переинициализируем автоподгрузку для архивных страниц
            const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                                 document.body.classList.contains('tax-product_category') ||
                                 document.body.classList.contains('post-type-archive-look') ||
                                 document.body.classList.contains('tax-look_category') ||
                                 window.location.pathname.includes('/catalog') ||
                                 window.location.pathname.includes('/looks');
            
            if (isArchivePage) {
                // Небольшая задержка для завершения обновления DOM
                setTimeout(() => {
                    if (typeof initAutoLoadForCategory === 'function') {
                        initAutoLoadForCategory();
                    }
                }, 200);
            }
        }

        // Автоматический скролл отключен для улучшения пользовательского опыта
    }
}

/**
 * @function showProductLoadingIndicator
 * @description Показывает индикатор загрузки для товаров
 */
function showProductLoadingIndicator() {
    const productsGrid = document.querySelector('.products-grid');
    if (productsGrid) {
        showLoadingOverlay(productsGrid);
    }
}

/**
 * @function hideProductLoadingIndicator
 * @description Скрывает индикатор загрузки для товаров
 */
function hideProductLoadingIndicator() {
    const productsGrid = document.querySelector('.products-grid');
    if (productsGrid) {
        hideLoadingOverlay(productsGrid);
    }
}

/**
 * @function showProductErrorMessage
 * @description Показывает сообщение об ошибке для товаров
 * @param {string} message - сообщение об ошибке
 */
function showProductErrorMessage(message) {
    const productsGrid = document.querySelector('.products-grid');
    if (productsGrid) {
        productsGrid.innerHTML = `<div class="products-list-empty"><p>${message}</p></div>`;
    }
}

/**
 * @function getTermSlugById
 * @description Получает slug термина по его ID из загруженных данных фильтров
 * @param {string} termId - ID термина
 * @returns {string|null} slug термина или null если не найден
 */
function getTermSlugById(termId) {

    // Ищем во всех загруженных данных фильтров
    const allTerms = [];

    // Добавляем все категории из all_categories
    if (window.productFilterData && window.productFilterData.all_categories) {
        const allCategories = window.productFilterData.all_categories;
        if (Array.isArray(allCategories)) {
            allTerms.push(...allCategories);
        } else if (typeof allCategories === 'object') {
            allTerms.push(...Object.values(allCategories));
        }
    }

    // Добавляем бренды
    if (window.productFilterData && window.productFilterData.product_brands) {
        const brandTerms = window.productFilterData.product_brands;
        if (Array.isArray(brandTerms)) {
            allTerms.push(...brandTerms);
        } else if (typeof brandTerms === 'object') {
            allTerms.push(...Object.values(brandTerms));
        }
    }

    // Ищем термин по ID
    const term = allTerms.find(t => t.term_id == termId);

    // Если не найден по ID, попробуем найти по slug
    if (!term) {
        const termBySlug = allTerms.find(t => t.slug == termId);
        return termBySlug ? termBySlug.slug : null;
    }

    return term ? term.slug : null;
}

/**
 * @function restoreFiltersFromUrl
 * @description Восстанавливает состояние фильтров из URL параметров
 */
function restoreFiltersFromUrl() {
    
    const urlParams = new URLSearchParams(window.location.search);
    
    // Восстанавливаем активную категорию
    const categoryParam = urlParams.get('category');
    if (categoryParam) {
        
        updateActiveFilter(categoryParam);
    }

    // Восстанавливаем фильтр одежды
    const clothingValue = urlParams.get('filterClothing');
    if (clothingValue) {
        
        restoreFilterState('clothing_filter', clothingValue);
        restoreMobileFilterState('clothing_filter', clothingValue);
    }

    // Восстанавливаем фильтр обуви
    const shoesValue = urlParams.get('filterShoes');
    if (shoesValue) {
        
        restoreFilterState('shoes_filter', shoesValue);
        restoreMobileFilterState('shoes_filter', shoesValue);
    }

    // Восстанавливаем фильтр аксессуаров
    const accessoriesValue = urlParams.get('filterAccessories');
    if (accessoriesValue) {
        
        restoreFilterState('accessories_filter', accessoriesValue);
        restoreMobileFilterState('accessories_filter', accessoriesValue);
    }

    // Восстанавливаем фильтр брендов
    const brandValue = urlParams.get('filterProduct_brand');
    if (brandValue) {
        
        restoreFilterState('product_brand_filter', brandValue);
    }

    // Восстанавливаем сортировку (всегда вызываем, даже если параметра нет - для установки "По умолчанию")
    const orderbyValue = urlParams.get('orderby');
    restoreSortingState(orderbyValue || 'default');
}

/**
 * @function restoreFilterState
 * @description Восстанавливает состояние конкретного фильтра
 * @param {string} filterName - имя фильтра
 * @param {string} values - значения через запятую
 */
function restoreFilterState(filterName, values) {
    
    const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
    
    if (!customSelect) {
        return;
    }

    const optionsContainer = customSelect.querySelector('.custom-select__options');
    
    if (!optionsContainer) {
        
        return;
    }
    
    // Проверяем содержимое контейнера
    const allInputs = optionsContainer.querySelectorAll('input');
    
    allInputs.forEach((input, index) => {
        
    });

    const valueArray = values.split(',');
    

    // Сначала сбрасываем все радиокнопки/чекбоксы в этой группе
    const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');
    const groupInputs = isCategoryFilter
        ? optionsContainer.querySelectorAll('input[type="radio"]')
        : optionsContainer.querySelectorAll('input[type="checkbox"]');
    
    groupInputs.forEach(input => {
        input.checked = false;
        // Убираем классы визуального выделения
        input.classList.remove('selected', 'checked', 'active', 'is-checked');
        
        // Убираем классы с родительского label
        const parentLabel = input.closest('label');
        if (parentLabel) {
            parentLabel.classList.remove('selected', 'checked', 'active', 'is-checked');
        }
    });
    
    

    // Отмечаем соответствующие чекбоксы/радиокнопки
    valueArray.forEach(value => {
        const trimmedValue = value.trim();
        
        const checkbox = optionsContainer.querySelector(`input[value="${trimmedValue}"]`);
        
        if (checkbox) {
            checkbox.checked = true;
            
            // Добавляем классы для визуального выделения
            checkbox.classList.add('selected', 'checked', 'active', 'is-checked');
            
            // Добавляем классы к родительскому label
            const parentLabel = checkbox.closest('label');
            if (parentLabel) {
                parentLabel.classList.add('selected', 'checked', 'active', 'is-checked');
            }
            
            
        } else {
            
            // Удаляем несуществующий параметр из URL
            const urlParams = new URLSearchParams(window.location.search);
            const filterParam = `filter${filterName.replace('_filter', '').charAt(0).toUpperCase() + filterName.replace('_filter', '').slice(1)}`;
            urlParams.delete(filterParam);
            const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
            window.history.replaceState({}, '', newUrl);
            
        }
    });

    // Обновляем текст триггера
    const checkedBoxes = isCategoryFilter
        ? optionsContainer.querySelectorAll('input[type="radio"]:checked')
        : optionsContainer.querySelectorAll('input[type="checkbox"]:checked');
    const valueElement = customSelect.querySelector('.custom-select__value');
    if (valueElement) {
        const filterLabel = getFilterLabel(filterName);
        // Показываем счетчик для всех фильтров кроме радиокнопок категорий
        if (!isCategoryFilter) {
            if (checkedBoxes.length > 0) {
                valueElement.textContent = `${filterLabel} (${checkedBoxes.length})`;
            } else {
                valueElement.textContent = `${filterLabel} (0)`;
            }
        } else {
            // Для категорий показываем название выбранной категории
            if (checkedBoxes.length > 0) {
                const selectedLabel = checkedBoxes[0].nextElementSibling;
                if (selectedLabel) {
                    valueElement.textContent = selectedLabel.textContent;
                    
                } else {
                    valueElement.textContent = filterLabel;
                }
            } else {
                valueElement.textContent = filterLabel;
            }
        }
    }

    // Добавляем класс has-selection если есть выбранные элементы
    const triggerElement = customSelect.querySelector('.custom-select__trigger');
    if (triggerElement && checkedBoxes.length > 0) {
        triggerElement.classList.add('has-selection');
        
    }

    

    // НЕ вызываем updateAllFiltersActiveState() при восстановлении из URL
    // Это предотвращает двойную фильтрацию
    // updateAllFiltersActiveState() будет вызван в initProductFilters() после restoreFiltersFromUrl()
}

/**
 * @function restoreMobileFilterState
 * @description Восстанавливает состояние мобильного фильтра
 * @param {string} filterName - имя фильтра
 * @param {string} values - значения через запятую
 */
function restoreMobileFilterState(filterName, values) {

    // Определяем ID контейнера мобильного фильтра
    const mobileContainerId = `mobile_${filterName.replace('_filter', '')}_filter_options`;
    const mobileContainer = document.getElementById(mobileContainerId);

    if (!mobileContainer) {
        return;
    }

    const valueArray = values.split(',');

    // Отмечаем соответствующие радиокнопки
    valueArray.forEach(value => {
        const radio = mobileContainer.querySelector(`input[value="${value.trim()}"]`);
        if (radio) {
            radio.checked = true;
        }
    });

    // Открываем соответствующий аккордеон
    const accordionItem = document.querySelector(`[data-category="${filterName.replace('_filter', '')}"]`);
    if (accordionItem) {
        accordionItem.classList.add('active');
    }
}

/**
 * @function initBackToTop
 * @description Инициализирует кнопку "Наверх"
 */
function initBackToTop() {
    const backToTopButton = document.getElementById('backToTop');

    if (!backToTopButton) {
        return;
    }

    // Показываем/скрываем кнопку при скролле
    window.addEventListener('scroll', function() {
        if (window.scrollY > 300) {
            backToTopButton.classList.add('visible');
        } else {
            backToTopButton.classList.remove('visible');
        }
    });

    // Обработчик клика по кнопке
    backToTopButton.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

}

/**
 * @function initLookMobileFilters
 * @description Инициализирует мобильный фильтр для архива образов
 */
function initLookMobileFilters() {
    const mobileFiltersContainer = document.querySelector('.catalog__mobile-filters');
    const mobileFiltersBody = document.querySelector('.mobile-filters__body');
    const mobileFiltersTrigger = document.querySelector('.mobile-filters__trigger');
    const mobileFiltersReset = document.querySelector('.mobile-filters__filter-reset');
    const mobileFiltersClose = document.querySelector('.mobile-filters__close-btn');
    const clearFiltersBtn = document.querySelector('.mobile-filters__filter .text-btn');

    if (!mobileFiltersContainer || !mobileFiltersBody) {
        return;
    }

    // Загружаем данные фильтров только если есть элементы фильтров образов
    if (isExist('.catalog__mobile-filters') || isExist('.mobile-filters__body')) {
        loadLookFilterData().then(() => {
            // Восстанавливаем состояние фильтров из URL
            restoreLookFiltersFromUrl();
        }).catch(error => {
            console.error('Error loading look filter data:', error);
        });
    }

    // Обработчик открытия мобильного фильтра
    if (mobileFiltersTrigger) {
        mobileFiltersTrigger.addEventListener('click', function() {
            mobileFiltersContainer.classList.add('active');
            document.body.style.overflow = 'clip';
        });
    }

    // Обработчик закрытия мобильного фильтра
    function closeMobileFilters() {
        mobileFiltersContainer.classList.remove('active');
        document.body.style.overflow = '';
    }

    if (mobileFiltersReset) {
        mobileFiltersReset.addEventListener('click', closeMobileFilters);
    }

    if (mobileFiltersClose) {
        mobileFiltersClose.addEventListener('click', closeMobileFilters);
    }

    // Обработчик аккордеона
    const accordionItems = document.querySelectorAll('.mobile-filters__accordion-item');
    accordionItems.forEach(item => {
        const header = item.querySelector('.mobile-filters__accordion-header');
        if (header) {
            header.addEventListener('click', function() {
                // Закрываем все другие аккордеоны
                accordionItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                    }
                });

                // Переключаем текущий аккордеон
                item.classList.toggle('active');
            });
        }
    });

    // Обработчик сброса фильтров
    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', function() {
            // Сбрасываем все чекбоксы
            const checkboxes = document.querySelectorAll('.mobile-filters__options input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });

            // Очищаем URL параметры фильтров
            clearLookFilterUrlParams();

            // Загружаем все образы без фильтров
            loadFilteredLooks();

            // Закрываем мобильный фильтр
            closeMobileFilters();

        });
    }

    // Восстанавливаем состояние мобильных фильтров из URL
    restoreMobileFilterStates();

}

/**
 * @function loadLookFilterData
 * @description Загружает данные для фильтров образов через AJAX
 */
function loadLookFilterData() {
    
    // Проверяем, не загружены ли уже данные фильтров
    if (window.lookFilterDataLoaded) {
        return Promise.resolve({ success: true, data: window.lookFilterData });
    }

    return fetch(looksAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'get_look_filter_data',
            nonce: looksAjax.filterNonce
        })
    })
    .then(response => {
        return response.json();
    })
    .then(data => {
        if (data.success) {            
            // Заполняем как десктопные, так и мобильные фильтры
            populateFilterSelects(data.data);
            populateLookMobileFilters(data.data);
        } else {
            console.error('❌ Ошибка загрузки данных фильтров образов:', data);
        }
        return data;
    })
    .catch(error => {
        console.error('❌ Ошибка AJAX запроса для фильтров образов:', error);
        console.error('🔍 Детали ошибки:', {
            message: error.message,
            stack: error.stack,
            ajaxurl: typeof looksAjax !== 'undefined' ? looksAjax.ajaxurl : 'undefined'
        });
        throw error;
    });
}

/**
 * @function populateLookMobileFilters
 * @description Заполняет мобильные фильтры данными для образов
 * @param {object} filterData - данные фильтров
 */
function populateLookMobileFilters(filterData) {

    // Сохраняем данные фильтров в глобальную переменную
    window.lookFilterData = filterData;
    window.lookFilterDataLoaded = true;

    // Заполняем мобильные фильтры для образов
    populateMobileFiltersForLooks(filterData);

    // Обновляем счетчики фильтров
    updateLookFilterCounters(filterData);
}

/**
 * @function populateLookMobileFilter
 * @description Заполняет конкретный мобильный фильтр данными
 * @param {string} containerId - ID контейнера
 * @param {Array} items - массив терминов или постов
 * @param {string} label - название фильтра
 */
function populateLookMobileFilter(containerId, items, label) {
    const container = document.getElementById(containerId);
    if (!container) {
        return;
    }


    // Очищаем контейнер
    container.innerHTML = '';

    // Создаем чекбоксы для каждого элемента
    items.forEach(item => {
        const optionItem = document.createElement('div');
        optionItem.className = 'mobile-filters__options-item';

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';

        // Определяем ID и значение в зависимости от типа элемента
        let itemId, itemValue, itemName;

        if (item.slug) {
            // Это термин (цвет)
            itemId = `${containerId}_${item.slug}`;
            itemValue = item.slug;
            itemName = item.name;
        } else if (item.ID) {
            // Это пост (стилист)
            itemId = `${containerId}_${item.ID}`;
            itemValue = item.ID;
            itemName = item.post_title;
        } else {
            console.warn('Unknown item type:', item);
            return;
        }

        checkbox.id = itemId;
        checkbox.name = containerId.replace('mobile_', '').replace('_options', '');
        checkbox.value = itemValue;

        // Добавляем обработчик изменения
        checkbox.addEventListener('change', function() {
            handleLookFilterChange(containerId, this);
        });

        const labelElement = document.createElement('label');
        labelElement.htmlFor = itemId;
        labelElement.textContent = itemName;

        optionItem.appendChild(checkbox);
        optionItem.appendChild(labelElement);
        container.appendChild(optionItem);
    });

}

/**
 * @function handleLookFilterChange
 * @description Обрабатывает изменение фильтра образов
 * @param {string} containerId - ID контейнера
 * @param {HTMLElement} checkbox - измененный чекбокс
 */
function handleLookFilterChange(containerId, checkbox) {
    
    // Защита от выполнения запросов при сбросе фильтров
    if (window.isClearingFilters) {
        return;
    }

    // Собираем все выбранные значения для этого фильтра
    const filterName = containerId.replace('mobile_', '').replace('_options', '');
    const selectedValues = [];

    const checkboxes = document.querySelectorAll(`#${containerId} input[type="checkbox"]:checked`);
    checkboxes.forEach(cb => {
        selectedValues.push(cb.value);
    });


    // Здесь можно добавить логику фильтрации образов
    // Например, обновление URL параметров или AJAX запрос
    updateLookFilters(filterName, selectedValues);
}

/**
 * @function updateLookFilters
 * @description Обновляет фильтры образов
 * @param {string} filterName - название фильтра
 * @param {Array} values - выбранные значения
 */
function updateLookFilters(filterName, values) {
    
    // Защита от выполнения запросов при сбросе фильтров
    if (window.isClearingFilters) {
        return;
    }

    // Преобразуем название фильтра в формат, используемый в десктопном фильтре
    let filterParam = filterName.replace('_filter', '');

    // Добавляем префикс "filter" как в десктопном фильтре
    if (filterParam === 'color') {
        filterParam = 'filterColor';
    } else if (filterParam === 'stylist') {
        filterParam = 'filterStylist';
    } else if (filterParam === 'brand') {
        filterParam = 'filterBrand';
    } else if (filterParam === 'style') {
        filterParam = 'filterStyle';
    } else {
        filterParam = 'filter' + filterParam.charAt(0).toUpperCase() + filterParam.slice(1);
    }


    // Обновляем URL параметры
    const url = new URL(window.location);

    if (values.length > 0) {
        url.searchParams.set(filterParam, values.join(','));
    } else {
        url.searchParams.delete(filterParam);
    }

    // Обновляем URL без перезагрузки страницы
    window.history.replaceState({}, '', url);


    // Выполняем AJAX запрос для фильтрации образов
    loadFilteredLooks();
}

/**
 * @function restoreLookFiltersFromUrl
 * @description Восстанавливает состояние мобильных фильтров из URL параметров
 */
function restoreLookFiltersFromUrl() {

    const urlParams = new URLSearchParams(window.location.search);

    // Проверяем, есть ли категория в URL
    const categoryParam = urlParams.get('category');
    if (!categoryParam) {
        // Если категория не выбрана, делаем "женщины" активной визуально
        // Но только если на странице нет уже активной категории
        const activeCategory = document.querySelector('.catalog__category.active');
        if (!activeCategory) {
            setActiveCategory('zhenshhiny');
        }
    } else {
        // Если есть категория в URL, устанавливаем её как активную
        setActiveCategory(categoryParam);
    }

    // Восстанавливаем фильтр цветов
    const colorParam = urlParams.get('filterColor');
    if (colorParam) {
        const colorValues = colorParam.split(',');
        restoreLookFilterState('mobile_color_filter_options', colorValues);
    }

    // Восстанавливаем фильтр стилистов
    const stylistParam = urlParams.get('filterStylist');
    if (stylistParam) {
        const stylistValues = stylistParam.split(',');
        restoreLookFilterState('mobile_stylist_filter_options', stylistValues);
    }

    // Восстанавливаем фильтр брендов
    const brandParam = urlParams.get('filterBrand');
    if (brandParam) {
        const brandValues = brandParam.split(',');
        restoreLookFilterState('mobile_brand_filter_options', brandValues);
    }

    // Восстанавливаем фильтр стилей
    const styleParam = urlParams.get('filterStyle');
    if (styleParam) {
        const styleValues = styleParam.split(',');
        restoreLookFilterState('mobile_style_filter_options', styleValues);
    }

}

/**
 * @function restoreLookFilterState
 * @description Восстанавливает состояние конкретного мобильного фильтра
 * @param {string} containerId - ID контейнера фильтра
 * @param {Array} values - значения для восстановления
 */
function restoreLookFilterState(containerId, values) {
    const container = document.getElementById(containerId);
    if (!container) {
        return;
    }


    // Отмечаем соответствующие чекбоксы
    values.forEach(value => {
        const checkbox = container.querySelector(`input[value="${value}"]`);
        if (checkbox) {
            checkbox.checked = true;
        } else {
        }
    });
}

/**
 * @function clearLookFilterUrlParams
 * @description Очищает URL параметры фильтров образов
 */
function clearLookFilterUrlParams() {

    const url = new URL(window.location);

    // Удаляем все параметры фильтров, но оставляем категорию
    const filterParams = ['filterColor', 'filterStylist', 'filterBrand', 'filterStyle'];
    filterParams.forEach(param => {
        url.searchParams.delete(param);
    });

    // Если категория не установлена, делаем "женщины" активной визуально
    if (!url.searchParams.has('category')) {
        setActiveCategory('zhenshhiny');
    }

    // Обновляем URL
    window.history.replaceState({}, '', url);

}

/**
 * @function setActiveCategory
 * @description Устанавливает активную категорию визуально
 * @param {string} categorySlug - slug категории
 */
function setActiveCategory(categorySlug) {

    // Убираем активный класс со всех категорий
    document.querySelectorAll('.catalog__category').forEach(category => {
        category.classList.remove('active');
    });

    // Находим и активируем нужную категорию
    const targetCategory = document.querySelector(`[data-termslug="${categorySlug}"]`);
    if (targetCategory) {
        targetCategory.classList.add('active');
    } else {
    }
}

/**
 * @function loadFilteredLooks
 * @description Загружает отфильтрованные образы через AJAX
 */
function loadFilteredLooks() {

    // Показываем прелоадер
    const looksGrid = document.querySelector('.looks-grid');
    if (looksGrid) {
        showLoadingOverlay(looksGrid);
    }

    // Собираем все активные фильтры из URL
    const urlParams = new URLSearchParams(window.location.search);
    const filterData = {};

    // Обрабатываем параметры фильтров
    if (urlParams.has('filterColor')) {
        filterData.color = urlParams.get('filterColor');
    }

    if (urlParams.has('filterStylist')) {
        filterData.stylist = urlParams.get('filterStylist');
    }

    if (urlParams.has('filterBrand')) {
        filterData.brand = urlParams.get('filterBrand');
    }

    if (urlParams.has('filterStyle')) {
        filterData.style = urlParams.get('filterStyle');
    }

    // Обрабатываем категорию образов
    const categoryValue = urlParams.get('category');
    if (categoryValue) {
        filterData.look_category_slug = categoryValue;
        
    } else {
        // Если категория не выбрана, проверяем активную категорию на странице
        const activeCategory = document.querySelector('.catalog__category.active');
        if (activeCategory && activeCategory.dataset.termslug) {
            filterData.look_category_slug = activeCategory.dataset.termslug;
            
        } else {
            // Если нет активной категории, используем "женщины" по умолчанию
            filterData.look_category_slug = 'zhenshhiny';
            
            // Устанавливаем активную категорию после определения параметра
            setActiveCategory('zhenshhiny');
        }
    }

    // Обрабатываем параметр сортировки
    const orderbyValue = urlParams.get('orderby');
    if (orderbyValue && orderbyValue !== 'default') {
        filterData['orderby'] = orderbyValue;
    }
    // Если нет параметра или "default", не добавляем orderby - будет сортировка по умолчанию

    // Подготавливаем данные для запроса
    const requestData = {
        action: 'load_looks',
        nonce: looksAjax.nonce,
        ...filterData
    };
    
    
    

    // Выполняем AJAX запрос
    fetch(looksAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(requestData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            updateLooksContent(data.data);
        } else {
            console.error('Error loading filtered looks:', data);
            showErrorMessage('Ошибка при загрузке отфильтрованных образов');
        }
    })
    .catch(error => {
        console.error('AJAX error loading filtered looks:', error);
        showErrorMessage('Произошла ошибка при загрузке данных');
    })
    .finally(() => {
        // Прелоадер уже скрыт в updateLooksContent или в обработчиках ошибок
        // Обновляем lazyload после загрузки контента
        lazyLoadInstance.update();
        
        // Сбрасываем флаг сброса фильтров после завершения запроса
        if (window.isClearingFilters) {
            window.isClearingFilters = false;
        }
    });
}

/**
 * @function getFilterLabel
 * @description Получает название фильтра по его имени
 * @param {string} filterName - имя фильтра
 * @returns {string} название фильтра
 */
function getFilterLabel(filterName) {
    const labels = {
        'clothing_filter': 'Одежда',
        'shoes_filter': 'Обувь',
        'accessories_filter': 'Аксессуары',
        'product_brand_filter': 'Бренд'
    };
    return labels[filterName] || filterName;
}

/**
 * @function updateFilterActiveState
 * @description Обновляет состояние активности селекта фильтра
 * @param {string} filterName - имя фильтра
 */
function updateFilterActiveState(filterName) {
    const customSelect = document.querySelector(`[data-filter="${filterName}"]`);
    if (!customSelect) return;

    const optionsContainer = customSelect.querySelector('.custom-select__options');
    if (!optionsContainer) return;

    const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');
    const checkedBoxes = isCategoryFilter
        ? optionsContainer.querySelectorAll('input[type="radio"]:checked')
        : optionsContainer.querySelectorAll('input[type="checkbox"]:checked');

    // Добавляем или убираем класс в зависимости от наличия выбранных элементов
    if (checkedBoxes.length > 0) {
        customSelect.classList.add('filtered');
    } else {
        customSelect.classList.remove('filtered');
    }
}

/**
 * @function updateAllFiltersActiveState
 * @description Обновляет состояние активности всех селектов фильтров
 */
function updateAllFiltersActiveState() {
    const filterNames = ['clothing_filter', 'shoes_filter', 'accessories_filter', 'product_brand_filter'];
    filterNames.forEach(filterName => {
        updateFilterActiveState(filterName);
    });
}

/**
 * @function restoreSortingState
 * @description Восстанавливает состояние сортировки из URL
 * @param {string} sortValue - значение сортировки
 */
function restoreSortingState(sortValue) {
    const customSelect = document.querySelector('.custom-select[data-sort="price"]');
    if (!customSelect) return;

    const optionsContainer = customSelect.querySelector('.custom-select__options');
    if (!optionsContainer) return;

    // Если значение не передано или пустое, используем "default"
    if (!sortValue || sortValue === '') {
        sortValue = 'default';
    }

    // Отмечаем соответствующую радиокнопку
    const radio = optionsContainer.querySelector(`input[value="${sortValue}"]`);
    if (radio) {
        radio.checked = true;
    } else {
        // Если радиокнопка не найдена, выбираем "default"
        const defaultRadio = optionsContainer.querySelector('input[value="default"]');
        if (defaultRadio) {
            defaultRadio.checked = true;
        }
    }

    // Обновляем текст триггера
    const valueElement = customSelect.querySelector('.custom-select__value');
    if (valueElement) {
        let sortText = 'По умолчанию';
        if (sortValue === 'price_asc') {
            sortText = 'Сначала дешевле';
        } else if (sortValue === 'price_desc') {
            sortText = 'Сначала дороже';
        }
        valueElement.textContent = sortText;
    }
}

/**
 * @function initProductSorting
 * @description Инициализирует сортировку товаров
 */
function initProductSorting() {
    // Проверяем, что селект существует на странице
    const sortingSelect = document.querySelector('.custom-select[data-sort="price"]');
    if (!sortingSelect) {
        console.warn('⚠️ Селект сортировки не найден на странице, повторная попытка через 200ms');
        // Повторная попытка через 200ms, если селект еще не загружен
        setTimeout(() => {
            const retrySelect = document.querySelector('.custom-select[data-sort="price"]');
            if (retrySelect) {
                initProductSorting();
            } else {
                // Еще одна попытка через 500ms
                setTimeout(() => {
                    const finalRetry = document.querySelector('.custom-select[data-sort="price"]');
                    if (finalRetry) {
                        initProductSorting();
                    }
                }, 500);
            }
        }, 200);
        return;
    }
    
    // Проверяем, не была ли уже инициализирована функция для этого селекта
    if (sortingSelect.dataset.sortingInitialized === 'true') {
        return; // Уже инициализирован
    }
    sortingSelect.dataset.sortingInitialized = 'true';

    const trigger = sortingSelect.querySelector('.custom-select__trigger');
    const dropdown = sortingSelect.querySelector('.custom-select__dropdown');
    const arrow = sortingSelect.querySelector('.custom-select__arrow');

    if (!trigger || !dropdown || !arrow) {
        console.warn('⚠️ Не все элементы селекта сортировки найдены');
        return;
    }

    // Удаляем старые обработчики, если они есть
    if (sortingClickHandler && trigger) {
        trigger.removeEventListener('click', sortingClickHandler, true);
    }
    if (sortingChangeHandler) {
        document.removeEventListener('change', sortingChangeHandler);
    }
    if (sortingOutsideClickHandler) {
        document.removeEventListener('click', sortingOutsideClickHandler);
    }

    // Сбрасываем флаг
    sortingIsOpening = false;

    // Создаем обработчик клика на триггер
    sortingClickHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Останавливаем все последующие обработчики на этом элементе

        // Закрываем все другие селекты
        document.querySelectorAll('.custom-select__dropdown.active').forEach(dd => {
            if (dd !== dropdown) {
                dd.classList.remove('active');
                const otherCustomSelect = dd.closest('.custom-select');
                if (otherCustomSelect) {
                    otherCustomSelect.classList.remove('active');
                    const otherTrigger = otherCustomSelect.querySelector('.custom-select__trigger');
                    const otherArrow = otherCustomSelect.querySelector('.custom-select__arrow');
                    if (otherTrigger) otherTrigger.classList.remove('active');
                    if (otherArrow) otherArrow.style.transform = 'rotate(0deg)';
                }
            }
        });

        // Переключаем текущий селект
        const isActive = dropdown.classList.contains('active');
        if (isActive) {
            dropdown.classList.remove('active');
            sortingSelect.classList.remove('active');
            trigger.classList.remove('active');
            arrow.style.transform = 'rotate(0deg)';
            sortingIsOpening = false;
        } else {
            // Устанавливаем флаг открытия
            sortingIsOpening = true;
            
            // Добавляем классы синхронно
            dropdown.classList.add('active');
            sortingSelect.classList.add('active');
            trigger.classList.add('active');
            arrow.style.transform = 'rotate(180deg)';
            
            // Сбрасываем флаг в следующем тике
            setTimeout(() => {
                sortingIsOpening = false;
            }, 10);
        }
    };
    
    // Добавляем обработчик клика на триггер с capture фазой для приоритета
    trigger.addEventListener('click', sortingClickHandler, true);

    // Обработчик клика по опциям сортировки
    const options = sortingSelect.querySelectorAll('.custom-select__option');
    options.forEach(option => {
        option.addEventListener('click', function(e) {
            e.stopPropagation();
            const radio = option.querySelector('input[type="radio"][name="price_sort"]');
            
            if (radio) {
                radio.checked = true;
                // Триггерим событие change для радиокнопки
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });

    // Обработчик изменения радиокнопок сортировки
    sortingChangeHandler = function(e) {
        if (e.target.name === 'price_sort' && e.target.closest('.custom-select[data-sort="price"]')) {
            const sortValue = e.target.value;
            applyProductSorting(sortValue);
        }
    };
    document.addEventListener('change', sortingChangeHandler);

    // Закрытие селекта при клике вне его
    sortingOutsideClickHandler = function(e) {
        // Пропускаем закрытие, если селект только что открылся
        if (sortingIsOpening) {
            return;
        }
        
        // Проверяем, что клик был вне селекта сортировки
        if (!e.target.closest('.custom-select[data-sort="price"]')) {
            if (dropdown && dropdown.classList.contains('active')) {
                dropdown.classList.remove('active');
                sortingSelect.classList.remove('active');
                trigger.classList.remove('active');
                arrow.style.transform = 'rotate(0deg)';
            }
        }
    };
    document.addEventListener('click', sortingOutsideClickHandler);
}

/**
 * @function applyProductSorting
 * @description Применяет сортировку товаров
 * @param {string} sortValue - значение сортировки
 */
function applyProductSorting(sortValue) {
    // Если выбрано "По умолчанию", удаляем параметр из URL
    if (sortValue === 'default' || !sortValue || sortValue === '') {
        removeProductUrlParameter('orderby');
    } else {
        // Иначе обновляем URL с параметром сортировки
        updateProductUrlParameter('orderby', sortValue);
    }

    // Обновляем текст триггера
    const customSelect = document.querySelector('.custom-select[data-sort="price"]');
    if (customSelect) {
        const valueElement = customSelect.querySelector('.custom-select__value');
        if (valueElement) {
            let sortText = 'По умолчанию';
            if (sortValue === 'price_asc') {
                sortText = 'Сначала дешевле';
            } else if (sortValue === 'price_desc') {
                sortText = 'Сначала дороже';
            }
            valueElement.textContent = sortText;
        }
    }

    // Выполняем AJAX запрос с сортировкой
    performProductAjaxFilter();

    // Закрываем селект сортировки
    if (customSelect) {
        const dropdown = customSelect.querySelector('.custom-select__dropdown');
        const trigger = customSelect.querySelector('.custom-select__trigger');
        const arrow = customSelect.querySelector('.custom-select__arrow');

        dropdown.classList.remove('active');
        customSelect.classList.remove('active');
        trigger.classList.remove('active');
        arrow.style.transform = 'rotate(0deg)';
    }
}

/**
 * @function initInfiniteScroll
 * @description Инициализирует автопрогрузку при прокрутке
 */
function initInfiniteScroll() {
    // Проверяем, есть ли контейнеры для автопрогрузки
    const productsGrid = document.querySelector('.products-grid');
    const looksGrid = document.querySelector('.looks-grid');

    if (!productsGrid && !looksGrid) {
        return;
    }

    // Добавляем обработчик прокрутки с throttling
    let scrollTimeout;
    window.addEventListener('scroll', function() {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }

        scrollTimeout = setTimeout(() => {
            checkInfiniteScroll();
        }, 100); // Throttle scroll events
    });

}

/**
 * @function checkInfiniteScroll
 * @description Проверяет, нужно ли загрузить больше контента при прокрутке
 */
function checkInfiniteScroll() {
    // Проверяем, не выполняется ли уже запрос
    if (isAjaxLoading) {
        return;
    }

    const loadMoreBtn = document.querySelector('.load-more-btn');

    // Проверяем, есть ли еще страницы для загрузки
    if (loadMoreBtn) {
        const currentPage = parseInt(loadMoreBtn.dataset.page) || 2;
        const totalPages = parseInt(loadMoreBtn.dataset.totalPages) || 1;
        
        // Если достигли последней страницы, не загружаем
        if (currentPage > totalPages) {
            return;
        }
    }

    // Проверяем, есть ли еще контент для загрузки
    const productsGrid = document.querySelector('.products-grid');
    const looksGrid = document.querySelector('.looks-grid');

    if (!productsGrid && !looksGrid) {
        return;
    }

    // Проверяем, находимся ли в нижней части страницы
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Загружаем когда пользователь прокрутил на 70% от высоты страницы
    if (scrollTop + windowHeight >= documentHeight * 0.7) {

        // Определяем тип страницы и загружаем соответствующий контент
        if (isExist('.products-grid')) {
            loadMoreProductsInfinite();
        } else if (isExist('.looks-grid')) {
            loadMoreLooksInfinite();
        }
    }
}

/**
 * @function loadMoreProductsInfinite
 * @description Загружает дополнительные товары при автопрогрузке
 */
function loadMoreProductsInfinite() {
    // Проверяем, не выполняется ли уже запрос
    if (isAjaxLoading) {
        return;
    }

    const loadMoreBtn = document.querySelector('.load-more-btn');
    let currentPage = 2;
    let totalPages = 1;
    
    
    // Если кнопка есть, проверяем её состояние
    if (loadMoreBtn) {
        currentPage = parseInt(loadMoreBtn.dataset.page) || 2;
        totalPages = parseInt(loadMoreBtn.dataset.totalPages) || 1;

        if (currentPage > totalPages) return;
    } else {
        // Если кнопки нет (на архивных страницах), используем данные из products-list
        const productsList = document.querySelector('.products-list');
        if (productsList) {
            currentPage = parseInt(productsList.getAttribute('data-current-page')) || 1;
            totalPages = parseInt(productsList.getAttribute('data-pages')) || 1;
            
            if (currentPage >= totalPages) return;
        } else {
            // Если нет ни кнопки, ни products-list, выходим
            return;
        }
    }

    // Устанавливаем флаг загрузки
    isAjaxLoading = true;

    // Собираем все активные фильтры из URL
    const urlParams = new URLSearchParams(window.location.search);
    const filterData = {};

    // Обрабатываем основной параметр категории товара
    const categoryValue = urlParams.get('category');
    if (categoryValue) {
        filterData['product_category_slug'] = categoryValue;
    } else {
        // Если нет параметра категории, определяем активную категорию
        const activeCategory = document.querySelector('.catalog__category.active');
        if (activeCategory && activeCategory.dataset.termslug) {
            filterData['product_category_slug'] = activeCategory.dataset.termslug;
        } else {
            // Fallback на "Женщины" если нет активной категории
            filterData['product_category_slug'] = 'zhenshhiny';
        }
    }

    // Получаем параметры фильтров с префиксом "filter"
    const filterParams = ['filterClothing', 'filterShoes', 'filterAccessories'];
    for (const param of filterParams) {
        const value = urlParams.get(param);
        if (value) {
            const baseParam = param.replace('filter', '').toLowerCase();
            const termSlug = getTermSlugById(value);
            if (termSlug) {
                filterData[baseParam + '_slug'] = termSlug;
            }
        }
    }

    // Обрабатываем параметр бренда
    const brandValue = urlParams.get('filterProduct_brand');
    if (brandValue) {
        const brandSlug = getTermSlugById(brandValue);
        if (brandSlug) {
            filterData['product_brand_slug'] = brandSlug;
        }
    }

    // Обрабатываем параметр сортировки
    const orderbyValue = urlParams.get('orderby');
    if (orderbyValue && orderbyValue !== 'default') {
        filterData['orderby'] = orderbyValue;
    }
    // Если нет параметра или "default", не добавляем orderby - будет сортировка по умолчанию

    // Добавляем номер страницы
    filterData['page'] = currentPage;

    // Получаем ID уже загруженных товаров
    const loadedIds = Array.from(document.querySelectorAll('.product-item')).map(item =>
        item.dataset.id
    ).filter(id => id);

    // Подготавливаем данные для запроса
    const requestData = {
        action: 'load_more_products',
        nonce: productAjax.loadNonce,
        loaded_ids: loadedIds.join(','),
        ...filterData
    };

    
    


    // Выполняем AJAX запрос
    fetch(productAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(requestData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            appendProductsContent(data.data);
            
            // Обновляем состояние кнопки или products-list
            if (loadMoreBtn) {
                updateLoadMoreButton(currentPage + 1, data.data.pages);
            } else {
                // Обновляем данные в products-list для архивных страниц
                const productsList = document.querySelector('.products-list');
                if (productsList) {
                    productsList.setAttribute('data-current-page', currentPage + 1);
                    productsList.setAttribute('data-pages', data.data.pages);
                }
            }

            // Проверяем, нужно ли скрыть кнопку
            setTimeout(() => {
                const totalItems = document.querySelectorAll('.product-item').length;
                const totalAvailable = data.data.total;

                if (totalItems >= totalAvailable) {
                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = 'none';
                    }
                }
            }, 100);
        } else {
            console.error('Error loading more products:', data);
        }
    })
    .catch(error => {
        console.error('Ошибка AJAX запроса для автопрогрузки товаров:', error);
    })
    .finally(() => {
        // Сбрасываем флаг загрузки
        isAjaxLoading = false;
        lazyLoadInstance.update();
    });
}

/**
 * @function loadMoreLooksInfinite
 * @description Загружает дополнительные образы при автопрогрузке
 */
function loadMoreLooksInfinite() {
    // ПОЛНАЯ ПЕРЕПИСЬ: Совершенно новая система автоподгрузки
    
    // Дополнительная защита от множественных вызовов
    if (window.looksLoadingInProgress) {
        console.log('🚫 Автоподгрузка уже выполняется, пропускаем');
        return;
    }
    
    // Проверяем, не выполняется ли уже запрос
    if (isAjaxLoading) {
        console.log('🚫 AJAX уже выполняется, пропускаем');
        return;
    }
    
    isAjaxLoading = true;
    window.looksLoadingInProgress = true;
    
    // Проверяем, определена ли переменная looksAjax
    if (typeof looksAjax === 'undefined') {
        console.error('🚀 NEW AUTOLOAD: looksAjax is not defined!');
        isAjaxLoading = false;
        return;
    }

    // ПОЛНАЯ ПЕРЕПИСЬ: Простая система с проверкой на 77 элементов
    const currentItems = document.querySelectorAll('.look-item');
    
    // Проверяем, не загружены ли уже все элементы
    const looksList = document.querySelector('.looks-list');
    if (looksList) {
        const totalAvailable = parseInt(looksList.dataset.total) || 0;
        if (currentItems.length >= totalAvailable && totalAvailable > 0) {
            console.log('✅ Все элементы уже загружены, останавливаем автоподгрузку');
            isAjaxLoading = false;
            window.looksLoadingInProgress = false;
            return;
        }
    }

    // Собираем все загруженные ID для исключения
    const loadedIds = Array.from(currentItems).map(item => item.dataset.id).filter(id => id);

    // Получаем фильтры из URL
    const filterData = getAllActiveFilters();
    // На мобильной версии загружаем 19 образов, на десктопе - 18
    const postsPerPage = isMobile() ? 19 : 18;
    filterData.page = Math.floor(currentItems.length / postsPerPage) + 1;
    filterData.posts_per_page = postsPerPage;
    filterData.exclude_ids = loadedIds;
    
    console.log('🔍 loadMoreLooksInfinite - активные фильтры:', filterData);
    
    // Добавляем небольшую задержку для предотвращения слишком частых запросов
    setTimeout(() => {
        performInfiniteLoadRequest(filterData);
    }, 100);
}

function performInfiniteLoadRequest(filterData) {

    // Подготавливаем данные для запроса
    const requestData = {
        action: 'load_more_looks',
        nonce: looksAjax.nonce,
        ...filterData
    };
    
    

    // Выполняем AJAX запрос
    fetch(looksAjax.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(requestData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            appendLooksContent(data.data);
            const loadMoreBtn = document.querySelector('.load-more-btn');
            
            // Обновляем кнопку если она существует
            if (loadMoreBtn) {
                let currentPage = parseInt(loadMoreBtn.dataset.page) || 2;
                updateLoadMoreButton(currentPage + 1, data.data.pages);
            }

            // Обновляем атрибуты .looks-list для архивных страниц
            const looksList = document.querySelector('.looks-list');
            if (looksList) {
                let currentPage = parseInt(loadMoreBtn.dataset.page) || 2;
                const newCurrentPage = currentPage + 1;
                looksList.setAttribute('data-current-page', newCurrentPage);
                looksList.setAttribute('data-pages', data.data.pages);
                looksList.setAttribute('data-total', data.data.total);
                
                // Проверяем, загружены ли все образы
                const totalAvailable = parseInt(data.data.total);
                const currentItemsCount = document.querySelectorAll('.look-item').length;
                
                if (currentItemsCount >= totalAvailable) {
                    
                    // Можно добавить логику для остановки автоподгрузки
                }
            } else {
                
            }

            // Проверяем, нужно ли скрыть кнопку
            setTimeout(() => {
                const totalItems = document.querySelectorAll('.look-item').length;
                const totalAvailable = data.data.total;

                if (totalItems >= totalAvailable) {
                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = 'none';
                    }
                }
            }, 100);
        } else {
            console.error('Error loading more looks:', data);
        }
    })
    .catch(error => {
        console.error('Error loading more looks:', error);
    })
    .finally(() => {
        isAjaxLoading = false;
        window.looksLoadingInProgress = false;
        lazyLoadInstance.update();
    });
}


/**
 * @function updateSelectHeader
 * @description Обновляет заголовок селекта с выбранными значениями
 * @param {HTMLElement} customSelect - элемент селекта
 * @param {NodeList} checkedBoxes - выбранные чекбоксы
 * @param {string} filterName - имя фильтра
 */
function updateSelectHeader(customSelect, checkedBoxes, filterName) {
    const valueElement = customSelect.querySelector('.custom-select__value');
    const triggerElement = customSelect.querySelector('.custom-select__trigger');

    if (valueElement && triggerElement) {
        const selectedLabels = Array.from(checkedBoxes).map(cb => {
            const label = cb.nextElementSibling;
            return label ? label.textContent : '';
        });

        if (selectedLabels.length === 1) {
            valueElement.textContent = selectedLabels[0];
        } else {
            valueElement.textContent = `Выбрано: ${selectedLabels.length}`;
        }

        // Добавляем класс для активного фильтра
        triggerElement.classList.add('has-selection');
    }
}

/**
 * @function resetSelectHeader
 * @description Сбрасывает заголовок селекта на дефолтное состояние
 * @param {HTMLElement} customSelect - элемент селекта
 * @param {string} filterName - имя фильтра
 */
function resetSelectHeader(customSelect, filterName) {
    const valueElement = customSelect.querySelector('.custom-select__value');
    const triggerElement = customSelect.querySelector('.custom-select__trigger');


    if (valueElement && triggerElement) {

        // Проверяем, это фильтр образов или товаров
        const isLookFilter = filterName.includes('brand') || filterName.includes('style') || filterName.includes('color') || filterName.includes('stylist');

        if (isLookFilter) {
            // Для фильтров образов НЕ меняем текст - он уже правильный в HTML
        } else {
            // Для товарных фильтров обновляем текст
            const filterLabel = getFilterLabel(filterName);

            // Для фильтров категорий (радиокнопки) не показываем счетчик
            const isCategoryFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories');

            if (isCategoryFilter) {
                valueElement.textContent = filterLabel;
            } else {
                // Для остальных фильтров показываем счетчик
                const optionsContainer = customSelect.querySelector('.custom-select__options');
                const totalOptions = optionsContainer ? optionsContainer.querySelectorAll('.custom-select__option').length : 0;
                valueElement.textContent = `${filterLabel} (${totalOptions})`;
            }
        }

        // Убираем классы для активного фильтра
        triggerElement.classList.remove('has-selection');

        // Убираем класс filtered только для товарных фильтров
        const isProductFilter = filterName.includes('clothing') || filterName.includes('shoes') || filterName.includes('accessories') || filterName.includes('product_brand');
        if (isProductFilter) {
            customSelect.classList.remove('filtered');
        }

    } else {
    }
}

/**
 * @function displayFavoritesItems
 * @description Отображает избранные элементы в виде каталога товаров
 * @param {string} type - тип элементов для отображения ('all', 'look', 'product')
 */
function displayFavoritesItems(type = 'all') {
    const favorites = getFavorites();
    const favoritesGrid = document.querySelector('.favorites-grid');

    if (!favoritesGrid) {
        console.error('Контейнер для избранных элементов не найден');
        return;
    }

    // Показываем спиннер загрузки
    favoritesGrid.classList.add('loading');

    // Очищаем контейнер
    favoritesGrid.innerHTML = '<div class="loading-spinner"></div>';

    if (favorites.length === 0) {
        favoritesGrid.classList.remove('loading');
        favoritesGrid.innerHTML = '<div class="favorites-empty"><p>В избранном пока ничего нет</p></div>';
        return;
    }

    // Фильтруем избранные по типу
    let filteredFavorites = favorites;
    if (type !== 'all') {
        filteredFavorites = favorites.filter(favorite => favorite.startsWith(type + '_'));
    }

    if (filteredFavorites.length === 0) {
        favoritesGrid.classList.remove('loading');
        favoritesGrid.innerHTML = '<div class="favorites-empty"><p>В избранном нет элементов этого типа</p></div>';
        return;
    }

    // Загружаем данные для каждого избранного элемента
    const promises = filteredFavorites.map(favoriteKey => {
        const [postType, postId] = favoriteKey.split('_');
        return fetchFavoritesItemData(postId, postType);
    });

    Promise.all(promises).then(items => {
        // Скрываем спиннер загрузки
        favoritesGrid.classList.remove('loading');

        // Фильтруем только успешно загруженные элементы
        const validItems = items.filter(item => item !== null);

        if (validItems.length === 0) {
            favoritesGrid.innerHTML = '<div class="favorites-empty"><p>Не удалось загрузить избранные элементы</p></div>';
            return;
        }

        // Создаем HTML для каждого элемента
        validItems.forEach(item => {
            const itemElement = createFavoritesItemElement(item);
            favoritesGrid.appendChild(itemElement);
        });

        // Инициализируем кнопки избранного для новых элементов
        initFavoritesButtons();
        lazyLoadInstance.update();
    }).catch(error => {
        // Скрываем спиннер загрузки при ошибке
        favoritesGrid.classList.remove('loading');
        console.error('Ошибка при загрузке избранных элементов:', error);
        favoritesGrid.innerHTML = '<div class="favorites-empty"><p>Ошибка при загрузке избранных элементов</p></div>';
    });
}

/**
 * @function fetchFavoritesItemData
 * @description Загружает данные элемента избранного через AJAX
 * @param {string} postId - ID поста
 * @param {string} postType - тип поста
 * @returns {Promise} Promise с данными элемента
 */
function fetchFavoritesItemData(postId, postType) {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('action', 'get_favorites_item_data');
        formData.append('post_id', postId);
        formData.append('post_type', postType);
        formData.append('nonce', window.ajax_object?.ajax_nonce || '');

        fetch(window.ajax_object?.ajax_url || '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                resolve(data.data);
            } else {
                console.error('Ошибка загрузки данных элемента:', data.data);
                resolve(null);
            }
        })
        .catch(error => {
            console.error('Ошибка AJAX запроса:', error);
            resolve(null);
        });
    });
}

/**
 * @function createFavoritesItemElement
 * @description Создает HTML элемент для избранного товара/образа
 * @param {Object} item - данные элемента
 * @returns {HTMLElement} HTML элемент
 */
function createFavoritesItemElement(item) {
    const element = document.createElement('div');
    element.className = `favorites-item`;
    element.setAttribute('data-id', item.id);
    element.setAttribute('data-type', item.type);

    let html = '';

    if (item.type === 'product') {
        html = `
            <a class="product-item" data-id="${item.id}" data-type="${item.type}" href="${item.url}">
                <div class="product-card">
                    <div class="product-tools">
                        <div class="product-tool tool-favorite isInFavorites" data-id="${item.id}" data-type="${item.type}">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                            </svg>
                        </div>
                    </div>
                    <div class="product-image">
                        ${item.image ? `<img class="lazy" data-src="${item.image}" alt="${item.title}" />` : '<div class="product-placeholder"><span>Нет изображения</span></div>'}
                    </div>
                    <div class="product-content">
                        <div class="product-details">
                            <div class="product-title">
                                <h3>${item.title}</h3>
                            </div>
                            ${item.brand ? `<div class="product-brand">${item.brand}</div>` : ''}
                            ${item.price ? `<div class="product-price">${item.price} ₽</div>` : ''}
                            ${item.excerpt ? `<div class="product-excerpt">${item.excerpt}</div>` : ''}
                        </div>
                    </div>
                </div>
            </a>
        `;
    } else if (item.type === 'look') {
        let mediaContent = '';

        if (item.image && item.media_type === 'video') {
            // Видео с автовоспроизведением
            mediaContent = `
                <video
                    class="lazy" data-src="${item.image}"
                    autoplay
                    muted
                    loop
                    playsinline
                    preload="metadata"
                    webkit-playsinline
                    data-autoplay="true"
                    style="width: 100%; height: 100%; object-fit: cover;"
                >
                    Ваш браузер не поддерживает видео.
                </video>
            `;
        } else if (item.image && item.media_type === 'iframe') {
            // Внешнее видео (YouTube, Vimeo)
            mediaContent = `
                <div class="video-iframe-container" style="width: 100%; height: 100%; position: relative;">
                    ${item.image}
                </div>
            `;
        } else if (item.image) {
            // Обычное изображение
            mediaContent = `<img class="lazy" data-src="${item.image}" alt="${item.title}" />`;
        } else {
            // Заглушка
            mediaContent = '<div class="look-placeholder"><span>Нет изображения</span></div>';
        }

        html = `
            <a class="look-item" data-id="${item.id}" data-type="${item.type}" href="${item.url}">
                <div class="look-map">
                    <div class="look-main-image">
                        <div class="look-tools">
                            <div class="look-tool tool-favorite isInFavorites" data-id="${item.id}" data-type="${item.type}">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                                </svg>
                            </div>
                        </div>
                        ${mediaContent}
                    </div>
                </div>
            </a>
        `;
    }

    element.innerHTML = html;
    return element;
}

/**
 * @function initFavoritesPage
 * @description Инициализирует страницу избранного
 */
function initFavoritesPage() {
    // Инициализируем фильтры
    const filterItems = document.querySelectorAll('.filter-item');

    filterItems.forEach(item => {
        item.addEventListener('click', function() {
            // Убираем активный класс со всех элементов
            filterItems.forEach(filter => filter.classList.remove('active'));

            // Добавляем активный класс к текущему элементу
            this.classList.add('active');

            // Определяем тип фильтра
            let type = 'product'; // По умолчанию товары
            if (this.textContent.includes('Товары')) {
                type = 'product';
            } else if (this.textContent.includes('Готовые образы')) {
                type = 'look';
            } else if (this.textContent.includes('Очистить')) {
                if (confirm('Вы уверены, что хотите очистить все избранное? Это действие нельзя отменить.')) {
                    clearAllFavorites();
                    displayFavoritesItems('product');
                }
                return;
            }

            // Отображаем отфильтрованные элементы
            displayFavoritesItems(type);
        });
    });

    // Устанавливаем активный фильтр по умолчанию (товары)
    const defaultFilter = document.querySelector('.filter-item');
    if (defaultFilter) {
        defaultFilter.classList.add('active');
    }

    // Загружаем товары по умолчанию
    displayFavoritesItems('product');
}

document.addEventListener('DOMContentLoaded', (e) => {
    const blogSlider = document.querySelector('.blog-slider__main');
    if (blogSlider && typeof Swiper !== 'undefined') {
        const blogSwiper = new Swiper('.blog-slider__main', {
            slidesPerView: 2,
            spaceBetween: 6,
            loop: false,
            navigation: {
                nextEl: '.blog-slider__btn--next',
                prevEl: '.blog-slider__btn--prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                991: {
                    slidesPerView: 2,
                }
            },
            on: {
                init: function() {
                    updateBlogSlideCounter(this);
                },
                slideChange: function() {
                    updateBlogSlideCounter(this);
                }
            }
        });
    }
})

/**
 * Обновляет счетчик слайдов блога
 * @param {Object} swiper - объект Swiper
 */
function updateBlogSlideCounter(swiper) {
    // Пробуем разные селекторы для поиска элементов
    let currentSlideEl = document.querySelector('.blog-slide__counter .current-slide');
    let totalSlidesEl = document.querySelector('.blog-slide__counter .total-slides');

    // Если не найдены, пробуем альтернативные селекторы
    if (!currentSlideEl) {
        currentSlideEl = document.querySelector('.current-slide');
    }
    if (!totalSlidesEl) {
        totalSlidesEl = document.querySelector('.total-slides');
    }


    if (currentSlideEl && totalSlidesEl) {
        // Получаем общее количество слайдов
        const totalSlides = swiper.slides.length;

        // Получаем текущий активный слайд (учитываем, что индексация начинается с 0)
        const currentSlide = swiper.activeIndex + 1;

        // Обновляем значения в DOM
        currentSlideEl.textContent = currentSlide;
        totalSlidesEl.textContent = totalSlides;

        // Принудительное обновление через innerHTML
        currentSlideEl.innerHTML = currentSlide;
        totalSlidesEl.innerHTML = totalSlides;

    }
}
function getStylist(){
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('action', 'get_stylist');
        formData.append('nonce', window.ajax_object?.ajax_nonce || '');

        fetch(window.ajax_object?.ajax_url || '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                resolve(data);
            } else {
                console.error('Ошибка загрузки данных элемента:', data.data);
                resolve({ success: false, error: data.data });
            }
        })
        .catch(error => {
            console.error('Ошибка AJAX запроса:', error);
            resolve({ success: false, error: error.message });
        });
    });
}

/**
 * @function setDefaultCategory
 * @description Устанавливает категорию "женщины" по умолчанию без изменения URL
 */
function setDefaultCategory() {
    // Ищем категорию "женщины" по различным возможным slug'ам
    const possibleWomenSlugs = ['women', 'zhenshchiny', 'zhenshiny', 'female', 'women-category'];

    let womenCategory = null;

    // Ищем категорию "женщины" среди доступных категорий
    for (const slug of possibleWomenSlugs) {
        womenCategory = document.querySelector(`[data-termslug="${slug}"]`);
        if (womenCategory) {
            break;
        }
    }

    // Если не нашли по slug, ищем по тексту
    if (!womenCategory) {
        const allCategories = document.querySelectorAll('.catalog__category');
        for (const category of allCategories) {
            const categoryText = category.textContent.toLowerCase().trim();
            if (categoryText.includes('женщин') || categoryText.includes('women') || categoryText.includes('female')) {
                womenCategory = category;
                break;
            }
        }
    }

    if (womenCategory) {
        const categorySlug = womenCategory.dataset.termslug;

        // Активируем категорию визуально
        womenCategory.classList.add('active');

        // Применяем фильтр без изменения URL
        applyDefaultCategoryFilter(categorySlug);
    } else {
    }
}

/**
 * @function applyDefaultCategoryFilter
 * @description Применяет фильтр по умолчанию без изменения URL
 * @param {string} categorySlug - slug категории
 */
function applyDefaultCategoryFilter(categorySlug) {
    // Определяем тип страницы и применяем соответствующий фильтр
    if (isExist('.catalog-list') && isExist('.products-grid')) {
        // Для страниц товаров
        performProductAjaxFilterWithCategory(categorySlug);
    } else {
        // Для страниц образов
        const filterData = getAllActiveFilters();
        filterData.look_category_slug = categorySlug;
        performAjaxFilter(filterData);
    }
}

/**
 * @function performProductAjaxFilterWithCategory
 * @description Выполняет AJAX фильтрацию товаров с категорией без изменения URL
 * @param {string} categorySlug - slug категории
 */
function performProductAjaxFilterWithCategory(categorySlug) {
    // Обновляем URL с категорией
    updateProductUrlParameter('category', categorySlug);

    // Выполняем AJAX запрос (performProductAjaxFilter читает данные из URL)
    performProductAjaxFilter();
}

/**
 * @function populateMobileFiltersForLooks
 * @description Заполняет мобильные фильтры для образов данными
 * @param {object} filterData - данные фильтров
 */
function populateMobileFiltersForLooks(filterData) {

    // Заполняем мобильные фильтры цветов
    if (filterData.colors) {
        populateMobileFilterForLooks('mobile_color_filter_options', filterData.colors, 'Цвет');
    }

    // Заполняем мобильные фильтры стилистов
    if (filterData.stylists) {
        populateMobileFilterForLooks('mobile_stylist_filter_options', filterData.stylists, 'Стилист');
    }
}

/**
 * @function populateMobileFilterForLooks
 * @description Заполняет конкретный мобильный фильтр для образов
 * @param {string} containerId - ID контейнера
 * @param {Array} items - массив терминов
 * @param {string} label - название фильтра
 */
function populateMobileFilterForLooks(containerId, items, label) {

    const optionsContainer = document.getElementById(containerId);

    if (!optionsContainer) {
        console.warn(`Mobile options container with ID ${containerId} not found`);
        return;
    }

    // Очищаем контейнер
    optionsContainer.innerHTML = '';

    // Проверяем, что items является массивом
    if (!items || !Array.isArray(items) || items.length === 0) {
        optionsContainer.innerHTML = '<div class="mobile-filter__option no-options">Нет доступных опций</div>';
        return;
    }

    // Преобразуем данные в нужный формат
    const itemsArray = Array.isArray(items) ? items : [];

    if (itemsArray.length === 0) {
        return;
    }

    // Добавляем новые опции для мобильных фильтров
    itemsArray.forEach(item => {

        const optionDiv = document.createElement('div');
        optionDiv.className = 'mobile-filters__options-item';

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.name = containerId.replace('mobile_', '').replace('_filter_options', '_filter');

        // Используем правильный ID для значения, как в обычных фильтрах
        let desktopOptionId;
        // Формируем ID десктопной опции (как в populateSelect для образов)
        // containerId: mobile_stylist_filter_options -> desktopSelectId: stylist_filter_options
        const desktopSelectId = containerId.replace('mobile_', '');
        
        if (item.term_id) {
            input.value = item.term_id;
            input.id = `${containerId}_${item.term_id}`;
            // ID десктопной опции формируется как в populateSelect: ${selectId}_${item.term_id || item.ID}
            desktopOptionId = `${desktopSelectId}_${item.term_id}`;
        } else if (item.ID) {
            input.value = item.ID;
            input.id = `${containerId}_${item.ID}`;
            // ID десктопной опции для постов (стилистов)
            desktopOptionId = `${desktopSelectId}_${item.ID}`;
        } else {
            input.value = item.slug || item.id;
            input.id = `${containerId}_${item.slug || item.id}`;
            // Fallback для других случаев
            desktopOptionId = `${desktopSelectId}_${item.slug || item.id}`;
        }
        
        // Добавляем data-атрибут с ID десктопной опции
        if (desktopOptionId) {
            optionDiv.setAttribute('data-option-id', desktopOptionId);
        }

        const labelElement = document.createElement('label');
        labelElement.htmlFor = input.id;

        // Исправляем проблему с undefined именами - используем ту же логику, что и в обычных фильтрах
        let itemName;
        if (item.term_id) {
            // Это термин таксономии
            itemName = item.name;
        } else if (item.ID) {
            // Это пост (например, стилист)
            itemName = item.post_title;
        } else {
            // Fallback для других случаев
            itemName = item.name || item.title || item.term_name || 'Без названия';
        }
        labelElement.textContent = itemName;

        optionDiv.appendChild(input);
        optionDiv.appendChild(labelElement);
        optionsContainer.appendChild(optionDiv);

        // Добавляем обработчик изменения для автоматического применения фильтров
        input.addEventListener('change', function() {
            applyMobileFiltersForLooks();
        });
    });

}

/**
 * @function applyMobileFiltersForLooks
 * @description Применяет мобильные фильтры для образов
 */
function applyMobileFiltersForLooks() {

    // Собираем выбранные значения из мобильных фильтров
    const selectedFilters = {};

    // Получаем текущую категорию из URL или активной категории на странице
    const urlParams = new URLSearchParams(window.location.search);
    const categoryParam = urlParams.get('category');
    
    if (categoryParam) {
        selectedFilters.look_category_slug = categoryParam;
    } else {
        // Ищем активную категорию на странице
        const activeCategory = document.querySelector('.catalog__category.active');
        if (activeCategory && activeCategory.dataset.termslug) {
            selectedFilters.look_category_slug = activeCategory.dataset.termslug;
        } else {
            // Если нет активной категории, используем "женщины" по умолчанию
            selectedFilters.look_category_slug = 'zhenshhiny';
        }
    }

    // Собираем выбранные цвета
    const selectedColors = [];
    document.querySelectorAll('#mobile_color_filter_options input:checked').forEach(checkbox => {
        selectedColors.push(checkbox.value);
    });
    if (selectedColors.length > 0) {
        selectedFilters.color = selectedColors;
    }

    // Собираем выбранных стилистов
    const selectedStylists = [];
    document.querySelectorAll('#mobile_stylist_filter_options input:checked').forEach(checkbox => {
        selectedStylists.push(checkbox.value);
    });
    if (selectedStylists.length > 0) {
        selectedFilters.stylist = selectedStylists;
    }

    // Обновляем URL с выбранными фильтрами
    updateUrlWithMobileFilters(selectedFilters);

    // Применяем фильтры
    if (Object.keys(selectedFilters).length > 0) {
        performAjaxFilter(selectedFilters);
    } else {
        // Если ничего не выбрано, показываем все
        performAjaxFilter({});
    }
}

/**
 * @function updateUrlWithMobileFilters
 * @description Обновляет URL с параметрами мобильных фильтров
 * @param {object} filterData - данные фильтров
 */
function updateUrlWithMobileFilters(filterData) {
    const url = new URL(window.location);
    
    // Очищаем существующие параметры фильтров
    url.searchParams.delete('filterColor');
    url.searchParams.delete('filterStylist');
    
    // Добавляем новые параметры фильтров
    if (filterData.color && filterData.color.length > 0) {
        url.searchParams.set('filterColor', filterData.color.join(','));
    }
    
    if (filterData.stylist && filterData.stylist.length > 0) {
        url.searchParams.set('filterStylist', filterData.stylist.join(','));
    }
    
    // Обновляем URL без перезагрузки страницы
    window.history.pushState({}, '', url);
}

/**
 * @function restoreMobileFilterStates
 * @description Восстанавливает состояние мобильных фильтров из URL
 */
function restoreMobileFilterStates() {
    
    
    // Получаем параметры из URL
    const urlParams = new URLSearchParams(window.location.search);
    
    // Восстанавливаем фильтр по цветам
    const colorValue = urlParams.get('filterColor');
    if (colorValue) {
        const colorValues = colorValue.split(',');
        colorValues.forEach(value => {
            const checkbox = document.querySelector(`#mobile_color_filter_options input[value="${value}"]`);
            if (checkbox) {
                checkbox.checked = true;
            }
        });
    }
    
    // Восстанавливаем фильтр по стилистам
    const stylistValue = urlParams.get('filterStylist');
    if (stylistValue) {
        const stylistValues = stylistValue.split(',');
        stylistValues.forEach(value => {
            const checkbox = document.querySelector(`#mobile_stylist_filter_options input[value="${value}"]`);
            if (checkbox) {
                checkbox.checked = true;
            }
        });
    }
    
    
}

// Функция для управления автовоспроизведением видео в слайдерах
function initVideoAutoplay() {
    // Находим все слайдеры с видео
    const mainSliders = document.querySelectorAll('.product-main-slider');

    mainSliders.forEach(slider => {
        const swiper = slider.swiper;
        if (swiper) {
            // Функция для запуска видео на активном слайде
            function playActiveVideo() {
                // Останавливаем все видео в слайдере
                const allVideos = slider.querySelectorAll('.swiper-video');
                allVideos.forEach(video => {
                    video.pause();
                    video.currentTime = 0;
                });

                // Запускаем видео на активном слайде
                const activeSlide = slider.querySelector('.swiper-slide-active');
                if (activeSlide) {
                    const activeVideo = activeSlide.querySelector('.swiper-video');
                    if (activeVideo) {
                        // Небольшая задержка для плавного перехода
                        setTimeout(() => {
                            activeVideo.play().catch(e => {
                            });
                        }, 300);
                    }
                }
            }

            // Обработчик изменения слайда (стрелки, свайп)
            swiper.on('slideChange', playActiveVideo);

            // Обработчик инициализации слайдера
            swiper.on('init', function() {
                // Запускаем видео на первом слайде, если это видео
                const firstSlide = slider.querySelector('.swiper-slide-active');
                if (firstSlide) {
                    const firstVideo = firstSlide.querySelector('.swiper-video');
                    if (firstVideo) {
                        setTimeout(() => {
                            firstVideo.play().catch(e => {
                            });
                        }, 500);
                    }
                }
            });
        }

        // Обработчик кликов по миниатюрам
        const thumbsSlider = slider.closest('.product-info__slider')?.querySelector('.product-thumbs-slider');
        if (thumbsSlider) {
            const thumbsSwiper = thumbsSlider.swiper;
            if (thumbsSwiper) {
                // Обработчик изменения слайда в миниатюрах
                thumbsSwiper.on('slideChange', function() {
                    // Небольшая задержка, чтобы основной слайдер успел переключиться
                    setTimeout(playActiveVideo, 100);
                });
            }

            // Обработчик кликов по слайдам миниатюр
            const thumbSlides = thumbsSlider.querySelectorAll('.swiper-slide');
            thumbSlides.forEach((thumbSlide, index) => {
                thumbSlide.addEventListener('click', function() {
                    // Переключаем основной слайдер на соответствующий слайд
                    if (swiper) {
                        swiper.slideTo(index);
                        // Запускаем видео после переключения
                        setTimeout(playActiveVideo, 200);
                    }
                });
            });
        }
    });
}

/**
 * @function showLoadingOverlay
 * @description Показывает прелоадер для списков
 */
function showLoadingOverlay(container) {
    if (!container) return;

    // Создаем прелоадер если его нет
    let overlay = container.querySelector('.loading-overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'loading-overlay';
        overlay.innerHTML = `
            <div class="loading-spinner"></div>
            <div class="loading-text">Загрузка...</div>
        `;
        container.style.position = 'relative';
        container.appendChild(overlay);
    }

    // Показываем прелоадер
    overlay.classList.add('active');
}

/**
 * @function initSimpleAutoLoadForLooks
 * @description Простая инициализация автоподгрузки для страниц образов
 */
function initSimpleAutoLoadForLooks() {
    
    // Проверяем, что мы НЕ на главной странице
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
    const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                         document.body.classList.contains('tax-product_category') ||
                         document.body.classList.contains('post-type-archive-look') ||
                         document.body.classList.contains('tax-look_category') ||
                         window.location.pathname.includes('/catalog') ||
                         window.location.pathname.includes('/looks');
    
    // НЕ инициализируем автоподгрузку на главной странице (не архивной)
    if (isHomePage && !isArchivePage) {
        return;
    }
    
    // Проверяем, что мы на странице образов
    if (!isExist('.looks-grid')) {
        console.log('❌ initSimpleAutoLoadForLooks: блок .looks-grid не найден');
        return;
    }
    
    // Проверяем, не инициализирована ли уже автоподгрузка
    if (window.simpleAutoLoadInitialized) {
        console.log('⚠️ initSimpleAutoLoadForLooks: уже инициализирована');
        return;
    }

    // console.log('🚀 initSimpleAutoLoadForLooks: начинаем инициализацию');
    window.simpleAutoLoadInitialized = true;
    
    // Добавляем обработчик прокрутки для автоподгрузки
    let isLoading = false;
    let lastScrollTime = 0;
    
    const handleScroll = () => {
        const now = Date.now();
        if (now - lastScrollTime < 100) return; // Throttle scroll events
        lastScrollTime = now;
        
        if (isLoading) {
            return;
        }
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        
        // Находим блок образов для более точного определения момента загрузки
        const looksGrid = document.querySelector('.looks-grid');
        if (looksGrid) {
            const looksGridRect = looksGrid.getBoundingClientRect();
            const looksGridBottom = looksGridRect.bottom;
            
            // Загружаем когда до конца блока образов остается 10% от высоты экрана
            const triggerPoint = windowHeight * 0.1;
            
            // Отладочная информация (отключена)
            // console.log('🔍 Отладка предзагрузки:', {
            //     looksGridBottom: Math.round(looksGridBottom),
            //     triggerPoint: Math.round(triggerPoint),
            //     windowHeight: Math.round(windowHeight),
            //     shouldLoad: looksGridBottom <= triggerPoint
            // });
            
            if (looksGridBottom <= triggerPoint) {
                // console.log('🚀 Очень ранняя предзагрузка: до конца блока образов остается', Math.round(looksGridBottom), 'px');
                
                isLoading = true;
                
                // Для страниц образов всегда используем loadMoreLooksInfinite
                if (typeof loadMoreLooksInfinite === 'function') {
                    loadMoreLooksInfinite();
                    isLoading = false;
                } else {
                    console.error('initSimpleAutoLoadForLooks: loadMoreLooksInfinite function not found');
                    isLoading = false;
                }
            }
        } else {
            // Fallback на старую логику если блок образов не найден
            const documentHeight = document.documentElement.scrollHeight;
            if (scrollTop + windowHeight >= documentHeight * 0.7) {
                isLoading = true;
                
                if (typeof loadMoreLooksInfinite === 'function') {
                    loadMoreLooksInfinite();
                    isLoading = false;
                } else {
                    console.error('initSimpleAutoLoadForLooks: loadMoreLooksInfinite function not found');
                    isLoading = false;
                }
            }
        }
    };
    
    // Добавляем обработчик прокрутки
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // console.log('✅ initSimpleAutoLoadForLooks: обработчик скролла добавлен');
}

/**
 * @function initAutoLoadForLooks
 * @description Инициализирует автоподгрузку специально для страниц образов
 */
function initAutoLoadForLooks() {
    
    // Проверяем, что мы НЕ на главной странице
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.php';
    const isArchivePage = document.body.classList.contains('post-type-archive-product') ||
                         document.body.classList.contains('tax-product_category') ||
                         document.body.classList.contains('post-type-archive-look') ||
                         document.body.classList.contains('tax-look_category') ||
                         window.location.pathname.includes('/catalog') ||
                         window.location.pathname.includes('/looks');
    
    // НЕ инициализируем автоподгрузку на главной странице (не архивной)
    if (isHomePage && !isArchivePage) {
        return;
    }
    
    // Проверяем, что мы на странице образов
    if (!isExist('.looks-grid')) {
        
        return;
    }
    
    // Проверяем, не инициализирована ли уже автоподгрузка
    if (window.looksAutoLoadInitialized) {
        
        return;
    }

    
    window.looksAutoLoadInitialized = true;
    
    // Добавляем обработчик прокрутки для автоподгрузки
    let isLoading = false;
    let lastScrollTime = 0;
    
    const handleScroll = () => {
        const now = Date.now();
        if (now - lastScrollTime < 100) return; // Throttle scroll events
        lastScrollTime = now;
        
        if (isLoading) {
            return;
        }
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        
        // Находим блок образов для более точного определения момента загрузки
        const looksGrid = document.querySelector('.looks-grid');
        if (looksGrid) {
            const looksGridRect = looksGrid.getBoundingClientRect();
            const looksGridBottom = looksGridRect.bottom;
            
            // Загружаем когда до конца блока образов остается 10% от высоты экрана
            const triggerPoint = windowHeight * 0.1;
            
            if (looksGridBottom <= triggerPoint) {
                console.log('🚀 Ранняя предзагрузка (initAutoLoadForLooks): до конца блока образов остается', Math.round(looksGridBottom), 'px');
                
                isLoading = true;
                
                // Для страниц образов всегда используем loadMoreLooksInfinite
                if (typeof loadMoreLooksInfinite === 'function') {
                    loadMoreLooksInfinite();
                    isLoading = false;
                } else {
                    isLoading = false;
                }
            }
        } else {
            // Fallback на старую логику если блок образов не найден
            const documentHeight = document.documentElement.scrollHeight;
            if (scrollTop + windowHeight >= documentHeight * 0.7) {
                isLoading = true;
                
                if (typeof loadMoreLooksInfinite === 'function') {
                    loadMoreLooksInfinite();
                    isLoading = false;
                } else {
                    isLoading = false;
                }
            }
        }
    };
    
    // Добавляем обработчик прокрутки
    window.addEventListener('scroll', handleScroll, { passive: true });
    
}

/**
 * @function initAutoLoadForCategory
 * @description Инициализирует автоподгрузку для страниц категорий
 */
function initAutoLoadForCategory() {
    
    
    // Проверяем, не инициализирована ли уже автоподгрузка
    if (window.categoryAutoLoadInitialized) {
        
        return;
    }
    
    // Добавляем обработчик прокрутки для автоподгрузки
    let isLoading = false;
    let lastScrollTime = 0;
    
    const handleScroll = () => {
        const now = Date.now();
        if (now - lastScrollTime < 100) return; // Throttle scroll events
        lastScrollTime = now;
        
        
        
        if (isLoading) {
            
            return;
        }
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        
        // Добавляем дополнительное логирование для отладки
        if (scrollTop + windowHeight >= documentHeight * 0.7) {
            
        }
        
        // Загружаем новые элементы когда пользователь прокрутил на 70% страницы
        if (scrollTop + windowHeight >= documentHeight * 0.7) {
            
            isLoading = true;
            
            // Определяем тип страницы и используем соответствующую функцию
            if (isExist('.products-grid')) {
                // Для страниц товаров
                
                if (typeof loadMoreProductsInfinite === 'function') {
                    loadMoreProductsInfinite();
                    isLoading = false;
                } else {
                    isLoading = false;
                }
            } else if (isExist('.looks-grid')) {
                // Для страниц образов
                
                if (typeof loadMoreLooksInfinite === 'function') {
                    loadMoreLooksInfinite();
                    isLoading = false;
                } else {
                    isLoading = false;
                }
            } else {
                isLoading = false;
            }
        }
    };
    
    // Добавляем обработчик прокрутки
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    
    // Устанавливаем флаг ПОСЛЕ добавления обработчика
    
    window.categoryAutoLoadInitialized = true;
}

/**
 * @function hideLoadingOverlay
 * @description Скрывает прелоадер для списков
 */
function hideLoadingOverlay(container) {
    
    if (!container) {
        
        return;
    }

    const overlay = container.querySelector('.loading-overlay');
    
    if (overlay) {
        
        overlay.classList.remove('active');
        
    } else {
        
    }
}

/**
 * @function restoreFilterStates
 * @description Восстанавливает состояние фильтров после обновления контента
 */
function restoreFilterStates() {
    
    
    // Получаем параметры из URL
    const urlParams = new URLSearchParams(window.location.search);
    
    // Список фильтров для восстановления
    const filterNames = ['brand', 'style', 'color', 'stylist'];
    
    let restoredCount = 0;
    
    filterNames.forEach(filterName => {
        const filterValue = urlParams.get(`filter${filterName.charAt(0).toUpperCase() + filterName.slice(1)}`);
        
        if (filterValue) {
            
            
            // Находим соответствующий селект
            const customSelect = document.querySelector(`[data-filter="${filterName}_filter"]`);
            if (customSelect) {
                const valueElement = customSelect.querySelector('.custom-select__value');
                const triggerElement = customSelect.querySelector('.custom-select__trigger');
                
                if (valueElement && triggerElement) {
                    // Определяем название фильтра
                    const labelMap = {
                        'brand': 'Бренд',
                        'style': 'Стиль',
                        'color': 'Цвет',
                        'stylist': 'Стилист'
                    };
                    
                    // Разбиваем значения (могут быть через запятую)
                    const values = filterValue.split(',');
                    
                    if (values.length === 1) {
                        // Для одного значения показываем название фильтра с количеством
                        valueElement.textContent = `${labelMap[filterName]} (1)`;
                    } else {
                        // Для нескольких значений показываем количество
                        valueElement.textContent = `${labelMap[filterName]} (${values.length})`;
                    }
                    
                    // Добавляем класс для активного фильтра
                    triggerElement.classList.add('has-selection');
                    
                    restoredCount++;
                    
                } else {
                    
                    // Если элементы не найдены, пробуем еще раз через 200мс
                    setTimeout(() => {
                        restoreFilterStates();
                    }, 200);
                    return;
                }
            } else {
                
                // Если селект не найден, пробуем еще раз через 200мс
                setTimeout(() => {
                    restoreFilterStates();
                }, 200);
                return;
            }
        }
    });
    
    
    
    // Восстанавливаем состояние мобильных фильтров
    restoreMobileFilterStates();
}

// Инициализируем автовоспроизведение видео после загрузки DOM
document.addEventListener('DOMContentLoaded', function() {
    // Ждем немного, чтобы слайдеры успели инициализироваться
    setTimeout(initVideoAutoplay, 1000);
});

// ИСПРАВЛЕНИЕ: Явно экспортируем функции в глобальную область
window.initAutoLoadForLooks = initAutoLoadForLooks;
window.initSimpleAutoLoadForLooks = initSimpleAutoLoadForLooks;
window.loadMoreLooksInfinite = loadMoreLooksInfinite;